import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.clusters.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-clusters-item',
template: templateSource || '',
    styles: [``],
})
export class PageKieraClustersItemComponent implements OnInit, OnDestroy {
    public item: any = null;
    public id: number = 0;
    public tab: string = 'summary';
    public summaryEditing: boolean = false;
    public summaryPrefixForm: any = { relay_prefix: '', compute_prefix: '' };
    public clusterActivities: any[] = [];
    public clusterActivityLogs: any[] = [];
    public clusterActivityLoading: boolean = false;
    public clusterActivityPage: number = 1;
    public clusterActivityDump: number = 25;
    public clusterActivityTotal: number = 0;
    public clusterActivitySearch: string = '';
    public clusterActivityStatus: string = 'all';
    public templatePreviewVisible: boolean = false;
    public templatePreviewTab: string = 'info';
    public templateViewerLoading: boolean = false;
    public templateViewer: any = null;
    public templateViewerMessage: string = '';
    public tabs: any[] = [
        { key: 'summary', label: 'Summary', icon: 'bx bx-info-circle' },
        { key: 'nodes', label: 'Nodes', icon: 'bx bx-server' },
        { key: 'ssh-keys', label: 'SSH', icon: 'bx bx-key' },
        { key: 'network', label: 'Network', icon: 'bx bx-network-chart' },
        { key: 'scripts', label: 'Scripts', icon: 'bx bx-code-alt' },
        { key: 'relay', label: 'Relay', icon: 'bx bx-sitemap' },
        { key: 'storage', label: 'Storage', icon: 'bx bx-hdd' },
        { key: 'zabbix', label: 'Zabbix', icon: 'bx bx-bar-chart-alt-2' },
        { key: 'log', label: 'Log', icon: 'bx bx-history' },
    ];
    private routerSub: Subscription;

    // Nodes tab
    public clusterNodes: any[] = [];
    public availableNodes: any[] = [];
    public nodeSearch: any = { text: '', role: '', dhcp_role: '', assigned_relay_id: '', status: '', power_status: '', rack_key: '' };
    public availableNodeSearch: any = { text: '', page: 1, dump: 5, total: 0 };
    public readonly availableNodePageWindowSize: number = 5;
    public readonly availableNodeFetchDump: number = 100;
    public availableNodeFetchPage: number = 1;
    public availableNodesLoading: boolean = false;
    public showAddNodesModal: boolean = false;
    public selectedNodeIds: Set<number> = new Set();
    public selectedClusterNodeIds: Set<number> = new Set();
    public selectedAction: string = 'power-on';
    public actionRunning: boolean = false;
    public actionMessage: string = '';
    public clusterActionResult: any = null;
    public nodeTableRefreshing: boolean = false;
    public exportingClusterTemplate: boolean = false;
    public editingClusterNode: any = null;
    public editingClusterNodeForm: any = null;
    public editingClusterNodeSaving: boolean = false;
    public clusterNodeEditMessage: string = '';
    public clusterNodeTreeCollapsed: any = {};
    public showClusterNodeBulkEditModal: boolean = false;
    public clusterNodeBulkEditForm: any = null;
    public clusterNodeBulkEditSaving: boolean = false;
    public clusterNodeBulkEditMessage: string = '';
    public sshKeyCopyRunning: boolean = false;
    public sshKeyCopyMessage: string = '';
    public sshKeyCopyResult: any = null;
    public clusterSshKey: any = null;
    public nodeMappingMessage: string = '';
    public nodeMappingBusy: boolean = false;
    public nodeMappingAvailableRole: string = '';
    public readonly nodeMappingPageSize: number = 5;
    public nodeMappingMemberSearch: any = { text: '', role: '', page: 1, dump: 5 };
    public nodeMappingPendingAddRows: any[] = [];
    public nodeMappingPendingRemoveIds: Set<number> = new Set();
    public nodeMappingManualForm: any = { template_key: '', node_id: '' };
    public nodeMappingTemplateImporting: boolean = false;
    public actionOptions: any[] = [
        { label: 'Power On', value: 'power-on' },
        { label: 'Power Off', value: 'power-off' },
        { label: 'Power Cycle', value: 'power-cycle' },
        { label: 'Power Soft Off', value: 'power-soft' },
        { label: 'UEFI PXE Boot', value: 'bootdev-pxe' },
        { label: 'Legacy PXE Boot', value: 'bootdev-pxe-legacy' },
        { label: 'Default Boot', value: 'bootdev-none' },
        { label: 'Commission', value: 'commission' },
        { label: 'Release', value: 'release' },
        { label: 'Get Power Status', value: 'get-power' },
        { label: 'Get Boot Device', value: 'get-bootdev' },
    ];
    public readonly clusterNodeRoleFilterOptions: any[] = [
        { value: 'relay', label: 'Relay' },
        { value: 'compute', label: 'Compute' },
    ];
    public readonly clusterNodeDhcpRoleFilterOptions: any[] = [
        { value: 'authority', label: 'Authority' },
        { value: 'member', label: 'Next Server' },
        { value: 'client', label: 'Client' },
    ];
    public readonly clusterNodePowerFilterOptions: any[] = [
        { value: 'on', label: 'On' },
        { value: 'off', label: 'Off' },
        { value: 'unknown', label: 'Unknown' },
    ];

    // Zabbix tab
    public zabbixServerIp: string = '';
    public zabbixSshUser: string = 'root';
    public zabbixSshPassword: string = 'kiera123';
    public zabbixProxyNodeId: any = '';
    public zabbixProxyName: string = '';
    public zabbixRunning: boolean = false;
    public zabbixMessage: string = '';
    public zabbixResult: any = null;
    private zabbixConfigLoaded: boolean = false;

    // Network tab
    public networkRows: any[] = [];
    public networkSearch: any = { text: '', node: '', role: '', interface: '', state: '' };
    public selectedNetworkIds: Set<number> = new Set();
    public networkFiltersVisible: boolean = true;
    public networkRefreshing: boolean = false;
    public exportingNetworkCsv: boolean = false;
    public showNetworkBulkModal: boolean = false;
    public networkBulkSaving: boolean = false;
    public networkBulkMessage: string = '';
    public networkBulkForm: any = { network_mode: 'static', start_ip: '', mask_bits: 24, gateway: '' };
    public networkModeOptions: Array<{ value: string; label: string; }> = [
        { value: 'static', label: 'Static' },
        { value: 'dhcp', label: 'DHCP' },
        { value: 'unconfigured', label: 'Unconfigured' },
    ];

    // Scripts tab
    public scriptRows: any[] = [];
    public scriptOptions: any[] = [];
    public bulkScript: any = { pre_script_id: '', post_script_id: '' };
    public scriptMessage: string = '';

    // Relay tab
    public relayImages: any[] = [];
    public relayForm: any = { relay_image_id: '', computing_image_id: '' };
    public relayWindowGapSeconds: any = 3;
    public relayWindowSize: any = 50;
    public relayName: string = '';
    public relayCreatedId: string = '';
    public relayLoading: boolean = false;
    public relayMessage: string = '';
    public relayDeployingHead: boolean = false;
    public relayHeadDeploySubmitted: boolean = false;
    public relayHeadDeployStartedAt: string = '';
    public relayHeadDeployCompletedAt: string = '';
    public relayDeploymentStatus: any = {};
    public relayPreflightLoading: boolean = false;
    public relayPreflightReport: any = null;
    public relayPreflightCollapsed: any = {};
    public relayAllowOverride: boolean = false;
    public relayDeployStarted: boolean = false;
    public relayDeployCompleted: boolean = false;
    public relayDeployStarting: boolean = false;
    public relayDeployStats: any = { total: 0, deployed: 0, in_progress: 0, failed: 0 };
    public relayNodeDeployStatus: any = {};
    public relayOrchestrationJobId: string = '';
    public relayOrchestrationJob: any = null;
    public relayOrchestrationLogVisible: boolean = false;
    public relayOrchestrationLogLoading: boolean = false;
    public relayOrchestrationLogTitle: string = '';
    public relayOrchestrationLogFilename: string = '';
    public relayOrchestrationLogContent: string = '';
    public relayOrchestrationLogMessage: string = '';
    public relayOrchestrationLogMeta: any = null;
    public relayOrchestrationLogTab: string = 'script';
    public relayOrchestrationIntegratedLogs: any[] = [];
    public relayOrchestrationNodeLogs: any[] = [];
    public relayOrchestrationSelectedNodeLog: any = null;
    public relayOrchestrationFailureSummary: any = null;
    public relayOrchestrationFailureActionMessage: string = '';
    public relayOrchestrationRecoveryRunning: boolean = false;
    public relayOrchestrationRerunRunning: boolean = false;
    public relayOrchestrationStopRunning: boolean = false;
    public relayOrchestrationControlRunning: boolean = false;
    public relayPoweringOn: boolean = false;
    public relayPoweringOff: boolean = false;
    public relayConfigSaving: boolean = false;
    public relaySubnets: any[] = [];
    public relayView: string = 'overview';
    public relayDeployTarget: any = null;
    public relayGroupSearch: string = '';
    public relayGroupPage: number = 1;
    public relayGroupPageSize: number = 10;
    public relayGroupSelectedKeys: Set<string> = new Set();
    public relayDomainMetadata: any = {};
    public relayGroupFormMode: string = 'add';
    public relayGroupForm: any = {};
    public relayGroupFormMessage: string = '';
    public relayAssignmentGroupKey: string = '';
    public relayAssignmentAuthorityId: string = '';
    public relayAssignmentMemberIds: any = {};
    public relayAssignmentMessage: string = '';
    public clusterRelayDhcpOptions: any[] = [
        { value: '', label: '-' },
        { value: 'authority', label: 'Authority' },
        { value: 'member', label: 'member' },
    ];
    public clusterNodeRelayRoleOptions: any[] = [
        { value: '', label: 'computenode' },
        { value: 'authority', label: 'Authority' },
        { value: 'member', label: 'member' },
    ];
    private relayHeadPoller: any = null;
    private relayJobPoller: any = null;
    private relayOrchestrationLogPoller: any = null;
    private relayHeadPowerCheckTimer: any = null;
    private readonly relayHeadPowerCheckDelayMs: number = 4000;
    private readonly relayShortDurationThresholdSeconds: number = 3;
    private readonly relayDefaultWindowGapSeconds: number = 3;
    private readonly relayDefaultWindowSize: number = 50;
    private readonly relayMaxWindowGapSeconds: number = 600;
    private readonly relayMaxWindowSize: number = 1000;
    private relaySignature: string = '';
    private relayConfigAutoSaveRunning: boolean = false;
    private relayConfigAutoSaveQueued: boolean = false;
    private relayConfigAutoSaveMessage: string = 'Relay config saved.';
    private summaryConfigCacheRaw: any = null;
    private summaryConfigCache: any = null;

    // Storage tab
    public storageList: any[] = [];
    public editingStorage: any = null;
    public storageTypes: string[] = ['nfs', 'cifs', 'glusterfs', 'ceph', 'local', 'lustre'];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( TranslateService)  private translate: TranslateService) { }

    public isTabDisabled(tab: string): boolean {
        if (String(tab || '').trim() === 'node-mapping') return true;
        return !!this.tabs.find((item: any) => item.key === tab && item.disabled);
    }

    private normalizedTab(tab: string): string {
        const requested = String(tab || 'summary').trim() || 'summary';
        if (requested === 'relay-group') return 'relay';
        if (requested === 'logs') return 'log';
        if (this.isTabDisabled(requested)) return 'nodes';
        return this.tabs.some((item: any) => item.key === requested) ? requested : 'summary';
    }

    public async ngOnInit() {
        await this.service.init();
        if (this.canManageResourceUsers() && !this.tabs.some((t: any) => t.key === 'users')) this.tabs.push({ key: 'users', label: this.translate.instant('resource_access.users_tab'), icon: 'bx bx-user-check' });
        this.id = WizRoute.segment.id;
        const requestedTab = WizRoute.segment.tab || 'summary';
        this.tab = this.normalizedTab(requestedTab);
        if (this.tab !== requestedTab) this.service.href(`/kiera/clusters/${this.id}/${this.tab}`);
        await this.load();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const requestedNextTab = WizRoute.segment.tab || 'summary';
                const newTab = this.normalizedTab(requestedNextTab);
                if (newTab !== requestedNextTab) {
                    this.service.href(`/kiera/clusters/${this.id}/${newTab}`);
                    return;
                }
                if (newTab !== this.tab) {
                    this.tab = newTab;
                    await this.loadTabData();
                    await this.service.render();
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.relayHeadPoller) clearInterval(this.relayHeadPoller);
        if (this.relayJobPoller) clearInterval(this.relayJobPoller);
        this.stopRelayOrchestrationLogPoll();
        if (this.relayHeadPowerCheckTimer) clearTimeout(this.relayHeadPowerCheckTimer);
    }

    public async load() {
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href('/kiera/clusters');
            return;
        }
        this.item = data;
        await this.loadTabData();
        await this.service.render();
    }

    private async loadTabData() {
        if (this.isTabDisabled(this.tab)) {
            this.tab = 'nodes';
            this.service.href(`/kiera/clusters/${this.id}/nodes`);
            return;
        }
        if (this.tab === 'summary') {
            await this.loadSummaryData();
        } else if (this.tab === 'nodes') {
            await this.loadRelaySubnets();
            await this.loadNodes();
        } else if (this.tab === 'node-mapping') {
            await this.loadRelaySubnets();
            await this.loadNodes();
            await this.loadAvailableNodes(1, false);
        } else if (this.tab === 'ssh-keys') {
            await this.loadNodes();
            await this.loadClusterSshKey();
        } else if (this.tab === 'zabbix') {
            await this.loadClusterZabbixConfig();
        } else if (this.tab === 'network') {
            await this.loadNetworks();
        } else if (this.tab === 'scripts') {
            await this.loadScriptConfigs();
        } else if (this.tab === 'relay') {
            await this.loadRelaySubnets();
            await this.loadRelay();
        } else if (this.tab === 'storage') {
            await this.loadStorages();
        } else if (this.tab === 'log') {
            await this.loadClusterActivityLogs(1);
        }
    }

    public selectTab(tab: string) {
        if (this.isTabDisabled(tab)) return;
        this.service.href(`/kiera/clusters/${this.id}/${tab}`);
    }

    public async save() {
        if (this.summaryEditing) this.applySummaryPrefixForm();
        const { code } = await wiz.call("update", { id: this.id, data: JSON.stringify(this.item) });
        if (code === 200) {
            this.summaryEditing = false;
            alert(this.translate.instant('page.nodes.item.saved'));
            await this.load();
        }
    }

    public async deleteCluster() {
        if (!confirm(this.translate.instant('page.clusters.item.confirm_delete'))) return;
        const { code } = await wiz.call("delete", { id: this.id });
        if (code === 200) this.service.href('/kiera/clusters');
    }

    // =========================================================================
    // Summary
    // =========================================================================

    public async loadSummaryData() {
        await this.loadRelaySubnets();
        await this.loadNodes();
        await this.loadClusterActivities();
    }

    public async loadClusterActivities() {
        const { code, data } = await wiz.call("recent_activities", { id: this.id, dump: 6 });
        this.clusterActivities = code === 200 ? (data?.rows || []) : [];
    }

    public async loadClusterActivityLogs(page: number = this.clusterActivityPage) {
        this.clusterActivityLoading = true;
        this.clusterActivityPage = Math.max(1, Number(page || 1));
        await this.service.render();
        try {
            const { code, data } = await wiz.call("recent_activities", {
                id: this.id,
                page: this.clusterActivityPage,
                dump: this.clusterActivityDump,
                status: this.clusterActivityStatus,
                text: this.clusterActivitySearch,
            });
            if (code === 200) {
                this.clusterActivityLogs = data?.rows || [];
                this.clusterActivityTotal = Number(data?.total || this.clusterActivityLogs.length || 0);
                this.clusterActivityPage = Number(data?.page || this.clusterActivityPage || 1);
                this.clusterActivityDump = Number(data?.dump || this.clusterActivityDump || 25);
            } else {
                this.clusterActivityLogs = [];
                this.clusterActivityTotal = 0;
            }
        } catch (e) {
            this.clusterActivityLogs = [];
            this.clusterActivityTotal = 0;
        }
        this.clusterActivityLoading = false;
        await this.service.render();
    }

    public async applyClusterActivityFilters() {
        await this.loadClusterActivityLogs(1);
    }

    public clusterActivityTotalPages(): number {
        return Math.max(1, Math.ceil(Number(this.clusterActivityTotal || 0) / Number(this.clusterActivityDump || 25)));
    }

    public clusterActivityActor(activity: any): string {
        return String(activity?.actor_name || activity?.actor_email || activity?.actor_id || '-');
    }

    public clusterActivityStatusClass(status: string): string {
        const value = String(status || '').trim();
        if (value === 'success') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (value === 'failed') return 'bg-red-50 text-red-700 border-red-200';
        if (value === 'partial_failed' || value === 'review-needed') return 'bg-amber-50 text-amber-700 border-amber-200';
        return 'bg-zinc-50 text-zinc-600 border-zinc-200';
    }

    public clusterActivityDetailText(activity: any): string {
        const detail = this.summaryActivityDetail(activity);
        const keys = Object.keys(detail || {});
        if (keys.length === 0) return '';
        try {
            return JSON.stringify(detail);
        } catch (e) {
            return String(activity?.detail || '');
        }
    }

    public clusterActivitySourceText(activity: any): string {
        return String(activity?.source_path || activity?.target_id || '');
    }

    public async toggleSummaryEditing() {
        if (!this.summaryEditing) {
            this.resetSummaryPrefixForm();
            this.summaryEditing = true;
            await this.service.render();
            return;
        }
        await this.save();
    }

    public async cancelSummaryEdit() {
        this.summaryEditing = false;
        await this.load();
    }

    private summaryConfigObject(): any {
        const raw = this.item?.config || '';
        if (raw === this.summaryConfigCacheRaw && this.summaryConfigCache) {
            return this.summaryConfigCache;
        }

        let config: any = {};
        if (raw && typeof raw === 'object') {
            config = { ...raw };
        } else {
            try {
                const parsed = JSON.parse(String(raw || '{}'));
                config = parsed && typeof parsed === 'object' ? parsed : {};
            } catch (e) {
                config = {};
            }
        }

        this.summaryConfigCacheRaw = raw;
        this.summaryConfigCache = config;
        return config;
    }

    private setSummaryConfigObject(config: any) {
        const nextConfig = config && typeof config === 'object' ? config : {};
        this.item.config = JSON.stringify(nextConfig);
        this.summaryConfigCacheRaw = this.item.config;
        this.summaryConfigCache = nextConfig;
    }

    private summaryNestedValue(source: any, path: string): any {
        let current = source || {};
        for (const part of String(path || '').split('.')) {
            if (!part || current === null || current === undefined || typeof current !== 'object') return '';
            current = current[part];
        }
        return current;
    }

    private summaryConfigValue(keys: string[], fallback: any = ''): any {
        const config = this.summaryConfigObject();
        for (const key of keys || []) {
            const value = this.summaryNestedValue(config, key);
            if (value !== undefined && value !== null && String(value).trim() !== '') return value;
        }
        return fallback;
    }

    public clusterCreationMode(): string {
        const mode = String(this.summaryConfigValue(['creation_mode', 'create_mode'], '') || '').trim().toLowerCase();
        if (mode === 'template' || mode === 'template_based') return 'template';
        if (mode === 'manual') return 'manual';
        if (this.summaryTemplateFileName() || this.summaryConfigValue(['template_preview'], null)) return 'template';
        return 'manual';
    }

    public isTemplateCluster(): boolean {
        return this.clusterCreationMode() === 'template';
    }

    public clusterCreationModeLabel(): string {
        return this.isTemplateCluster() ? 'Template-based Cluster' : 'Manual Cluster';
    }

    public clusterCreationModeShortLabel(): string {
        return this.isTemplateCluster() ? 'Template' : 'Manual';
    }

    public clusterCreationModeBadgeClass(): string {
        return this.isTemplateCluster()
            ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'
            : 'bg-zinc-100 text-zinc-700 ring-1 ring-zinc-200';
    }

    public summaryFormatNumber(value: any): string {
        const numberValue = Number(value || 0);
        return Number.isFinite(numberValue) ? numberValue.toLocaleString() : '0';
    }

    public summaryProvisioningMode(): string {
        const configured = String(this.summaryConfigValue(['provisioning_mode', 'provisioning.mode'], '') || '').trim().toLowerCase();
        if (configured.includes('direct')) return 'direct';
        if (configured.includes('relay')) return 'relay';
        if (this.item?.relay_group) return 'relay';
        return this.summaryRelayCount() > 0 ? 'relay' : 'direct';
    }

    public summaryProvisioningModeLabel(): string {
        return this.summaryProvisioningMode() === 'relay' ? 'Relay Based' : 'Direct';
    }

    public summaryRelayPrefix(): string {
        return String(this.summaryConfigValue(['relay_prefix', 'prefix.relay'], '') || '').trim() || '-';
    }

    public summaryComputePrefix(): string {
        return String(this.summaryConfigValue(['compute_prefix', 'cluster_prefix', 'prefix.compute'], this.item?.prefix || '') || '').trim() || '-';
    }

    public summaryTemplateVersion(): string {
        const version = this.summaryConfigValue(['template_version', 'template.version'], '');
        const file = this.summaryConfigValue(['template_file', 'template.file'], '');
        return String(version || file || '-');
    }

    public summaryTemplateFileName(): string {
        return String(this.summaryConfigValue(['template_file', 'template.file', 'template_preview.file.name'], '') || '').trim();
    }

    public summaryTemplateUploadedAt(): string {
        return String(this.summaryConfigValue(['template_uploaded', 'template.uploaded', 'template_preview.file.uploaded'], '') || '').trim();
    }

    private summaryCleanPrefixValue(value: any): string {
        const text = String(value || '').trim();
        return text === '-' ? '' : text;
    }

    private resetSummaryPrefixForm() {
        this.summaryPrefixForm = {
            relay_prefix: this.summaryCleanPrefixValue(this.summaryRelayPrefix()),
            compute_prefix: this.summaryCleanPrefixValue(this.summaryComputePrefix()),
        };
    }

    private applySummaryPrefixForm() {
        if (!this.item) return;
        const config = { ...this.summaryConfigObject() };
        const relayPrefix = String(this.summaryPrefixForm.relay_prefix || '').trim();
        const computePrefix = String(this.summaryPrefixForm.compute_prefix || '').trim();
        config.relay_prefix = relayPrefix;
        config.compute_prefix = computePrefix;
        config.cluster_prefix = computePrefix;
        this.item.prefix = computePrefix;
        this.setSummaryConfigObject(config);
    }

    public openTemplatePreview() {
        this.templatePreviewVisible = true;
        this.templatePreviewTab = 'info';
        this.templateViewer = null;
        this.templateViewerMessage = '';
        this.service.render();
    }

    public closeTemplatePreview() {
        this.templatePreviewVisible = false;
        this.service.render();
    }

    public async selectTemplatePreviewTab(tab: string) {
        const nextTab = String(tab || '').trim() === 'viewer' ? 'viewer' : 'info';
        this.templatePreviewTab = nextTab;
        if (nextTab === 'viewer') {
            await this.loadTemplateViewer();
            return;
        }
        await this.service.render();
    }

    public async loadTemplateViewer(force: boolean = false) {
        if (this.templateViewerLoading) return;
        if (!force && (this.templateViewer || this.templateViewerMessage)) {
            await this.service.render();
            return;
        }
        this.templateViewerLoading = true;
        this.templateViewerMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("template_file_viewer", { id: this.id });
            if (code === 200) {
                this.templateViewer = data?.viewer || null;
                if (data?.available === false || this.templateViewer?.available === false) {
                    this.templateViewerMessage = data?.message || this.templateViewer?.message || '템플릿 원본 파일을 열 수 없습니다.';
                } else if (this.templateViewerSheets().length === 0) {
                    this.templateViewerMessage = '표시할 시트 데이터가 없습니다.';
                }
            } else {
                this.templateViewer = null;
                this.templateViewerMessage = data?.message || '템플릿 원본 파일을 열지 못했습니다.';
            }
        } catch (e) {
            this.templateViewer = null;
            this.templateViewerMessage = '템플릿 원본 파일을 열지 못했습니다.';
        } finally {
            this.templateViewerLoading = false;
            await this.service.render();
        }
    }

    public async refreshTemplateViewer() {
        this.templateViewer = null;
        this.templateViewerMessage = '';
        await this.loadTemplateViewer(true);
    }

    public templateViewerSheets(): any[] {
        return Array.isArray(this.templateViewer?.sheets) ? this.templateViewer.sheets : [];
    }

    public templateViewerFileName(): string {
        return String(this.templateViewer?.file?.name || this.summaryTemplateFileName() || '-');
    }

    public templateViewerFileMeta(): string {
        const file = this.templateViewer?.file || {};
        const size = this.formatSize(Number(file.size || 0));
        const uploaded = String(file.uploaded || '').trim();
        const parts = [size];
        if (uploaded) parts.push(`Uploaded ${uploaded}`);
        return parts.filter((item: string) => item && item !== '-').join(' · ') || '-';
    }

    public templateViewerCellValue(value: any): string {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            return this.templateViewerCellValue(value.value);
        }
        if (value === null || value === undefined) return '';
        return String(value);
    }

    public templateViewerRowCells(row: any): any[] {
        if (Array.isArray(row)) return row;
        if (row && Array.isArray(row.cells)) return row.cells;
        return [];
    }

    public templateViewerCellStyle(cell: any): any {
        if (!cell || typeof cell !== 'object' || Array.isArray(cell)) return {};
        const style = cell.style && typeof cell.style === 'object' ? cell.style : {};
        const result: any = {};
        const backgroundColor = this.templateViewerSafeColor(style.backgroundColor);
        const color = this.templateViewerSafeColor(style.color);
        const borderColor = this.templateViewerSafeColor(style.borderColor);
        if (backgroundColor) result.backgroundColor = backgroundColor;
        if (color) result.color = color;
        if (borderColor) result.borderColor = borderColor;
        if (style.bold === true || style.fontWeight === '600' || style.fontWeight === '700') result.fontWeight = '600';
        if (['left', 'center', 'right'].includes(String(style.textAlign || ''))) result.textAlign = style.textAlign;
        const rawWidth = Number(cell.width || 0);
        if (rawWidth > 0) {
            const width = Math.max(72, Math.min(rawWidth, 360));
            result.minWidth = `${width}px`;
            result.maxWidth = `${Math.max(width, 140)}px`;
        }
        return result;
    }

    public templateViewerCellClass(cell: any): any {
        const style = cell && typeof cell === 'object' && !Array.isArray(cell) ? (cell.style || {}) : {};
        return {
            'font-semibold': style.bold === true,
            'text-white': String(style.color || '').toUpperCase() === '#FFFFFF',
        };
    }

    public templateViewerSafeColor(value: any): string {
        const text = String(value || '').trim();
        return /^#[0-9A-Fa-f]{6}$/.test(text) ? text.toUpperCase() : '';
    }

    public summaryTemplatePreview(): any {
        const configured = this.summaryConfigValue(['template_preview'], {});
        const preview = configured && typeof configured === 'object' ? configured : {};
        const file = preview.file && typeof preview.file === 'object' ? preview.file : {};
        const cluster = preview.cluster && typeof preview.cluster === 'object' ? preview.cluster : {};
        const summary = preview.summary && typeof preview.summary === 'object' ? preview.summary : {};
        const mapping = this.summaryMappingConfig();
        return {
            ...preview,
            file: {
                ...file,
                name: file.name || this.summaryTemplateFileName() || '-',
                uploaded: file.uploaded || this.summaryTemplateUploadedAt() || '-',
            },
            cluster: {
                ...cluster,
                name: cluster.name || this.item?.name || '-',
                description: cluster.description || this.item?.description || '-',
                provisioning_mode: cluster.provisioning_mode || this.summaryProvisioningModeLabel(),
                relay_prefix: cluster.relay_prefix || this.summaryRelayPrefix(),
                compute_prefix: cluster.compute_prefix || this.summaryComputePrefix(),
                nodes_per_rack: cluster.nodes_per_rack || this.summaryRackUnit(),
                template_version: cluster.template_version || this.summaryConfigValue(['template_version', 'template.version'], '-'),
            },
            summary: {
                ...summary,
                total_nodes: summary.total_nodes ?? mapping.total ?? this.summaryNodeCount(),
                relay_count: summary.relay_count ?? mapping.relay ?? this.summaryRelayCount(),
                compute_count: summary.compute_count ?? Math.max(0, this.summaryComputeCount()),
                warnings: summary.warnings ?? 0,
                errors: summary.errors ?? mapping.failed ?? 0,
            },
            metrics: Array.isArray(preview.metrics) ? preview.metrics : [],
            details: Array.isArray(preview.details) ? preview.details : [],
            nodes: Array.isArray(preview.nodes) ? preview.nodes : [],
        };
    }

    public summaryTemplatePreviewClusterRows(): any[] {
        const cluster = this.summaryTemplatePreview().cluster || {};
        return [
            { label: 'Cluster Name', value: cluster.name || '-' },
            { label: 'Description', value: cluster.description || '-' },
            { label: 'Provisioning Mode', value: cluster.provisioning_mode || '-' },
            { label: 'Relay Prefix', value: cluster.relay_prefix || '-' },
            { label: 'Compute Prefix', value: cluster.compute_prefix || '-' },
            { label: 'Nodes per Rack', value: cluster.nodes_per_rack || '-' },
            { label: 'Template Version', value: cluster.template_version || '-' },
        ];
    }

    public summaryTemplatePreviewCards(): any[] {
        const summary = this.summaryTemplatePreview().summary || {};
        return [
            { label: 'Total Nodes', value: this.summaryFormatNumber(summary.total_nodes), className: 'text-blue-700' },
            { label: 'Relay', value: this.summaryFormatNumber(summary.relay_count), className: 'text-cyan-700' },
            { label: 'Compute', value: this.summaryFormatNumber(summary.compute_count), className: 'text-emerald-700' },
            { label: 'Warnings', value: this.summaryFormatNumber(summary.warnings), className: 'text-amber-700' },
            { label: 'Errors', value: this.summaryFormatNumber(summary.errors), className: 'text-red-700' },
        ];
    }

    public summaryTemplatePreviewNodes(): any[] {
        return (this.summaryTemplatePreview().nodes || []).slice(0, 50);
    }

    public summaryTemplatePreviewHasOriginalRows(): boolean {
        return this.summaryTemplatePreviewNodes().length > 0;
    }

    public summaryStatusLabel(value: any): string {
        const status = String(value || '').trim().toLowerCase();
        if (status === 'active') return 'Active';
        if (status === 'inactive') return 'Inactive';
        if (status === 'maintenance') return 'Maintenance';
        return status ? status.charAt(0).toUpperCase() + status.slice(1) : '-';
    }

    public summaryStatusBadgeClass(value: any): string {
        const status = String(value || '').trim().toLowerCase();
        if (status === 'active') return 'rounded bg-green-100 px-2 py-1 text-[11px] font-semibold text-green-700';
        if (status === 'maintenance') return 'rounded bg-amber-100 px-2 py-1 text-[11px] font-semibold text-amber-700';
        if (status === 'inactive') return 'rounded bg-zinc-100 px-2 py-1 text-[11px] font-semibold text-zinc-600';
        return 'rounded bg-zinc-100 px-2 py-1 text-[11px] font-semibold text-zinc-600';
    }

    public summaryClusterInfoRows(): any[] {
        return [
            { label: 'Cluster Name', value: this.item?.name || '-' },
            { label: 'Description', value: this.item?.description || '-' },
            { label: 'Cluster Group', value: this.item?.group_name || '-' },
            {
                label: 'Provisioning Mode',
                value: this.summaryProvisioningModeLabel(),
                badgeClass: 'rounded bg-indigo-100 px-2 py-1 text-[11px] font-semibold text-indigo-700',
            },
            { label: 'Relay Prefix', value: this.summaryRelayPrefix() },
            { label: 'Compute Prefix', value: this.summaryComputePrefix() },
            { label: 'Nodes per Rack', value: this.summaryFormatNumber(this.summaryRackUnit()) },
            {
                label: 'Status',
                value: this.summaryStatusLabel(this.item?.status),
                badgeClass: this.summaryStatusBadgeClass(this.item?.status),
            },
        ];
    }

    public summaryNodeCount(): number {
        return (this.clusterNodes || []).length || Number(this.item?.count || 0);
    }

    public summaryRelayNodes(): any[] {
        return this.clusterRelayCandidateServerNodes();
    }

    private summaryMappingConfig(): any {
        const mapping = this.summaryConfigValue(['mapping_summary'], {});
        return mapping && typeof mapping === 'object' ? mapping : {};
    }

    public summaryRelayCount(): number {
        const relayNodes = this.summaryRelayNodes();
        if (relayNodes.length > 0) return relayNodes.length;
        return Number(this.summaryMappingConfig().relay || 0);
    }

    public summaryComputeNodes(): any[] {
        return (this.clusterNodes || []).filter((node: any) => !this.isClusterRelayServer(node));
    }

    public summaryComputeCount(): number {
        const loaded = this.summaryComputeNodes().length;
        if (loaded > 0) return loaded;
        return Math.max(0, this.summaryNodeCount() - this.summaryRelayCount());
    }

    public summaryRackUnit(): number {
        const configured = this.summaryConfigValue(['nodes_per_rack', 'rack_unit'], this.item?.rack_unit || 1);
        const value = Number(configured || 1);
        return Number.isFinite(value) && value > 0 ? Math.floor(value) : 1;
    }

    public summaryRackCount(): number {
        const racks = new Set<string>();
        for (const node of this.clusterNodes || []) {
            const rack = String(node?.rack || '').trim();
            if (rack) racks.add(rack);
        }
        if (racks.size > 0) return racks.size;

        const mappingRackCount = Number(this.summaryMappingConfig().rack_count || 0);
        if (mappingRackCount > 0) return mappingRackCount;
        return Math.max(1, Math.ceil(this.summaryNodeCount() / this.summaryRackUnit()));
    }

    public summaryProvisioningDomainCount(): number {
        const domains = new Set<string>();
        for (const node of this.clusterRelayAuthorityNodes()) {
            const key = this.clusterRelayDhcpGroupKey(node);
            if (key) domains.add(key);
        }
        if (domains.size > 0) return domains.size;

        const configured = Number(this.summaryConfigValue(['provisioning_domains', 'relay_groups', 'domain_count'], 0) || 0);
        if (configured > 0) return configured;
        return this.summaryProvisioningMode() === 'relay' ? (this.relaySubnets || []).length : 0;
    }

    private summaryNodeReady(node: any): boolean {
        const values = [
            String(node?.status || '').trim().toLowerCase(),
            String(node?.deploy_status || '').trim().toLowerCase(),
        ];
        return values.some((value: string) => ['ready', 'relay-ready', 'deployed', 'active', 'commissioned'].includes(value));
    }

    public summaryRelayReadyCount(): number {
        return this.summaryRelayNodes().filter((node: any) => this.summaryNodeReady(node)).length;
    }

    public summaryComputeReadyCount(): number {
        return this.summaryComputeNodes().filter((node: any) => this.summaryNodeReady(node)).length;
    }

    public summaryAutoCommissionCount(): number {
        return Number(this.summaryMappingConfig().compute_auto || 0);
    }

    public summaryOverviewCards(): any[] {
        return [
            {
                label: 'Nodes',
                value: this.summaryFormatNumber(this.summaryNodeCount()),
                icon: 'bx bx-group',
                boxClass: 'border-blue-100 bg-blue-50',
                textClass: 'text-blue-700',
            },
            {
                label: 'Relay',
                value: this.summaryFormatNumber(this.summaryRelayCount()),
                icon: 'bx bx-server',
                boxClass: 'border-cyan-100 bg-cyan-50',
                textClass: 'text-cyan-700',
            },
            {
                label: 'Compute',
                value: this.summaryFormatNumber(this.summaryComputeCount()),
                icon: 'bx bx-desktop',
                boxClass: 'border-emerald-100 bg-emerald-50',
                textClass: 'text-emerald-700',
            },
            {
                label: 'Rack',
                value: this.summaryFormatNumber(this.summaryRackCount()),
                icon: 'bx bx-grid-alt',
                boxClass: 'border-violet-100 bg-violet-50',
                textClass: 'text-violet-700',
            },
            {
                label: 'Provisioning Domains',
                value: this.summaryFormatNumber(this.summaryProvisioningDomainCount()),
                icon: 'bx bx-globe',
                boxClass: 'border-orange-100 bg-orange-50',
                textClass: 'text-orange-700',
            },
        ];
    }

    public summaryMainDeploymentCidr(): string {
        const configured = this.summaryConfigValue([
            'main_deployment',
            'main_deployment_cidr',
            'deployment_cidr',
            'provisioning_network',
            'network.main_deployment',
        ], '');
        if (configured) return String(configured);
        const subnet = (this.relaySubnets || []).find((row: any) => String(row?.cidr || '').trim());
        if (subnet?.cidr) return String(subnet.cidr);
        const node = (this.clusterNodes || []).find((row: any) => String(row?.ip_address || '').trim());
        const ip = String(node?.ip_address || '').trim();
        const parts = ip.split('.');
        if (parts.length === 4) return `${parts[0]}.${parts[1]}.${parts[2]}.0/24`;
        return '-';
    }

    public summaryRootFsLabel(): string {
        const iface = String(this.summaryConfigValue(['rootfs_interface', 'rootfs_distribution.interface', 'rootfs.interface'], '') || '').trim();
        const cidr = String(this.summaryConfigValue(['rootfs_cidr', 'rootfs_distribution.cidr', 'rootfs.cidr'], '') || '').trim();
        const distribution = String(this.summaryConfigValue(['rootfs_distribution', 'rootfs'], '') || '').trim();
        if (iface && cidr) return `${iface} ${cidr}`;
        if (iface) return iface;
        if (distribution && !distribution.startsWith('[object')) return distribution;
        return '-';
    }

    public summaryNetworkDomainRows(): any[] {
        return [
            { label: 'Relay', value: this.summaryFormatNumber(this.summaryRelayCount()) },
            { label: 'Compute', value: this.summaryFormatNumber(this.summaryComputeCount()) },
        ];
    }

    private summaryDeployedCount(nodes: any[]): number {
        return (nodes || []).filter((node: any) => this.isNodeDeployed(node)).length;
    }

    private summaryStateClass(status: string): string {
        const normalized = String(status || '').toLowerCase();
        if (normalized === 'completed' || normalized === 'applied' || normalized === 'key ready') return 'bg-green-100 text-green-700';
        if (normalized === 'partial' || normalized === 'in progress') return 'bg-amber-100 text-amber-700';
        if (normalized === 'failed') return 'bg-red-100 text-red-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    private summaryDeployState(total: number, completed: number): string {
        if (total <= 0) return 'Not Deployed';
        if (completed >= total) return 'Completed';
        if (completed > 0) return 'Partial';
        return 'Not Deployed';
    }

    public summaryDeploymentStatuses(): any[] {
        const relayNodes = this.summaryRelayNodes();
        const computeNodes = this.summaryComputeNodes();
        const relayStatus = this.summaryDeployState(this.summaryRelayCount(), this.summaryDeployedCount(relayNodes));
        const computeStatus = this.summaryDeployState(this.summaryComputeCount(), this.summaryDeployedCount(computeNodes));
        const sshSummary = this.sshKeyCopyResult?.summary || {};
        const sshStatus = Number(sshSummary.success || 0) > 0 && Number(sshSummary.failed || 0) === 0 && Number(sshSummary.pending_deploy || 0) === 0
            ? 'Applied'
            : 'Not Applied';
        const configuredScripts = (this.scriptRows || []).filter((row: any) => Number(row.pre_script_id || 0) > 0 || Number(row.post_script_id || 0) > 0).length;
        const scriptStatus = configuredScripts > 0 ? 'Applied' : 'Not Applied';

        return [
            { label: 'Relay', status: relayStatus, className: this.summaryStateClass(relayStatus) },
            { label: 'Compute', status: computeStatus, className: this.summaryStateClass(computeStatus) },
            { label: 'SSH Bootstrap', status: sshStatus, className: this.summaryStateClass(sshStatus) },
            { label: 'Scripts', status: scriptStatus, className: this.summaryStateClass(scriptStatus) },
        ];
    }

    private summaryNodeMappingValues(): any {
        const mapping = this.summaryMappingConfig();
        const relayTotal = Number(mapping.relay || this.summaryRelayCount());
        const auto = Number(mapping.compute_auto || 0);
        const computePreTotal = Number(mapping.compute_pre || Math.max(0, this.summaryComputeCount() - auto));
        const matchedTotal = Number(mapping.matched || (relayTotal + computePreTotal));
        const relayMatched = Math.min(relayTotal, matchedTotal);
        const computeMatched = Math.min(computePreTotal, Math.max(0, matchedTotal - relayMatched));
        return { relayTotal, relayMatched, computePreTotal, computeMatched, auto };
    }

    public summaryNodeMappingCards(): any[] {
        const mapping = this.summaryNodeMappingValues();
        return [
            {
                label: 'Relay',
                value: `${this.summaryFormatNumber(mapping.relayMatched)} / ${this.summaryFormatNumber(mapping.relayTotal)}`,
                sub: 'Matched',
                className: 'text-emerald-600',
            },
            {
                label: 'Compute',
                value: `${this.summaryFormatNumber(mapping.computeMatched)} / ${this.summaryFormatNumber(mapping.computePreTotal)}`,
                sub: 'Matched',
                className: 'text-emerald-600',
            },
            {
                label: 'Auto Commission',
                value: this.summaryFormatNumber(mapping.auto),
                sub: 'DB registration',
                className: 'text-blue-600',
            },
        ];
    }

    public summaryMatchedByLabel(): string {
        return String(this.summaryConfigValue(['matched_by', 'mapping.matched_by'], '') || '').trim() || 'BMC MAC';
    }

    private summaryActivityDetail(activity: any): any {
        const detail = activity?.detail;
        if (!detail) return {};
        if (typeof detail === 'object') return detail;
        try {
            const parsed = JSON.parse(String(detail || '{}'));
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    public summaryActivityMessage(activity: any): string {
        if (activity?.message) return activity.message;
        const action = String(activity?.action || '').trim();
        const detail = this.summaryActivityDetail(activity);
        const labels: any = {
            create: 'Cluster created',
            update: 'Cluster updated',
            delete: 'Cluster deleted',
            add_nodes: 'Nodes added',
            remove_nodes: 'Nodes removed',
            action: 'Cluster action requested',
            cluster_ssh_key_register: 'SSH bootstrap requested',
            deploy: 'Deployment requested',
            cluster_network_bulk_apply: 'Network configuration updated',
            script_save: 'Script configuration saved',
            script_bulk_apply: 'Script configuration bulk applied',
            storage_save: 'Storage configuration saved',
            storage_delete: 'Storage configuration deleted',
            cluster_zabbix_install_proxy: 'Zabbix proxy installation requested',
            cluster_zabbix_assign_proxy: 'Zabbix proxy assignment requested',
        };
        const base = labels[action] || action || 'Activity';
        const clusterName = detail.cluster_name ? ` · ${detail.cluster_name}` : '';
        return `${base}${clusterName}`;
    }

    public openRackView() {
        if (this.item?.group_id) {
            this.service.href(`/kiera/groups/${this.item.group_id}`);
            return;
        }
        this.service.href('/kiera/groups');
    }

    // =========================================================================
    // Nodes 관리
    // =========================================================================

    public async loadNodes() {
        const { code, data } = await wiz.call("nodes", { id: this.id });
        if (code === 200) {
            this.clusterNodes = data || [];
            this.applyClusterRelayConfig();
            const validIds = new Set(this.clusterNodes.map((node: any) => Number(node.id)));
            Array.from(this.selectedClusterNodeIds).forEach((nodeId: number) => {
                if (!validIds.has(nodeId)) this.selectedClusterNodeIds.delete(nodeId);
            });
        }
    }

    public async loadRelaySubnets() {
        const { code, data } = await wiz.call("relay_subnets", { id: this.id });
        if (code === 200) {
            this.relaySubnets = data?.rows || [];
        }
    }

    public async refreshNodeTable() {
        if (this.nodeTableRefreshing) return;
        this.nodeTableRefreshing = true;
        await this.service.render();
        try {
            await this.loadNodes();
        } finally {
            this.nodeTableRefreshing = false;
            await this.service.render();
        }
    }

    public async openAddNodes() {
        this.availableNodeSearch = { text: '', page: 1, dump: this.nodeMappingPageSize, total: 0 };
        this.nodeMappingAvailableRole = '';
        this.nodeMappingMemberSearch = { text: '', role: '', page: 1, dump: this.nodeMappingPageSize };
        this.nodeMappingMessage = '';
        this.nodeMappingBusy = false;
        this.nodeMappingPendingAddRows = [];
        this.nodeMappingPendingRemoveIds = new Set();
        this.availableNodes = [];
        this.selectedNodeIds = new Set();
        this.selectedClusterNodeIds = new Set();
        this.showAddNodesModal = true;
        await this.loadNodes();
        await this.loadAvailableNodes(1, false);
        await this.service.render();
    }

    private prepareNodeMappingModalForImport() {
        if (this.showAddNodesModal) return;
        this.availableNodeSearch = { text: '', page: 1, dump: this.nodeMappingPageSize, total: 0 };
        this.nodeMappingAvailableRole = '';
        this.nodeMappingMemberSearch = { text: '', role: '', page: 1, dump: this.nodeMappingPageSize };
        this.nodeMappingMessage = '';
        this.nodeMappingBusy = false;
        this.nodeMappingPendingAddRows = [];
        this.nodeMappingPendingRemoveIds = new Set();
        this.availableNodes = [];
        this.selectedNodeIds = new Set();
        this.selectedClusterNodeIds = new Set();
        this.showAddNodesModal = true;
    }

    public async closeAddNodes() {
        this.showAddNodesModal = false;
        this.nodeMappingMessage = '';
        this.selectedNodeIds = new Set();
        this.selectedClusterNodeIds = new Set();
        this.nodeMappingPendingAddRows = [];
        this.nodeMappingPendingRemoveIds = new Set();
        await this.service.render();
    }

    public async loadAvailableNodes(page: number = 1, render: boolean = true) {
        const requested = Number(page || 1);
        this.availableNodeSearch.page = Number.isFinite(requested) ? Math.max(1, requested) : 1;
        this.availableNodeSearch.dump = this.nodeMappingPageSize;
        this.availableNodeFetchPage = Math.floor(((this.availableNodeSearch.page - 1) * this.nodeMappingPageSize) / this.availableNodeFetchDump) + 1;
        this.availableNodesLoading = true;
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call("available_nodes", {
                id: this.id,
                text: this.availableNodeSearch.text || '',
                page: this.availableNodeFetchPage,
                dump: this.availableNodeFetchDump,
            });
            if (code === 200) {
                this.availableNodes = data?.rows || [];
                this.availableNodeSearch.total = Number(data?.total || 0);
                this.availableNodeSearch.dump = this.nodeMappingPageSize;
                this.availableNodeSearch.page = Math.min(this.availableNodeTotalPages(), Math.max(1, this.availableNodeSearch.page));
                this.availableNodeFetchPage = Math.floor(((this.availableNodeSearch.page - 1) * this.nodeMappingPageSize) / this.availableNodeFetchDump) + 1;
            } else {
                this.availableNodes = [];
                this.availableNodeSearch.total = 0;
            }
        } finally {
            this.availableNodesLoading = false;
            if (render) await this.service.render();
        }
    }

    public async searchAvailableNodes() {
        await this.loadAvailableNodes(1);
    }

    public async changeAvailableNodePageSize(size?: number) {
        this.availableNodeSearch.dump = this.nodeMappingPageSize;
        await this.loadAvailableNodes(1);
    }

    public availableNodeTotalPages(): number {
        const pendingAddCount = (this.nodeMappingPendingAddRows || []).length;
        const pendingRemoveCount = this.nodeMappingPendingRemoveIds?.size || 0;
        const total = Math.max(0, Number(this.availableNodeSearch.total || 0) - pendingAddCount + pendingRemoveCount);
        return Math.ceil(total / this.nodeMappingPageSize) || 1;
    }

    public availableNodePageList(): number[] {
        const totalPages = this.availableNodeTotalPages();
        const current = Math.min(totalPages, Math.max(1, Number(this.availableNodeSearch.page || 1)));
        const start = Math.floor((current - 1) / this.availableNodePageWindowSize) * this.availableNodePageWindowSize + 1;
        const end = Math.min(totalPages, start + this.availableNodePageWindowSize - 1);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async moveAvailableNodePage(page: number) {
        const requested = Number(page || 1);
        const safePage = Number.isFinite(requested) ? requested : 1;
        const next = Math.min(this.availableNodeTotalPages(), Math.max(1, safePage));
        if (next === Number(this.availableNodeSearch.page || 1)) return;
        await this.loadAvailableNodes(next);
    }

    public allAvailableNodesSelected(): boolean {
        return this.availableNodes.length > 0 && this.availableNodes.every((node: any) => {
            return this.selectedNodeIds.has(Number(node.id));
        });
    }

    public async toggleNodeSelect(nodeId: number) {
        nodeId = Number(nodeId);
        if (this.selectedNodeIds.has(nodeId)) this.selectedNodeIds.delete(nodeId);
        else this.selectedNodeIds.add(nodeId);
        await this.service.render();
    }

    public toggleAvailableNodesAll(event: any) {
        const checked = !!event?.target?.checked;
        this.availableNodes.forEach((node: any) => {
            const nodeId = Number(node.id);
            if (checked) this.selectedNodeIds.add(nodeId);
            else this.selectedNodeIds.delete(nodeId);
        });
    }

    public async addSelectedNodes() {
        if (this.selectedNodeIds.size === 0) return;
        const ids = Array.from(this.selectedNodeIds);
        const { code } = await wiz.call("add_nodes", { id: this.id, node_ids: JSON.stringify(ids) });
        if (code === 200) {
            this.showAddNodesModal = false;
            await this.load();
        }
        await this.service.render();
    }

    private async clusterTemplateApi(name: string, params: any = {}) {
        const formData = new FormData();
        Object.entries(params || {}).forEach(([key, value]: any) => {
            if (value !== undefined && value !== null) formData.append(key, String(value));
        });

        try {
            const response = await fetch(`/wiz/api/page.kiera.clusters/${name}`, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });
            const result = await response.json();
            return { code: result?.code || response.status || 0, data: result?.data ?? result };
        } catch (error: any) {
            return { code: 0, data: { message: error?.message || 'Cluster template API request failed.' } };
        }
    }

    private async readNodeMappingTemplateFileAsBase64(file: File): Promise<string> {
        const buffer = await file.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        const chunkSize = 0x8000;
        let binary = '';
        for (let index = 0; index < bytes.length; index += chunkSize) {
            const chunk = bytes.subarray(index, index + chunkSize);
            binary += String.fromCharCode(...Array.from(chunk));
        }
        return btoa(binary);
    }

    private downloadNodeMappingBase64File(contentBase64: string, filename: string, mimeType: string) {
        const encoded = String(contentBase64 || '');
        const binary = atob(encoded.includes(',') ? encoded.split(',').pop() || '' : encoded);
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index++) bytes[index] = binary.charCodeAt(index);
        const blob = new Blob([bytes], { type: mimeType || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    private nodeMappingTemplateFormatDateTime(date: Date): string {
        const pad = (value: number) => String(value).padStart(2, '0');
        return [
            date.getFullYear(),
            pad(date.getMonth() + 1),
            pad(date.getDate()),
        ].join('-') + ' ' + [
            pad(date.getHours()),
            pad(date.getMinutes()),
            pad(date.getSeconds()),
        ].join(':');
    }

    // =========================================================================
    // Node Mapping
    // =========================================================================

    private nodeMappingConfigValue(keys: string[], fallback: any = ''): any {
        return this.summaryConfigValue(keys, fallback);
    }

    public nodeMappingTemplateNodes(): any[] {
        const preview = this.summaryTemplatePreview();
        return Array.isArray(preview.nodes) ? preview.nodes : [];
    }

    public nodeMappingTemplateTotal(): number {
        const preview = this.summaryTemplatePreview();
        const total = Number(preview?.summary?.total_nodes || this.summaryMappingConfig().total || 0);
        return total || this.nodeMappingTemplateNodes().length || this.summaryNodeCount();
    }

    public nodeMappingRegisteredTotal(): number {
        return this.summaryNodeCount() + Number(this.availableNodeSearch?.total || this.availableNodes?.length || 0);
    }

    public nodeMappingHasTemplateReference(): boolean {
        const mapping = this.summaryMappingConfig();
        return this.nodeMappingTemplateNodes().length > 0
            || !!this.summaryTemplateFileName()
            || Number(mapping.total || 0) > 0;
    }

    public nodeMappingAutomaticMatchedCount(): number {
        const mapping = this.summaryMappingConfig();
        const configured = Number(mapping.matched || 0);
        if (configured > 0) return configured;
        return this.nodeMappingTemplateNodes().filter((row: any) => String(row?.mapping_status || '').toLowerCase() === 'matched').length;
    }

    public nodeMappingManualMappedCount(): number {
        const mapping = this.summaryMappingConfig();
        return Number(mapping.manual || mapping.manual_mapped || 0);
    }

    public nodeMappingNotMappedCount(): number {
        const mapping = this.summaryMappingConfig();
        const configured = Number(mapping.failed || mapping.not_mapped || 0);
        if (configured > 0) return configured;
        const templateTotal = this.nodeMappingTemplateTotal();
        const mapped = this.nodeMappingAutomaticMatchedCount() + this.nodeMappingManualMappedCount();
        return Math.max(0, templateTotal - mapped);
    }

    private nodeMappingPercent(value: number, total: number): string {
        if (!total || total <= 0) return '0%';
        return `${((Number(value || 0) / total) * 100).toFixed(1)}%`;
    }

    public nodeMappingLastUpdatedLabel(): string {
        return String(this.item?.updated || this.summaryConfigValue(['template_uploaded'], '') || '-');
    }

    public nodeMappingSummaryCards(): any[] {
        const total = this.nodeMappingRegisteredTotal();
        const members = this.summaryNodeCount();
        const available = Number(this.availableNodeSearch?.total || this.availableNodes?.length || 0);
        const templateTotal = this.nodeMappingHasTemplateReference() ? this.nodeMappingTemplateTotal() : 0;
        return [
            { label: 'Cluster Members', value: this.summaryFormatNumber(members), sub: `Relay ${this.summaryFormatNumber(this.summaryRelayCount())} | Compute ${this.summaryFormatNumber(this.summaryComputeCount())}`, tone: 'blue' },
            { label: 'Available Nodes', value: this.summaryFormatNumber(available), sub: 'Not in this cluster', tone: 'blue' },
            { label: 'Global Inventory', value: this.summaryFormatNumber(total), sub: templateTotal ? `Template reference ${this.summaryFormatNumber(templateTotal)}` : 'Registered nodes', tone: 'dark' },
            { label: 'Utilization', value: this.nodeMappingPercent(members, total), sub: `${this.summaryFormatNumber(members)} / ${this.summaryFormatNumber(total)}`, tone: 'dark' },
            { label: 'Last Updated', value: this.nodeMappingLastUpdatedLabel(), sub: 'Cluster inventory', tone: 'dark' },
        ];
    }

    public nodeMappingSummaryCardClass(tone: string): string {
        const map: any = {
            blue: 'border-blue-100 bg-white text-blue-700',
            green: 'border-emerald-100 bg-white text-emerald-700',
            violet: 'border-violet-100 bg-white text-violet-700',
            red: 'border-red-100 bg-white text-red-600',
            dark: 'border-zinc-100 bg-white text-zinc-900',
        };
        return map[tone] || map.dark;
    }

    public nodeMappingRuleItems(): string[] {
        const configured = this.nodeMappingConfigValue(['mapping_rules', 'mapping.rule', 'node_identity_mapping_rule'], null);
        if (Array.isArray(configured) && configured.length > 0) {
            return configured.map((item: any) => String(item?.label || item?.name || item || '').trim()).filter((item: string) => !!item);
        }
        return ['BMC MAC', 'Provisioning MAC', 'Hostname', 'Serial Number'];
    }

    public nodeMappingRuleLabel(): string {
        return this.nodeMappingRuleItems().slice(0, 3).join(' -> ') || 'BMC MAC -> Provisioning MAC -> Hostname';
    }

    private nodeMappingTemplateFileExtension(fileName: string): string {
        const match = String(fileName || '').toLowerCase().match(/\.[^.]+$/);
        return match ? match[0] : '';
    }

    public async downloadNodeMappingTemplateSample() {
        if (this.nodeMappingTemplateImporting) return;
        const sampleMode = this.nodeMappingRelayProvisioning() ? 'relay' : 'direct';
        this.nodeMappingMessage = '';
        const { code, data } = await this.clusterTemplateApi("template_sample", { mode: sampleMode });
        if (code !== 200 || !data?.content_base64) {
            this.nodeMappingMessage = data?.message || 'Failed to download template sample.';
            await this.service.render();
            return;
        }
        this.downloadNodeMappingBase64File(
            data.content_base64,
            data.filename || (sampleMode === 'relay' ? 'cluster-template-relay-sample.xlsx' : 'cluster-template-direct-sample.xlsx'),
            data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        );
    }

    private nodeMappingNormalizedTemplateValue(value: any, kind: string): string {
        const text = String(value ?? '').trim();
        if (!text) return '';
        if (kind === 'bmc_mac' || kind === 'provisioning_mac') {
            const normalized = text.replace(/[^0-9A-Fa-f]/g, '').toLowerCase();
            return normalized.length === 12 ? normalized : '';
        }
        if (kind === 'node_id') return /^\d+$/.test(text) ? String(Number(text)) : text;
        if (kind === 'hostname' || kind === 'serial_number') return text.toLowerCase();
        return text;
    }

    private nodeMappingTemplateIdentityValue(row: any, key: string): string {
        const source: any = {
            node_id: row?.template_node_id || row?.node_id,
            bmc_mac: row?.template_bmc_mac || row?.bmc_mac,
            provisioning_mac: row?.template_provisioning_mac || row?.provisioning_mac,
            bmc_ip: row?.template_bmc_ip || row?.bmc_ip,
            hostname: row?.template_hostname || row?.hostname || row?.name,
            serial_number: row?.template_serial_number || row?.serial_number,
        };
        return this.nodeMappingNormalizedTemplateValue(source[key], key);
    }

    private nodeMappingInventoryIdentityValue(node: any, key: string): string {
        const source: any = {
            node_id: node?.id,
            bmc_mac: node?.bmc_mac,
            provisioning_mac: node?.mac_address,
            bmc_ip: node?.bmc_ip,
            hostname: node?.name,
            serial_number: node?.serial_number,
        };
        return this.nodeMappingNormalizedTemplateValue(source[key], key);
    }

    private nodeMappingTemplateRole(row: any): string {
        const roleType = String(row?.role_type || '').trim().toLowerCase();
        if (roleType === 'relay') return 'relay';
        const role = String(row?.role || '').trim().toLowerCase();
        if (['relay', 'authority', 'member', 'dhcp', 'server'].some((token: string) => role.includes(token))) return 'relay';
        return 'compute';
    }

    private async nodeMappingTemplateImportCandidates(): Promise<any[]> {
        const rows: any[] = [];
        const dump = 100;
        let page = 1;
        let total = 0;
        do {
            const { code, data } = await wiz.call("available_nodes", {
                id: this.id,
                text: '',
                page,
                dump,
            });
            if (code !== 200) break;
            const pageRows = data?.rows || [];
            rows.push(...pageRows);
            total = Number(data?.total || rows.length || 0);
            page += 1;
            if (pageRows.length === 0) break;
        } while (rows.length < total);
        return rows;
    }

    private nodeMappingApplyTemplateImport(preview: any, candidates: any[]): any {
        const rules = ['bmc_ip', 'node_id', 'bmc_mac', 'provisioning_mac', 'hostname', 'serial_number'];
        const indexes: any = {};
        for (const key of rules) indexes[key] = {};
        for (const node of candidates || []) {
            for (const key of rules) {
                const value = this.nodeMappingInventoryIdentityValue(node, key);
                if (!value) continue;
                if (!indexes[key][value]) indexes[key][value] = [];
                indexes[key][value].push(node);
            }
        }

        const pendingAddIds = this.nodeMappingPendingAddIdSet();
        const clusterNodeIds = new Set((this.clusterNodes || []).map((node: any) => String(node.id)));
        const usedNodeIds = new Set<string>();
        const stats = { staged: 0, existing: 0, duplicate: 0, unmatched: 0, skipped: 0 };
        for (const row of preview?.nodes || []) {
            let matchedNode: any = null;
            for (const key of rules) {
                const value = this.nodeMappingTemplateIdentityValue(row, key);
                if (!value) continue;
                const matches = (indexes[key][value] || []).filter((node: any) => !usedNodeIds.has(String(node.id)));
                if (matches.length === 1) {
                    matchedNode = matches[0];
                    break;
                }
                if (matches.length > 1) {
                    stats.duplicate++;
                    break;
                }
            }
            if (!matchedNode) {
                stats.unmatched++;
                continue;
            }

            const nodeId = String(matchedNode.id || '');
            if (!nodeId) {
                stats.skipped++;
                continue;
            }
            usedNodeIds.add(nodeId);
            if (clusterNodeIds.has(nodeId)) {
                stats.existing++;
                continue;
            }
            if (pendingAddIds.has(nodeId)) {
                stats.skipped++;
                continue;
            }

            const templateName = String(row?.template_hostname || row?.hostname || row?.name || '').trim();
            const targetRole = this.nodeMappingTargetRole(this.nodeMappingTemplateRole(row));
            this.nodeMappingPendingAddRows.push({
                ...matchedNode,
                __nodeMappingTemplateImport: true,
                old_name: matchedNode.old_name || matchedNode.name || '',
                name: templateName || matchedNode.name || '',
                node_mapping_target_role: targetRole,
                role_type: targetRole,
                template_role: targetRole,
                template_hostname: templateName,
                template_bmc_ip: row?.template_bmc_ip || row?.bmc_ip || '',
                template_bmc_mac: row?.template_bmc_mac || row?.bmc_mac || '',
                template_provisioning_ip: row?.template_provisioning_ip || row?.provisioning_ip || '',
                template_provisioning_mac: row?.template_provisioning_mac || row?.provisioning_mac || '',
            });
            pendingAddIds.add(nodeId);
            stats.staged++;
        }
        return stats;
    }

    public async importNodeMappingTemplate(event: any, fileInput?: any) {
        const file = event?.target?.files?.[0] || null;
        if (fileInput) fileInput.value = '';
        if (!file || this.nodeMappingBusy || this.nodeMappingTemplateImporting) return;
        this.prepareNodeMappingModalForImport();

        const extension = this.nodeMappingTemplateFileExtension(file.name);
        if (!['.xlsx', '.xlsm', '.xltx', '.csv', '.tsv', '.txt', '.xls', '.xml', '.html', '.htm'].includes(extension)) {
            this.nodeMappingMessage = 'Unsupported template file type.';
            await this.service.render();
            return;
        }

        this.nodeMappingTemplateImporting = true;
        this.nodeMappingMessage = 'Importing node template...';
        await this.service.render();
        try {
            const contentBase64 = await this.readNodeMappingTemplateFileAsBase64(file);
            const { code, data } = await this.clusterTemplateApi("template_validate", {
                filename: file.name || 'cluster-template.xlsx',
                uploaded: this.nodeMappingTemplateFormatDateTime(new Date()),
                content_base64: contentBase64,
            });
            const preview = data?.preview || data;
            if (code !== 200 || !preview?.nodes) {
                this.nodeMappingMessage = data?.message || 'Template import failed.';
                return;
            }
            if (preview?.summary?.result_status === 'error') {
                this.nodeMappingMessage = preview?.summary?.result_message || 'Template has validation errors.';
                return;
            }
            await this.loadNodes();
            const candidates = await this.nodeMappingTemplateImportCandidates();
            const stats = this.nodeMappingApplyTemplateImport(preview, candidates);
            this.nodeMappingMemberSearch.page = this.nodeMappingMemberTotalPages();
            await this.loadAvailableNodes(this.availableNodeSearch.page || 1, false);
            this.nodeMappingMessage = `${stats.staged} node(s) staged from template. ${stats.existing} already in cluster. ${stats.unmatched + stats.duplicate} not matched.`;
        } catch (error: any) {
            this.nodeMappingMessage = error?.message || 'Template import failed.';
        } finally {
            this.nodeMappingTemplateImporting = false;
            await this.service.render();
        }
    }

    private nodeMappingMatchedByLabel(value: any): string {
        const normalized = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ');
        if (!normalized) return 'Configured rule';
        if (normalized.includes('bmc') && normalized.includes('mac')) return 'BMC MAC';
        if (normalized.includes('provision') && normalized.includes('mac')) return 'Provisioning MAC';
        if (normalized.includes('host')) return 'Hostname';
        if (normalized.includes('serial')) return 'Serial Number';
        return normalized.replace(/\b\w/g, (letter: string) => letter.toUpperCase());
    }

    public nodeMappingAutomaticRows(): any[] {
        const counts: any = {};
        for (const row of this.nodeMappingTemplateNodes()) {
            if (String(row?.mapping_status || '').toLowerCase() !== 'matched') continue;
            const key = this.nodeMappingMatchedByLabel(row?.matched_by || this.summaryMatchedByLabel());
            counts[key] = Number(counts[key] || 0) + 1;
        }
        const rows = Object.entries(counts).map(([label, count]: [string, any]) => ({ label, count }));
        if (rows.length > 0) return rows;
        return [{ label: this.summaryMatchedByLabel(), count: this.nodeMappingAutomaticMatchedCount() }];
    }

    private nodeMappingRoleKey(node: any): string {
        const relayRole = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (relayRole === 'authority' || relayRole === 'member') return 'relay';
        if (this.isClusterRelayServer(node)) return 'relay';
        const name = String(node?.name || node?.template_hostname || '').trim().toLowerCase();
        if (name.startsWith('relay')) return 'relay';
        const role = String(node?.role_type || node?.template_role || '').trim().toLowerCase();
        if (role.includes('relay') || role.includes('authority')) return 'relay';
        return 'compute';
    }

    public nodeMappingRoleLabel(node: any): string {
        return this.nodeMappingRoleKey(node) === 'relay' ? 'Relay' : 'Compute';
    }

    public nodeMappingRoleBadgeClass(node: any): string {
        return this.nodeMappingRoleKey(node) === 'relay'
            ? 'bg-blue-100 text-blue-700'
            : 'bg-emerald-100 text-emerald-700';
    }

    private nodeMappingNodeMatchesText(node: any, text: string): boolean {
        const keyword = String(text || '').trim().toLowerCase();
        if (!keyword) return true;
        const values = [
            node?.name,
            node?.template_hostname,
            node?.bmc_ip,
            node?.template_bmc_ip,
            node?.ip_address,
            node?.mac_address,
            node?.bmc_mac,
            node?.template_bmc_mac,
            node?.rack,
            node?.unit,
        ];
        return values.some((value: any) => String(value || '').toLowerCase().includes(keyword));
    }

    public nodeMappingAvailableRows(): any[] {
        const role = String(this.nodeMappingAvailableRole || '').trim();
        const pendingAddIds = this.nodeMappingPendingAddIdSet();
        const rows = this.nodeMappingUniqueNodeRows([
            ...this.nodeMappingPendingRemovedRows(),
            ...(this.availableNodes || []).filter((node: any) => !pendingAddIds.has(String(node.id))),
        ]);
        const filtered = rows.filter((node: any) => {
            return (!role || this.nodeMappingRoleKey(node) === role)
                && this.nodeMappingNodeMatchesText(node, this.availableNodeSearch.text || '');
        });
        const page = Math.max(1, Number(this.availableNodeSearch.page || 1));
        const displayStart = (page - 1) * this.nodeMappingPageSize;
        const fetchStart = (Math.max(1, Number(this.availableNodeFetchPage || 1)) - 1) * this.availableNodeFetchDump;
        const start = Math.max(0, displayStart - fetchStart);
        return filtered.slice(start, start + this.nodeMappingPageSize);
    }

    public nodeMappingMemberRows(): any[] {
        const role = String(this.nodeMappingMemberSearch?.role || '').trim();
        const pendingRemoveIds = this.nodeMappingPendingRemoveIdSet();
        const rows = [
            ...(this.clusterNodes || []).filter((node: any) => !pendingRemoveIds.has(String(node.id))),
            ...this.nodeMappingPreparedPendingAdds(),
        ];
        return rows.filter((node: any) => {
            return (!role || this.nodeMappingRoleKey(node) === role)
                && this.nodeMappingNodeMatchesText(node, this.nodeMappingMemberSearch?.text || '');
        });
    }

    public nodeMappingVisibleMemberRows(): any[] {
        const rows = this.nodeMappingMemberRows();
        const page = Math.max(1, Number(this.nodeMappingMemberSearch?.page || 1));
        const dump = Math.max(1, Number(this.nodeMappingMemberSearch?.dump || this.nodeMappingPageSize));
        return rows.slice((page - 1) * dump, page * dump);
    }

    public nodeMappingMemberTotalPages(): number {
        const dump = Math.max(1, Number(this.nodeMappingMemberSearch?.dump || this.nodeMappingPageSize));
        return Math.ceil(this.nodeMappingMemberRows().length / dump) || 1;
    }

    public nodeMappingMemberPageList(): number[] {
        const totalPages = this.nodeMappingMemberTotalPages();
        const current = Math.min(totalPages, Math.max(1, Number(this.nodeMappingMemberSearch?.page || 1)));
        const start = Math.floor((current - 1) / this.availableNodePageWindowSize) * this.availableNodePageWindowSize + 1;
        const end = Math.min(totalPages, start + this.availableNodePageWindowSize - 1);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async nodeMappingMoveMemberPage(page: number) {
        this.nodeMappingMemberSearch.page = Math.min(this.nodeMappingMemberTotalPages(), Math.max(1, Number(page || 1)));
        await this.service.render();
    }

    public async nodeMappingChangeMemberPageSize(size?: number) {
        this.nodeMappingMemberSearch.dump = this.nodeMappingPageSize;
        this.nodeMappingMemberSearch.page = 1;
        await this.service.render();
    }

    private nodeMappingPendingAddIdSet(): Set<string> {
        return new Set((this.nodeMappingPendingAddRows || []).map((node: any) => String(node.id)));
    }

    private nodeMappingPendingRemoveIdSet(): Set<string> {
        return new Set(Array.from(this.nodeMappingPendingRemoveIds || new Set()).map((nodeId: any) => String(nodeId)));
    }

    private nodeMappingUniqueNodeRows(rows: any[]): any[] {
        const result: any[] = [];
        const seen = new Set<string>();
        for (const row of rows || []) {
            const key = String(row?.id || '');
            if (!key || seen.has(key)) continue;
            result.push(row);
            seen.add(key);
        }
        return result;
    }

    private nodeMappingPendingRemovedRows(): any[] {
        const pendingRemoveIds = this.nodeMappingPendingRemoveIdSet();
        return (this.clusterNodes || [])
            .filter((node: any) => pendingRemoveIds.has(String(node.id)))
            .map((node: any) => ({
                ...node,
                __nodeMappingPendingRemove: true,
                name: node.old_name || node.name,
            }));
    }

    public nodeMappingRelayProvisioning(): boolean {
        return this.summaryProvisioningMode() === 'relay';
    }

    private nodeMappingTargetRole(value: any): string {
        return this.nodeMappingRelayProvisioning() && String(value || '').trim().toLowerCase() === 'relay'
            ? 'relay'
            : 'compute';
    }

    public nodeMappingTargetRoleLabel(value: any): string {
        return this.nodeMappingTargetRole(value) === 'relay' ? 'Relay' : 'Compute';
    }

    private nodeMappingBaseRoleCounts(): any {
        const pendingRemoveIds = this.nodeMappingPendingRemoveIdSet();
        const counts: any = { relay: 0, compute: 0 };
        for (const node of this.clusterNodes || []) {
            if (pendingRemoveIds.has(String(node.id))) continue;
            if (this.nodeMappingRelayProvisioning() && this.nodeMappingRoleKey(node) === 'relay') counts.relay++;
            else counts.compute++;
        }
        return counts;
    }

    private nodeMappingExistingAuthorityCount(): number {
        const pendingRemoveIds = this.nodeMappingPendingRemoveIdSet();
        return (this.clusterNodes || []).filter((node: any) => {
            return !pendingRemoveIds.has(String(node.id))
                && String(node.cluster_relay_role || '').trim().toLowerCase() === 'authority';
        }).length;
    }

    private nodeMappingGeneratedNodeName(prefix: any, index: number, fallback: any): string {
        const cleanPrefix = this.summaryCleanPrefixValue(prefix);
        if (!cleanPrefix) return String(fallback || '').trim();
        return `${cleanPrefix.replace(/-+$/g, '')}-${index}`;
    }

    private nodeMappingBmcIpSortKey(node: any): string {
        const value = String(node?.bmc_ip || node?.template_bmc_ip || '').trim();
        const parts = value.split('.').map((part: string) => Number(part));
        if (parts.length === 4 && parts.every((part: number) => Number.isFinite(part) && part >= 0 && part <= 255)) {
            return parts.map((part: number) => String(part).padStart(3, '0')).join('.');
        }
        return value.toLowerCase();
    }

    private nodeMappingSortedByBmcIp(rows: any[]): any[] {
        return [...(rows || [])].sort((left: any, right: any) => {
            const leftKey = this.nodeMappingBmcIpSortKey(left);
            const rightKey = this.nodeMappingBmcIpSortKey(right);
            if (leftKey !== rightKey) return leftKey < rightKey ? -1 : 1;
            return String(left?.name || '').localeCompare(String(right?.name || ''));
        });
    }

    private nodeMappingBuildPendingAdds(applyPrefix: boolean, sortByBmcIp: boolean): any[] {
        const counts = this.nodeMappingBaseRoleCounts();
        let relayIndex = Number(counts.relay || 0);
        let computeIndex = Number(counts.compute || 0);
        let hasAuthority = this.nodeMappingExistingAuthorityCount() > 0;
        const rows = sortByBmcIp
            ? this.nodeMappingSortedByBmcIp(this.nodeMappingPendingAddRows || [])
            : [...(this.nodeMappingPendingAddRows || [])];
        return rows.map((node: any) => {
            const targetRole = this.nodeMappingTargetRole(node.node_mapping_target_role);
            const isRelayTarget = this.nodeMappingRelayProvisioning() && targetRole === 'relay';
            const prefix = isRelayTarget ? this.summaryRelayPrefix() : this.summaryComputePrefix();
            const index = isRelayTarget ? ++relayIndex : ++computeIndex;
            const templateName = String(node.template_hostname || '').trim();
            const originalName = templateName || node.old_name || node.name || '';
            const shouldApplyPrefix = applyPrefix && !(node.__nodeMappingTemplateImport && templateName);
            const nextName = shouldApplyPrefix
                ? this.nodeMappingGeneratedNodeName(prefix, index, originalName)
                : String(originalName || '').trim();
            let relayRole = '';
            if (isRelayTarget) {
                relayRole = hasAuthority ? 'member' : 'authority';
                hasAuthority = true;
            }
            return {
                ...node,
                __nodeMappingPendingAdd: true,
                old_name: originalName,
                name: nextName,
                node_mapping_target_role: targetRole,
                role_type: targetRole,
                template_role: targetRole,
                cluster_relay_role: relayRole,
            };
        });
    }

    private nodeMappingPreparedPendingAdds(): any[] {
        return this.nodeMappingBuildPendingAdds(false, false);
    }

    private nodeMappingPendingAddsForSave(): any[] {
        return this.nodeMappingBuildPendingAdds(true, true);
    }

    public nodeMappingPendingChangeCount(): number {
        return (this.nodeMappingPendingAddRows || []).length + (this.nodeMappingPendingRemoveIds?.size || 0);
    }

    public nodeMappingHasPendingChanges(): boolean {
        return this.nodeMappingPendingChangeCount() > 0;
    }

    public nodeMappingAvailableSelected(): boolean {
        const rows = this.nodeMappingAvailableRows();
        return rows.length > 0 && rows.every((node: any) => this.selectedNodeIds.has(Number(node.id)));
    }

    public async toggleNodeMappingAvailableAll(event: any) {
        const checked = !!event?.target?.checked;
        for (const node of this.nodeMappingAvailableRows()) {
            const nodeId = Number(node.id);
            if (checked) this.selectedNodeIds.add(nodeId);
            else this.selectedNodeIds.delete(nodeId);
        }
        await this.service.render();
    }

    public nodeMappingMembersSelected(): boolean {
        const rows = this.nodeMappingVisibleMemberRows();
        return rows.length > 0 && rows.every((node: any) => this.selectedClusterNodeIds.has(Number(node.id)));
    }

    public async toggleNodeMappingMembersAll(event: any) {
        const checked = !!event?.target?.checked;
        for (const node of this.nodeMappingVisibleMemberRows()) {
            const nodeId = Number(node.id);
            if (checked) this.selectedClusterNodeIds.add(nodeId);
            else this.selectedClusterNodeIds.delete(nodeId);
        }
        await this.service.render();
    }

    public async refreshNodeMapping() {
        await this.loadNodes();
        await this.loadAvailableNodes(this.availableNodeSearch.page || 1, false);
        this.nodeMappingMessage = 'Node mapping inventory refreshed.';
        await this.service.render();
    }

    private nodeMappingFindAvailableNode(nodeId: any): any {
        const key = String(nodeId || '');
        return this.nodeMappingAvailableRows().find((node: any) => String(node.id) === key)
            || (this.availableNodes || []).find((node: any) => String(node.id) === key)
            || this.nodeMappingPendingRemovedRows().find((node: any) => String(node.id) === key)
            || null;
    }

    public async nodeMappingStageSelectedNodes(targetRole: string = 'compute') {
        const ids = Array.from(this.selectedNodeIds);
        if (ids.length === 0 || this.nodeMappingBusy) return;
        const role = this.nodeMappingTargetRole(targetRole);
        const pendingAddIds = this.nodeMappingPendingAddIdSet();
        let staged = 0;
        let restored = 0;
        for (const id of ids) {
            const nodeId = Number(id);
            if (!nodeId) continue;
            if (this.nodeMappingPendingRemoveIds.has(nodeId)) {
                this.nodeMappingPendingRemoveIds.delete(nodeId);
                restored++;
                continue;
            }
            if (pendingAddIds.has(String(nodeId))) continue;
            const node = this.nodeMappingFindAvailableNode(nodeId);
            if (!node) continue;
            this.nodeMappingPendingAddRows.push({
                ...node,
                old_name: node.old_name || node.name || '',
                node_mapping_target_role: role,
            });
            pendingAddIds.add(String(nodeId));
            staged++;
        }
        this.selectedNodeIds = new Set();
        this.nodeMappingMemberSearch.page = this.nodeMappingMemberTotalPages();
        const parts = [];
        if (staged > 0) parts.push(`${staged} node(s) staged as ${this.nodeMappingTargetRoleLabel(role)}.`);
        if (restored > 0) parts.push(`${restored} node(s) restored to Cluster Members.`);
        this.nodeMappingMessage = parts.join(' ') || 'No node changes staged.';
        await this.service.render();
    }

    public async nodeMappingAddSelectedNodes() {
        await this.nodeMappingStageSelectedNodes('compute');
    }

    public async nodeMappingRemoveSelectedNodes() {
        const ids = this.selectedClusterNodeIdsArray();
        if (ids.length === 0 || this.nodeMappingBusy) return;
        const pendingAddIds = this.nodeMappingPendingAddIdSet();
        let unstaged = 0;
        let stagedRemove = 0;
        for (const id of ids) {
            const nodeId = Number(id);
            if (!nodeId) continue;
            if (pendingAddIds.has(String(nodeId))) {
                this.nodeMappingPendingAddRows = this.nodeMappingPendingAddRows.filter((node: any) => String(node.id) !== String(nodeId));
                unstaged++;
                continue;
            }
            if ((this.clusterNodes || []).some((node: any) => String(node.id) === String(nodeId))) {
                this.nodeMappingPendingRemoveIds.add(nodeId);
                stagedRemove++;
            }
        }
        this.selectedClusterNodeIds = new Set();
        this.nodeMappingMemberSearch.page = Math.min(
            this.nodeMappingMemberTotalPages(),
            Math.max(1, Number(this.nodeMappingMemberSearch.page || 1))
        );
        const parts = [];
        if (stagedRemove > 0) parts.push(`${stagedRemove} node(s) staged for removal.`);
        if (unstaged > 0) parts.push(`${unstaged} pending add node(s) returned to Available Nodes.`);
        this.nodeMappingMessage = parts.join(' ') || 'No node changes staged.';
        await this.service.render();
    }

    private nodeMappingSaveValidationMessage(addRows: any[]): string {
        if (!this.nodeMappingRelayProvisioning()) return '';
        const baseCounts = this.nodeMappingBaseRoleCounts();
        const relayAddCount = addRows.filter((node: any) => this.nodeMappingTargetRole(node.node_mapping_target_role) === 'relay').length;
        const computeAddCount = addRows.filter((node: any) => this.nodeMappingTargetRole(node.node_mapping_target_role) !== 'relay').length;
        const finalRelayCount = Number(baseCounts.relay || 0) + relayAddCount;
        const finalComputeCount = Number(baseCounts.compute || 0) + computeAddCount;
        const hasAuthority = this.nodeMappingExistingAuthorityCount() > 0
            || addRows.some((node: any) => String(node.cluster_relay_role || '') === 'authority');
        if (finalComputeCount > 0 && finalRelayCount === 0) {
            return 'Relay provisioning requires at least one Relay node before saving compute nodes.';
        }
        if (finalRelayCount > 0 && !hasAuthority) {
            return 'Relay provisioning requires one Authority relay node.';
        }
        return '';
    }

    private nodeMappingApplySavedRelayRoles(addRows: any[]): boolean {
        if (!this.nodeMappingRelayProvisioning() || addRows.length === 0) return false;
        const stagedById: any = {};
        for (const row of addRows) stagedById[String(row.id)] = row;

        let changed = false;
        for (const node of this.clusterNodes || []) {
            const staged = stagedById[String(node.id)];
            if (!staged) continue;
            const targetRole = this.nodeMappingTargetRole(staged.node_mapping_target_role);
            node.cluster_relay_excluded = false;
            if (targetRole === 'relay') {
                node.cluster_relay_role = String(staged.cluster_relay_role || 'member');
                node.cluster_relay_id = '';
                if (node.cluster_relay_role === 'authority') {
                    node.cluster_relay_dhcp_group_key = this.promotedClusterRelayAuthorityGroupKey(node);
                }
                changed = true;
            }
        }

        for (const node of this.clusterNodes || []) {
            const staged = stagedById[String(node.id)];
            if (!staged || this.nodeMappingTargetRole(staged.node_mapping_target_role) === 'relay') continue;
            const relay = this.clusterRelayFallbackServerForNode(node);
            node.cluster_relay_role = '';
            node.cluster_relay_excluded = false;
            node.cluster_relay_dhcp_group_key = this.defaultClusterRelayGroupKey(node);
            node.cluster_relay_id = relay?.id || '';
            node.cluster_relay_unassigned = !relay;
            changed = true;
        }

        if (changed) this.normalizeClusterRelayConfig();
        return changed;
    }

    public async saveNodeMappingChanges() {
        if (!this.nodeMappingHasPendingChanges() || this.nodeMappingBusy) return;
        const addRows = this.nodeMappingPendingAddsForSave();
        const validationMessage = this.nodeMappingSaveValidationMessage(addRows);
        if (validationMessage) {
            this.nodeMappingMessage = validationMessage;
            await this.service.render();
            return;
        }

        const removeIds = Array.from(this.nodeMappingPendingRemoveIds || new Set()).map((nodeId: any) => Number(nodeId)).filter((nodeId: number) => nodeId > 0);
        const addIds = addRows.map((node: any) => Number(node.id)).filter((nodeId: number) => nodeId > 0);
        const nodesConfig = addRows
            .filter((node: any) => String(node.name || '').trim())
            .map((node: any) => ({ id: Number(node.id), name: String(node.name || '').trim() }));

        this.nodeMappingBusy = true;
        this.nodeMappingMessage = 'Saving node mapping changes...';
        await this.service.render();

        if (addIds.length > 0) {
            const { code, data } = await wiz.call("add_nodes", {
                id: this.id,
                node_ids: JSON.stringify(addIds),
                nodes_config: nodesConfig.length > 0 ? JSON.stringify(nodesConfig) : '',
            });
            if (code !== 200) {
                this.nodeMappingBusy = false;
                this.nodeMappingMessage = data?.message || 'Failed to add selected nodes.';
                await this.service.render();
                return;
            }
        }

        if (removeIds.length > 0) {
            const { code, data } = await wiz.call("remove_nodes", { id: this.id, node_ids: JSON.stringify(removeIds) });
            if (code !== 200) {
                this.nodeMappingBusy = false;
                this.nodeMappingMessage = data?.message || 'Failed to remove selected nodes.';
                await this.loadNodes();
                await this.loadAvailableNodes(this.availableNodeSearch.page || 1, false);
                await this.service.render();
                return;
            }
        }

        await this.loadNodes();
        let relaySaved = true;
        if (this.nodeMappingRelayProvisioning() && this.nodeMappingApplySavedRelayRoles(addRows) && this.clusterRelayCandidateServerNodes().length > 0) {
            const relayGroupId = await this.ensureClusterRelayGroupSaved(false);
            relaySaved = !!relayGroupId;
        }

        this.nodeMappingBusy = false;
        this.selectedNodeIds = new Set();
        this.selectedClusterNodeIds = new Set();
        this.nodeMappingPendingAddRows = [];
        this.nodeMappingPendingRemoveIds = new Set();
        await this.loadNodes();
        await this.loadAvailableNodes(1, false);
        if (relaySaved) {
            this.showAddNodesModal = false;
            this.nodeMappingMessage = '';
        } else {
            this.nodeMappingMessage = `${addIds.length} node(s) added · ${removeIds.length} node(s) removed. Relay role config save failed.`;
        }
        await this.service.render();
    }

    public nodeMappingNotMappedRows(): any[] {
        return this.nodeMappingTemplateNodes().filter((row: any) => {
            const status = String(row?.mapping_status || '').trim().toLowerCase();
            return status && status !== 'matched' && status !== 'auto';
        });
    }

    public nodeMappingManualTemplateOptions(): any[] {
        const rows = this.nodeMappingNotMappedRows();
        return rows.map((row: any, index: number) => ({
            ...row,
            key: `${index}:${row.template_hostname || row.template_bmc_ip || row.template_bmc_mac || 'template'}`,
        }));
    }

    public nodeMappingUnusedRegisteredRows(): any[] {
        return this.nodeMappingAvailableRows();
    }

    private nodeMappingSelectedManualTemplate(): any {
        const key = String(this.nodeMappingManualForm?.template_key || '');
        return this.nodeMappingManualTemplateOptions().find((row: any) => row.key === key) || null;
    }

    public async nodeMappingApplyManualMapping() {
        const template = this.nodeMappingSelectedManualTemplate();
        const nodeId = Number(this.nodeMappingManualForm?.node_id || 0);
        if (!template || !nodeId || this.nodeMappingBusy) return;
        const nodeName = String(template.template_hostname || '').trim();
        const nodesConfig = nodeName ? [{ id: nodeId, name: nodeName }] : undefined;
        this.nodeMappingBusy = true;
        this.nodeMappingMessage = '';
        await this.service.render();
        const { code, data } = await wiz.call("add_nodes", {
            id: this.id,
            node_ids: JSON.stringify([nodeId]),
            nodes_config: nodesConfig ? JSON.stringify(nodesConfig) : '',
        });
        this.nodeMappingBusy = false;
        if (code === 200) {
            this.nodeMappingManualForm = { template_key: '', node_id: '' };
            this.nodeMappingMessage = 'Manual mapping applied.';
            await this.load();
        } else {
            this.nodeMappingMessage = data?.message || 'Manual mapping failed.';
            await this.service.render();
        }
    }

    public nodeMappingTemplateRoleLabel(row: any): string {
        return this.nodeMappingRoleLabel(row);
    }

    public nodeMappingTemplateStatusLabel(row: any): string {
        const status = String(row?.mapping_status || '').trim().toLowerCase();
        if (status === 'matched') return 'Matched';
        if (status === 'auto') return 'Auto';
        if (status === 'manual') return 'Manual';
        return status ? status.replace(/[_-]+/g, ' ') : 'Not mapped';
    }

    public nodeMappingTemplateReason(row: any): string {
        return String(row?.reason || row?.mapping_reason || row?.message || '').trim() || 'No match found';
    }

    public isClusterNodeSelected(nodeId: number): boolean {
        return this.selectedClusterNodeIds.has(Number(nodeId));
    }

    public async toggleClusterNodeSelect(nodeId: number) {
        nodeId = Number(nodeId);
        if (this.selectedClusterNodeIds.has(nodeId)) this.selectedClusterNodeIds.delete(nodeId);
        else this.selectedClusterNodeIds.add(nodeId);
        await this.service.render();
    }

    private visibleClusterTreeNodes(): any[] {
        return this.clusterNodeTreeRows().map((row: any) => row.node).filter((node: any) => !!node);
    }

    public async toggleAllClusterNodes(event: any) {
        const checked = !!event?.target?.checked;
        const next = new Set(this.selectedClusterNodeIds);
        this.visibleClusterTreeNodes().forEach((node: any) => {
            const nodeId = Number(node.id);
            if (checked) next.add(nodeId);
            else next.delete(nodeId);
        });
        this.selectedClusterNodeIds = next;
        await this.service.render();
    }

    public allClusterNodesSelected(): boolean {
        const nodes = this.visibleClusterTreeNodes();
        return nodes.length > 0 && nodes.every((node: any) => this.selectedClusterNodeIds.has(Number(node.id)));
    }

    public selectedClusterNodeIdsArray(): number[] {
        return Array.from(this.selectedClusterNodeIds);
    }

    public selectedClusterNodes(): any[] {
        const selectedIds = new Set(this.selectedClusterNodeIdsArray().map((nodeId: number) => String(nodeId)));
        return (this.clusterNodes || []).filter((node: any) => selectedIds.has(String(node.id)));
    }

    private normalizeClusterNodeValue(value: any): string {
        return String(value || '').trim().toLowerCase();
    }

    public clusterNodeInventoryRole(node: any): string {
        return this.isClusterRelayServer(node) ? 'relay' : 'compute';
    }

    public clusterNodeInventoryRoleLabel(node: any): string {
        return this.clusterNodeInventoryRole(node) === 'relay' ? 'Relay' : 'Compute';
    }

    public clusterNodeInventoryRoleBadgeClass(node: any): string {
        return this.clusterNodeInventoryRole(node) === 'relay'
            ? 'bg-blue-100 text-blue-700'
            : 'bg-emerald-100 text-emerald-700';
    }

    public isClusterNodeUnassigned(node: any): boolean {
        return !!node && !this.isClusterRelayServer(node) && !this.clusterRelayAssignedServer(node);
    }

    private clusterNodeDhcpRoleKey(node: any): string {
        const role = this.normalizeClusterNodeValue(node?.cluster_relay_role);
        if (role === 'authority') return 'authority';
        if (role === 'member') return 'member';
        return 'client';
    }

    public clusterNodeStatusLabel(value: any, fallback: string = 'new'): string {
        const normalized = this.normalizeClusterNodeValue(value) || fallback;
        return normalized.replace(/[_-]+/g, ' ').toUpperCase();
    }

    public clusterNodeStatusBadgeClass(value: any): string {
        const normalized = this.normalizeClusterNodeValue(value);
        if (!normalized || normalized === 'new') return 'bg-zinc-100 text-zinc-600';
        if (normalized === 'active' || normalized === 'ready' || normalized === 'deployed' || normalized === 'commissioned') {
            return 'bg-emerald-100 text-emerald-700';
        }
        if (normalized === 'busy' || normalized === 'deploying' || normalized === 'commissioning' || normalized.includes('running')) {
            return 'bg-blue-100 text-blue-700';
        }
        if (normalized === 'idle' || normalized === 'pending') return 'bg-zinc-100 text-zinc-600';
        if (normalized === 'error' || normalized === 'failed' || normalized.includes('failed')) return 'bg-red-100 text-red-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public clusterNodePowerLabel(node: any): string {
        const normalized = this.normalizeClusterNodeValue(node?.power_status);
        if (normalized === 'on') return 'On';
        if (normalized === 'off') return 'Off';
        return normalized ? normalized.toUpperCase() : 'Unknown';
    }

    public clusterNodePowerDotClass(node: any): string {
        const normalized = this.normalizeClusterNodeValue(node?.power_status);
        if (normalized === 'on') return 'bg-emerald-500';
        if (normalized === 'off') return 'bg-red-500';
        return 'bg-zinc-400';
    }

    public clusterNodePowerTextClass(node: any): string {
        const normalized = this.normalizeClusterNodeValue(node?.power_status);
        if (normalized === 'on') return 'text-emerald-700';
        if (normalized === 'off') return 'text-red-700';
        return 'text-zinc-600';
    }

    private clusterNodeRackFilterKey(node: any): string {
        const rackId = Number(node?.location_rack_id || node?.rack_id || 0);
        if (rackId > 0) return `rack:${rackId}`;
        const rack = this.normalizeClusterNodeValue(node?.location_rack || node?.rack);
        return rack ? `name:${rack}` : '__unassigned';
    }

    private clusterNodeRackValue(node: any): string {
        return String(
            node?.location_rack
            || node?.rack
            || node?.location_rack_name
            || '',
        ).trim();
    }

    public clusterNodeRackLabel(node: any): string {
        const rack = this.clusterNodeRackValue(node);
        if (!rack) return 'Unassigned';
        const prefixed = rack.match(/^rack[\s_-]*(.*)$/i);
        if (!prefixed) return `Rack ${rack}`;
        const suffix = String(prefixed[1] || '').trim();
        return suffix ? `Rack ${suffix}` : 'Rack';
    }

    private clusterNodeUnitLabel(node: any): string {
        const unit = String(node?.location_unit || node?.unit || '').trim();
        if (!unit) return '';
        return `${unit.replace(/\s*u$/i, '')}U`;
    }

    public clusterNodeLocationLabel(node: any): string {
        const rack = this.clusterNodeRackValue(node) ? this.clusterNodeRackLabel(node) : '';
        const isChassis = String(node?.location_type || '').toLowerCase() === 'chassis'
            || Number(node?.chassis_id || 0) > 0;
        if (isChassis) {
            const chassisName = String(node?.chassis_name || '').trim() || 'Chassis';
            const slot = Number(node?.chassis_slot || 0);
            const chassis = slot > 0 ? `${chassisName} / S${slot}` : chassisName;
            return rack ? `${rack} · ${chassis}` : chassis;
        }
        const unit = this.clusterNodeUnitLabel(node);
        const placement = [rack, unit].filter((value: string) => !!value).join(' / ');
        return placement ? `${placement} · Standalone` : 'Standalone';
    }

    public clusterNodeRackFilterOptions(): any[] {
        const options = new Map<string, any>();
        for (const node of this.clusterNodes || []) {
            const key = this.clusterNodeRackFilterKey(node);
            const current = options.get(key) || {
                value: key,
                label: key === '__unassigned' ? 'Unassigned' : this.clusterNodeRackLabel(node),
                count: 0,
            };
            current.count += 1;
            options.set(key, current);
        }
        return Array.from(options.values()).sort((left: any, right: any) => {
            if (left.value === '__unassigned') return 1;
            if (right.value === '__unassigned') return -1;
            return String(left.label).localeCompare(
                String(right.label),
                undefined,
                { numeric: true, sensitivity: 'base' },
            );
        });
    }

    public clusterNodeMacAddress(node: any): string {
        return String(node?.mac_address || node?.bmc_mac || '').trim() || '-';
    }

    public clusterNodeAssignedRelayFilterOptions(): any[] {
        return this.clusterRelayServerNodes().map((server: any) => ({
            id: String(server.id),
            label: server.name || `Node #${server.id}`,
            count: (this.clusterNodes || []).filter((node: any) => {
                return !this.isClusterRelayServer(node) && String(node.cluster_relay_id || '') === String(server.id);
            }).length,
        }));
    }

    public clusterNodeStatusFilterOptions(): any[] {
        const seen = new Set<string>();
        const options: any[] = [];
        for (const node of this.clusterNodes || []) {
            const value = this.normalizeClusterNodeValue(node?.status) || 'new';
            if (seen.has(value)) continue;
            seen.add(value);
            options.push({ value, label: this.clusterNodeStatusLabel(value) });
        }
        return options.sort((left: any, right: any) => String(left.label).localeCompare(String(right.label)));
    }

    private clusterNodeSearchActive(): boolean {
        return ['text', 'role', 'dhcp_role', 'assigned_relay_id', 'status', 'power_status', 'rack_key'].some((key: string) => {
            return String(this.nodeSearch?.[key] || '').trim() !== '';
        });
    }

    private clusterNodeMatchesText(node: any): boolean {
        const text = String(this.nodeSearch.text || '').trim().toLowerCase();
        if (!text) return true;
        const values = [
            node?.name,
            node?.old_name,
            node?.status,
            node?.power_status,
            node?.ip_address,
            node?.bmc_ip,
            node?.mac_address,
            node?.bmc_mac,
            node?.rack,
            node?.unit,
            node?.chassis_name,
            node?.chassis_model,
            this.clusterNodeLocationLabel(node),
            this.clusterNodeInventoryRoleLabel(node),
            this.clusterRelayDhcpLabel(node),
            this.clusterNodeSubnetLabel(node),
            this.clusterRelayAssignedServerLabel(node),
            this.clusterRelayAuthorityLabel(node),
        ];
        return values.some((value: any) => String(value || '').toLowerCase().includes(text));
    }

    public clusterNodeSubnetKey(node: any): string {
        if (!node) return '';
        if (this.isClusterRelayServer(node)) return this.clusterRelayDhcpGroupKey(node);
        const assignedServer = this.clusterRelayAssignedServer(node);
        if (assignedServer) return this.clusterRelayDhcpGroupKey(assignedServer);
        return this.defaultClusterRelayGroupKey(node);
    }

    public clusterNodeSubnetLabel(node: any): string {
        const key = this.clusterNodeSubnetKey(node);
        const subnet = this.clusterRelaySubnetForKey(key);
        if (subnet) return subnet.label;
        if (!key || key === 'default') return 'Unassigned subnet';
        return String(node?.dhcp_domain_label || '').trim() || key;
    }

    public clusterNodeSubnetOptions(): any[] {
        const options: any[] = [];
        const seen = new Set<string>();
        for (const node of this.clusterNodes || []) {
            const key = this.clusterNodeSubnetKey(node);
            if (!key || seen.has(key)) continue;
            seen.add(key);
            options.push({
                key,
                label: this.clusterNodeSubnetLabel(node),
                count: (this.clusterNodes || []).filter((item: any) => this.clusterNodeSubnetKey(item) === key).length,
            });
        }
        return options.sort((left: any, right: any) => String(left.label || '').localeCompare(String(right.label || '')));
    }

    private clusterNodeMatchesSubnet(node: any): boolean {
        const subnetKey = String(this.nodeSearch.subnet_key || '').trim();
        if (!subnetKey) return true;
        return this.clusterNodeSubnetKey(node) === subnetKey;
    }

    private clusterNodeMatchesRole(node: any): boolean {
        const role = String(this.nodeSearch.role || '').trim();
        if (!role) return true;
        return this.clusterNodeInventoryRole(node) === role;
    }

    private clusterNodeMatchesDhcpRole(node: any): boolean {
        const role = String(this.nodeSearch.dhcp_role || '').trim();
        if (!role) return true;
        return this.clusterNodeDhcpRoleKey(node) === role;
    }

    private clusterNodeMatchesAssignedRelay(node: any): boolean {
        const relayId = String(this.nodeSearch.assigned_relay_id || '').trim();
        if (!relayId) return true;
        if (relayId === '__unassigned') return !this.isClusterRelayServer(node) && !this.clusterRelayAssignedServer(node);
        return !this.isClusterRelayServer(node) && String(node?.cluster_relay_id || '') === relayId;
    }

    private clusterNodeMatchesStatus(node: any): boolean {
        const status = String(this.nodeSearch.status || '').trim();
        if (!status) return true;
        return (this.normalizeClusterNodeValue(node?.status) || 'new') === status;
    }

    private clusterNodeMatchesPower(node: any): boolean {
        const power = String(this.nodeSearch.power_status || '').trim();
        if (!power) return true;
        const current = this.normalizeClusterNodeValue(node?.power_status) || 'unknown';
        return current === power;
    }

    private clusterNodeMatchesRack(node: any): boolean {
        const rackKey = String(this.nodeSearch.rack_key || '').trim();
        if (!rackKey) return true;
        return this.clusterNodeRackFilterKey(node) === rackKey;
    }

    private clusterNodeMatchesFilters(node: any): boolean {
        return this.clusterNodeMatchesText(node)
            && this.clusterNodeMatchesSubnet(node)
            && this.clusterNodeMatchesRole(node)
            && this.clusterNodeMatchesDhcpRole(node)
            && this.clusterNodeMatchesAssignedRelay(node)
            && this.clusterNodeMatchesStatus(node)
            && this.clusterNodeMatchesPower(node)
            && this.clusterNodeMatchesRack(node);
    }

    public filteredClusterNodes(): any[] {
        const nodes = this.clusterNodes || [];
        const matched = nodes.filter((node: any) => this.clusterNodeMatchesFilters(node));
        if (!this.clusterNodeSearchActive()) return matched;

        const includeIds = new Set<string>(matched.map((node: any) => String(node.id)));
        for (const node of matched) {
            if (this.isClusterRelayServer(node)) {
                const authority = this.clusterRelayAuthorityForNode(node);
                if (authority) includeIds.add(String(authority.id));
                continue;
            }
            const assigned = this.clusterRelayAssignedServer(node);
            if (!assigned) continue;
            includeIds.add(String(assigned.id));
            const authority = this.clusterRelayAuthorityForNode(assigned);
            if (authority) includeIds.add(String(authority.id));
        }
        return nodes.filter((node: any) => includeIds.has(String(node.id)));
    }

    public async clearClusterNodeSearch() {
        this.nodeSearch = { text: '', role: '', dhcp_role: '', assigned_relay_id: '', status: '', power_status: '', rack_key: '' };
        await this.service.render();
    }

    public async exportClusterTemplate() {
        if (this.exportingClusterTemplate || this.filteredClusterNodes().length === 0) return;
        this.exportingClusterTemplate = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('template_export', { id: this.id });
            if (code !== 200 || !data?.content_base64) {
                this.nodeMappingMessage = data?.message || 'Failed to export cluster template.';
                return;
            }
            this.downloadNodeMappingBase64File(
                data.content_base64,
                data.filename || `cluster-${this.item?.name || this.id || 'cluster'}-template.csv`,
                data.mime_type || 'text/csv;charset=utf-8',
            );
        } finally {
            this.exportingClusterTemplate = false;
            await this.service.render();
        }
    }

    public viewClusterNode(node: any) {
        if (!node?.id) return;
        this.service.href('/kiera/nodes/' + node.id);
    }

    public isClusterNodeTerminalAvailable(node: any): boolean {
        const status = this.normalizeClusterNodeValue(node?.status);
        const deployStatus = this.normalizeClusterNodeValue(node?.deploy_status || node?.deploy_status_text);
        return status === 'deployed' || deployStatus === 'deployed';
    }

    public openClusterNodeSol(node: any) {
        if (!node?.id) return;
        const url = `/kiera/sol/${node.id}?name=${encodeURIComponent(node.name || 'Node #' + node.id)}`;
        const availWidth = window.screen?.availWidth || 1280;
        const availHeight = window.screen?.availHeight || 820;
        const width = Math.max(720, Math.min(1280, availWidth - 40));
        const height = Math.max(560, Math.min(820, availHeight - 60));
        const left = Math.max(0, Math.round((availWidth - width) / 2));
        const top = Math.max(0, Math.round((availHeight - height) / 2));
        const popup = window.open(
            url,
            `sol_${node.id}`,
            `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=no`
        );
        if (popup) popup.focus();
    }

    public openClusterNodeTerminal(node: any) {
        if (!node?.id) return;
        const url = `/kiera/terminal/${node.id}?name=${encodeURIComponent(node.name || 'Node #' + node.id)}`;
        const popup = window.open(url, `terminal_${node.id}`, 'width=980,height=680,menubar=no,toolbar=no,location=no,status=no');
        if (popup) popup.focus();
    }

    private clusterNodeRoleType(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority') return 'authority';
        if (role === 'member') return 'member';
        return 'computenode';
    }

    public clusterNodeRoleLabel(node: any): string {
        const role = this.clusterNodeRoleType(node);
        if (role === 'authority') return 'Authority';
        if (role === 'member') return 'Member';
        if (this.isClusterNodeUnassigned(node)) return 'Unassigned';
        return 'Compute';
    }

    public clusterNodeRoleBadgeClass(node: any): string {
        const role = this.clusterNodeRoleType(node);
        if (role === 'authority') return 'bg-emerald-100 text-emerald-700';
        if (role === 'member') return 'bg-blue-100 text-blue-700';
        if (this.isClusterNodeUnassigned(node)) return 'bg-amber-100 text-amber-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    private clusterNodeTreeKey(node: any): string {
        return `${this.clusterNodeRoleType(node)}:${String(node?.id || '')}`;
    }

    private clusterNodeTreeNodeRow(node: any, level: number, childrenCount: number = 0, counts: any = {}): any {
        const treeKey = this.clusterNodeTreeKey(node);
        return {
            kind: 'node',
            node,
            level,
            role: this.clusterNodeRoleType(node),
            treeKey,
            childrenCount,
            hasChildren: childrenCount > 0,
            collapsed: !!this.clusterNodeTreeCollapsed[treeKey],
            authorityCount: Number(counts.authorityCount || 0),
            memberCount: Number(counts.memberCount || 0),
            computeCount: Number(counts.computeCount || 0),
            totalCount: Number(counts.totalCount || 0),
        };
    }

    public clusterNodeTreeCountLabel(row: any): string {
        if (String(row?.role || '') === 'authority') {
            return `Total ${Number(row?.totalCount || 1)} · A${Number(row?.authorityCount || 1)}/M${Number(row?.memberCount || 0)}/C${Number(row?.computeCount || 0)}`;
        }
        if (String(row?.role || '') === 'member') {
            return `Compute ${Number(row?.computeCount || row?.childrenCount || 0)}`;
        }
        return String(Number(row?.childrenCount || 0));
    }

    public clusterNodeTreeCountTitle(row: any): string {
        if (String(row?.role || '') === 'authority') {
            return `Group total ${Number(row?.totalCount || 1)} VMs: Authority ${Number(row?.authorityCount || 1)}, Member ${Number(row?.memberCount || 0)}, Compute ${Number(row?.computeCount || 0)}`;
        }
        if (String(row?.role || '') === 'member') {
            return `${Number(row?.computeCount || row?.childrenCount || 0)} assigned Compute nodes`;
        }
        return '';
    }

    public clusterNodeTreeToggleIcon(row: any): string {
        if (!row?.hasChildren) return 'bx-minus';
        return row.collapsed ? 'bx-chevron-right' : 'bx-chevron-down';
    }

    public clusterNodeTreeRowClass(row: any): string {
        const role = String(row?.role || '');
        if (role === 'authority') return 'border-b border-emerald-100 bg-emerald-50 hover:bg-emerald-100';
        if (role === 'member') return 'border-b border-blue-100 bg-blue-50 hover:bg-blue-100';
        if (this.isClusterNodeUnassigned(row?.node)) return 'border-b border-amber-100 bg-amber-50 hover:bg-amber-100';
        return 'border-b border-gray-100 bg-white hover:bg-zinc-50';
    }

    public async toggleClusterNodeTreeRow(row: any, event?: any) {
        if (event?.stopPropagation) event.stopPropagation();
        if (!row?.hasChildren || !row.treeKey) return;
        this.clusterNodeTreeCollapsed = {
            ...(this.clusterNodeTreeCollapsed || {}),
            [row.treeKey]: !this.clusterNodeTreeCollapsed[row.treeKey],
        };
        await this.service.render();
    }

    public clusterNodeTreeRows(includeCollapsedChildren: boolean = false): any[] {
        const visibleNodes = this.filteredClusterNodes();
        const rows: any[] = [];
        const added = new Set<string>();
        const authorityNodes = visibleNodes.filter((node: any) => this.clusterNodeRoleType(node) === 'authority');
        const memberNodes = visibleNodes.filter((node: any) => this.clusterNodeRoleType(node) === 'member');
        const computeNodes = visibleNodes.filter((node: any) => this.clusterNodeRoleType(node) === 'computenode');

        const markNode = (node: any) => {
            if (node) added.add(String(node.id));
        };
        const pushNode = (node: any, level: number, childrenCount: number = 0, counts: any = {}) => {
            if (!node) return;
            rows.push(this.clusterNodeTreeNodeRow(node, level, childrenCount, counts));
            markNode(node);
        };
        const nodesAssignedTo = (server: any) => computeNodes.filter((node: any) => {
            return String(this.clusterRelayAssignedServer(node)?.id || '') === String(server?.id || '');
        });

        for (const authority of authorityNodes) {
            const authorityKey = this.clusterRelayDhcpGroupKey(authority);
            const members = memberNodes.filter((node: any) => this.clusterRelayDhcpGroupKey(node) === authorityKey);
            const directComputes = nodesAssignedTo(authority);
            const memberComputeCount = members.reduce((total: number, member: any) => total + nodesAssignedTo(member).length, 0);
            const computeCount = memberComputeCount + directComputes.length;
            const authorityChildrenCount = members.length + computeCount;
            pushNode(authority, 0, authorityChildrenCount, {
                authorityCount: 1,
                memberCount: members.length,
                computeCount,
                totalCount: 1 + members.length + computeCount,
            });

            const authorityCollapsed = !!this.clusterNodeTreeCollapsed[this.clusterNodeTreeKey(authority)];
            for (const member of members) {
                const memberComputes = nodesAssignedTo(member);
                markNode(member);
                memberComputes.forEach(markNode);
                if (authorityCollapsed && !includeCollapsedChildren) continue;
                pushNode(member, 1, memberComputes.length, {
                    memberCount: 1,
                    computeCount: memberComputes.length,
                    totalCount: 1 + memberComputes.length,
                });
                if (this.clusterNodeTreeCollapsed[this.clusterNodeTreeKey(member)] && !includeCollapsedChildren) continue;
                for (const compute of memberComputes) pushNode(compute, 2);
            }
            const directUnaddedComputes = directComputes.filter((node: any) => !added.has(String(node.id)));
            directUnaddedComputes.forEach(markNode);
            if (!authorityCollapsed || includeCollapsedChildren) {
                for (const compute of directUnaddedComputes) pushNode(compute, 1);
            }
        }

        const orphanMembers = memberNodes.filter((node: any) => !added.has(String(node.id)));
        for (const member of orphanMembers) {
            const memberComputes = nodesAssignedTo(member).filter((node: any) => !added.has(String(node.id)));
            memberComputes.forEach(markNode);
            pushNode(member, 0, memberComputes.length, {
                memberCount: 1,
                computeCount: memberComputes.length,
                totalCount: 1 + memberComputes.length,
            });
            if (this.clusterNodeTreeCollapsed[this.clusterNodeTreeKey(member)] && !includeCollapsedChildren) continue;
            for (const compute of memberComputes) {
                pushNode(compute, 1);
            }
        }

        const remainingComputes = computeNodes.filter((node: any) => !added.has(String(node.id)));
        for (const compute of remainingComputes) pushNode(compute, 0);
        return rows;
    }

    public async openClusterNodeEdit(node: any) {
        if (!node) return;
        this.editingClusterNode = node;
        this.editingClusterNodeForm = {
            id: node.id,
            cluster_relay_role: String(node.cluster_relay_role || ''),
            cluster_relay_dhcp_group_key: this.clusterRelayDhcpGroupKey(node),
            cluster_relay_id: String(node.cluster_relay_id || ''),
        };
        this.clusterNodeEditMessage = '';
        await this.service.render();
    }

    public async closeClusterNodeEdit() {
        if (this.editingClusterNodeSaving) return;
        this.editingClusterNode = null;
        this.editingClusterNodeForm = null;
        this.clusterNodeEditMessage = '';
        await this.service.render();
    }

    private clusterNodeEditDraft(): any {
        return {
            ...(this.editingClusterNode || {}),
            ...(this.editingClusterNodeForm || {}),
        };
    }

    public clusterNodeEditSubnetOptions(): any[] {
        const draft = this.clusterNodeEditDraft();
        return this.clusterRelaySubnetOptionsForNode(draft).map((subnet: any) => ({
            ...subnet,
            label: this.clusterRelayCompactSubnetLabel(subnet),
        }));
    }

    private clusterRelayCompactSubnetLabel(subnet: any): string {
        const name = String(subnet?.name || '').trim();
        if (name) return name;
        const vlanId = Number(subnet?.vlan_id || 0);
        if (vlanId > 0) return `VLAN ${vlanId}`;
        const id = String(subnet?.id || '').trim();
        if (id) return `Subnet #${id}`;
        const label = String(subnet?.label || '').trim();
        if (label.includes(' · ')) return label.split(' · ')[0].trim();
        return label || String(subnet?.key || '').trim() || '-';
    }

    public clusterNodeEditAuthorityOptions(): any[] {
        const draft = this.clusterNodeEditDraft();
        return this.clusterRelayAuthorityOptions(draft);
    }

    public clusterNodeEditRelayServerOptions(): any[] {
        const draft = this.clusterNodeEditDraft();
        return this.clusterRelayServerNodes().filter((server: any) => String(server.id) !== String(draft.id));
    }

    public async onClusterNodeEditRoleChanged() {
        if (!this.editingClusterNodeForm) return;
        const role = String(this.editingClusterNodeForm.cluster_relay_role || '').trim();
        const draft = this.clusterNodeEditDraft();
        if (role === 'authority') {
            this.editingClusterNodeForm.cluster_relay_dhcp_group_key = this.promotedClusterRelayAuthorityGroupKey(draft);
            this.editingClusterNodeForm.cluster_relay_id = '';
        } else if (role === 'member') {
            const authority = this.clusterNodeEditAuthorityOptions()[0];
            this.editingClusterNodeForm.cluster_relay_dhcp_group_key = authority?.groupKey || '';
            this.editingClusterNodeForm.cluster_relay_id = '';
        } else {
            this.editingClusterNodeForm.cluster_relay_dhcp_group_key = this.defaultClusterRelayGroupKey(draft);
            this.editingClusterNodeForm.cluster_relay_id = this.clusterNodeEditRelayServerOptions()[0]?.id || '';
        }
        this.clusterNodeEditMessage = '';
        await this.service.render();
    }

    public clusterNodeEditCanSave(): boolean {
        if (!this.editingClusterNode || !this.editingClusterNodeForm || this.editingClusterNodeSaving) return false;
        const role = String(this.editingClusterNodeForm.cluster_relay_role || '').trim();
        if (role === 'authority') return true;
        if (role === 'member') {
            return this.clusterNodeEditAuthorityOptions().length > 0
                && !!String(this.editingClusterNodeForm.cluster_relay_dhcp_group_key || '').trim();
        }
        return this.clusterNodeEditRelayServerOptions().length > 0;
    }

    public async saveClusterNodeEdit() {
        if (!this.clusterNodeEditCanSave()) return;
        const node = (this.clusterNodes || []).find((item: any) => String(item.id) === String(this.editingClusterNode?.id));
        if (!node) {
            await this.closeClusterNodeEdit();
            return;
        }

        const before = {
            cluster_relay_role: node.cluster_relay_role,
            cluster_relay_dhcp_group_key: node.cluster_relay_dhcp_group_key,
            cluster_relay_id: node.cluster_relay_id,
            cluster_relay_excluded: node.cluster_relay_excluded,
        };
        const role = String(this.editingClusterNodeForm.cluster_relay_role || '').trim();
        this.editingClusterNodeSaving = true;
        this.clusterNodeEditMessage = 'Saving node relay settings...';
        await this.service.render();

        node.cluster_relay_role = role;
        node.cluster_relay_excluded = false;
        if (role === 'authority') {
            node.cluster_relay_dhcp_group_key = String(this.editingClusterNodeForm.cluster_relay_dhcp_group_key || '').trim()
                || this.promotedClusterRelayAuthorityGroupKey(node);
            node.cluster_relay_id = '';
        } else if (role === 'member') {
            node.cluster_relay_dhcp_group_key = String(this.editingClusterNodeForm.cluster_relay_dhcp_group_key || '').trim();
            node.cluster_relay_id = '';
        } else {
            node.cluster_relay_dhcp_group_key = this.defaultClusterRelayGroupKey(node);
            node.cluster_relay_id = String(this.editingClusterNodeForm.cluster_relay_id || '').trim();
        }

        const groupId = await this.ensureClusterRelayGroupSaved(false);
        this.editingClusterNodeSaving = false;
        if (groupId) {
            this.relayMessage = 'Node relay settings saved.';
            await this.closeClusterNodeEdit();
            return;
        }

        node.cluster_relay_role = before.cluster_relay_role;
        node.cluster_relay_dhcp_group_key = before.cluster_relay_dhcp_group_key;
        node.cluster_relay_id = before.cluster_relay_id;
        node.cluster_relay_excluded = before.cluster_relay_excluded;
        this.normalizeClusterRelayConfig();
        this.clusterNodeEditMessage = this.relayMessage || 'Failed to save node relay settings.';
        await this.service.render();
    }

    public async openClusterNodeBulkEdit() {
        const nodes = this.selectedClusterNodes();
        if (nodes.length === 0) return;
        const relay = this.clusterNodeBulkEditRelayServerOptions()[0];
        this.clusterNodeBulkEditForm = {
            cluster_relay_role: '',
            cluster_relay_dhcp_group_key: '',
            cluster_relay_id: relay?.id || '',
        };
        this.clusterNodeBulkEditMessage = '';
        this.showClusterNodeBulkEditModal = true;
        await this.service.render();
    }

    public async closeClusterNodeBulkEdit() {
        if (this.clusterNodeBulkEditSaving) return;
        this.showClusterNodeBulkEditModal = false;
        this.clusterNodeBulkEditForm = null;
        this.clusterNodeBulkEditMessage = '';
        await this.service.render();
    }

    public clusterNodeBulkEditSubnetOptions(): any[] {
        return (this.relaySubnets || []).map((subnet: any) => ({
            ...subnet,
            label: this.clusterRelayCompactSubnetLabel(subnet),
        }));
    }

    public clusterNodeBulkEditAuthorityOptions(): any[] {
        const selectedIds = new Set(this.selectedClusterNodeIdsArray().map((nodeId: number) => String(nodeId)));
        return this.clusterRelayAuthorityOptions().filter((authority: any) => !selectedIds.has(String(authority.node?.id || '')));
    }

    public clusterNodeBulkEditRelayServerOptions(): any[] {
        const selectedIds = new Set(this.selectedClusterNodeIdsArray().map((nodeId: number) => String(nodeId)));
        return this.clusterRelayServerNodes().filter((server: any) => !selectedIds.has(String(server.id)));
    }

    public async onClusterNodeBulkEditRoleChanged() {
        if (!this.clusterNodeBulkEditForm) return;
        const role = String(this.clusterNodeBulkEditForm.cluster_relay_role || '').trim();
        if (role === 'authority') {
            this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key = this.clusterNodeBulkEditSubnetOptions()[0]?.key || '';
            this.clusterNodeBulkEditForm.cluster_relay_id = '';
        } else if (role === 'member') {
            this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key = this.clusterNodeBulkEditAuthorityOptions()[0]?.groupKey || '';
            this.clusterNodeBulkEditForm.cluster_relay_id = '';
        } else {
            this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key = '';
            this.clusterNodeBulkEditForm.cluster_relay_id = this.clusterNodeBulkEditRelayServerOptions()[0]?.id || '';
        }
        this.clusterNodeBulkEditMessage = '';
        await this.service.render();
    }

    public clusterNodeBulkEditCanSave(): boolean {
        if (!this.showClusterNodeBulkEditModal || !this.clusterNodeBulkEditForm || this.clusterNodeBulkEditSaving) return false;
        const nodes = this.selectedClusterNodes();
        if (nodes.length === 0) return false;
        const role = String(this.clusterNodeBulkEditForm.cluster_relay_role || '').trim();
        if (role === 'authority') {
            return nodes.length === 1 && !!String(this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key || '').trim();
        }
        if (role === 'member') {
            return this.clusterNodeBulkEditAuthorityOptions().length > 0
                && !!String(this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key || '').trim();
        }
        return this.clusterNodeBulkEditRelayServerOptions().length > 0
            && !!String(this.clusterNodeBulkEditForm.cluster_relay_id || '').trim();
    }

    public async saveClusterNodeBulkEdit() {
        if (!this.clusterNodeBulkEditCanSave()) return;
        const nodes = this.selectedClusterNodes();
        const snapshots = nodes.map((node: any) => ({
            node,
            cluster_relay_role: node.cluster_relay_role,
            cluster_relay_dhcp_group_key: node.cluster_relay_dhcp_group_key,
            cluster_relay_id: node.cluster_relay_id,
            cluster_relay_excluded: node.cluster_relay_excluded,
        }));
        const role = String(this.clusterNodeBulkEditForm.cluster_relay_role || '').trim();
        this.clusterNodeBulkEditSaving = true;
        this.clusterNodeBulkEditMessage = `Saving ${nodes.length} node(s)...`;
        await this.service.render();

        for (const node of nodes) {
            node.cluster_relay_role = role;
            node.cluster_relay_excluded = false;
            if (role === 'authority') {
                node.cluster_relay_dhcp_group_key = String(this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key || '').trim()
                    || this.promotedClusterRelayAuthorityGroupKey(node);
                node.cluster_relay_id = '';
            } else if (role === 'member') {
                node.cluster_relay_dhcp_group_key = String(this.clusterNodeBulkEditForm.cluster_relay_dhcp_group_key || '').trim();
                node.cluster_relay_id = '';
            } else {
                node.cluster_relay_dhcp_group_key = this.defaultClusterRelayGroupKey(node);
                node.cluster_relay_id = String(this.clusterNodeBulkEditForm.cluster_relay_id || '').trim();
            }
        }

        const groupId = await this.ensureClusterRelayGroupSaved(false);
        this.clusterNodeBulkEditSaving = false;
        if (groupId) {
            this.relayMessage = `${nodes.length} selected node(s) updated.`;
            await this.closeClusterNodeBulkEdit();
            return;
        }

        for (const snapshot of snapshots) {
            snapshot.node.cluster_relay_role = snapshot.cluster_relay_role;
            snapshot.node.cluster_relay_dhcp_group_key = snapshot.cluster_relay_dhcp_group_key;
            snapshot.node.cluster_relay_id = snapshot.cluster_relay_id;
            snapshot.node.cluster_relay_excluded = snapshot.cluster_relay_excluded;
        }
        this.normalizeClusterRelayConfig();
        this.clusterNodeBulkEditMessage = this.relayMessage || 'Failed to save selected node relay settings.';
        await this.service.render();
    }

    private clusterRelayGroup(): any {
        return this.item?.relay_group || null;
    }

    private defaultClusterRelayGroupKey(node: any): string {
        const subnetId = String(node?.dhcp_domain_subnet_id || '').trim();
        if (subnetId) return `id:${subnetId}`;
        const domainKey = String(node?.dhcp_domain_key || '').trim();
        if (domainKey) return domainKey;
        const vlanId = String(node?.dhcp_domain_vlan_id || '').trim();
        if (vlanId && vlanId !== '0') return `vlan:${vlanId}`;
        const cidr = String(node?.dhcp_domain_cidr || '').trim();
        if (cidr) return `cidr:${cidr}`;
        return 'default';
    }

    public clusterRelayDhcpGroupKey(node: any): string {
        return String(node?.cluster_relay_dhcp_group_key || '').trim() || this.defaultClusterRelayGroupKey(node);
    }

    private clusterRelayNodeDomainKeys(node: any): string[] {
        const keys: string[] = [];
        const pushKey = (value: any) => {
            const key = String(value || '').trim();
            if (key && !keys.includes(key)) keys.push(key);
        };
        const subnetId = String(node?.dhcp_domain_subnet_id || '').trim();
        if (subnetId) pushKey(`id:${subnetId}`);
        pushKey(node?.dhcp_domain_key);
        const vlanId = String(node?.dhcp_domain_vlan_id || '').trim();
        if (vlanId && vlanId !== '0') pushKey(`vlan:${vlanId}`);
        const cidr = String(node?.dhcp_domain_cidr || '').trim();
        if (cidr) pushKey(`cidr:${cidr}`);
        pushKey(this.defaultClusterRelayGroupKey(node));
        return keys;
    }

    private clusterRelayPreferredServerForNode(node: any): any {
        const servers = this.clusterRelayServerNodes();
        if (servers.length === 0) return null;
        const sameGroup = servers.filter((server: any) => this.clusterRelayNodeMatchesGroupKey(node, this.clusterRelayDhcpGroupKey(server)));
        return sameGroup.find((server: any) => String(server.cluster_relay_role || '') === 'authority') || sameGroup[0] || null;
    }

    private clusterRelayFallbackServerForNode(node: any): any {
        const preferred = this.clusterRelayPreferredServerForNode(node);
        if (preferred) return preferred;
        const hasKnownDomain = this.clusterRelayNodeDomainKeys(node).some((key: string) => key && key !== 'default');
        return hasKnownDomain ? null : (this.clusterRelayServerNodes()[0] || null);
    }

    private clusterRelayNodeMatchesGroupKey(node: any, groupKey: any): boolean {
        const key = String(groupKey || '').trim();
        return !!key && this.clusterRelayNodeDomainKeys(node).includes(key);
    }

    private clusterRelayNodeMatchesServer(node: any, server: any): boolean {
        return !!server && this.clusterRelayNodeMatchesGroupKey(node, this.clusterRelayDhcpGroupKey(server));
    }

    private promotedClusterRelayAuthorityGroupKey(node: any): string {
        const currentKey = String(node?.cluster_relay_dhcp_group_key || '').trim();
        const defaultKey = this.defaultClusterRelayGroupKey(node);
        const usedKeys = new Set(
            this.clusterRelayAuthorityNodes()
                .filter((item: any) => String(item.id) !== String(node?.id))
                .map((item: any) => this.clusterRelayDhcpGroupKey(item))
        );
        if (currentKey && !currentKey.startsWith('authority:') && !usedKeys.has(currentKey)) return currentKey;
        if (defaultKey && defaultKey !== 'default' && !usedKeys.has(defaultKey)) return defaultKey;
        const unusedSubnet = (this.relaySubnets || []).find((subnet: any) => {
            const key = String(subnet.key || '').trim();
            return key && !usedKeys.has(key);
        });
        if (unusedSubnet) return String(unusedSubnet.key || '');
        if (defaultKey && defaultKey !== 'default') return defaultKey;
        return currentKey && !currentKey.startsWith('authority:') ? currentKey : '';
    }

    public clusterRelayDhcpGroupLabel(node: any): string {
        const subnet = this.clusterRelaySubnetForKey(this.clusterRelayDhcpGroupKey(node));
        if (subnet) return subnet.label;
        return String(node?.dhcp_domain_label || '').trim() || this.clusterRelayDhcpGroupKey(node);
    }

    public clusterRelaySubnetForKey(key: any): any {
        const normalized = String(key || '').trim();
        if (!normalized) return null;
        return (this.relaySubnets || []).find((subnet: any) => String(subnet.key || '') === normalized) || null;
    }

    public clusterRelaySubnetOptionsForNode(node: any): any[] {
        const key = this.clusterRelayDhcpGroupKey(node);
        const options = [...(this.relaySubnets || [])];
        if (key && !this.clusterRelaySubnetForKey(key) && !key.startsWith('authority:')) {
            options.unshift({
                key,
                label: String(node?.dhcp_domain_label || '').trim() || key,
            });
        }
        return options;
    }

    public isClusterRelayServer(node: any): boolean {
        return ['authority', 'member'].includes(String(node?.cluster_relay_role || '').trim().toLowerCase());
    }

    public clusterRelayDhcpLabel(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority') return 'Authority';
        if (role === 'member') return 'Next Server';
        return 'Client';
    }

    public clusterRelayDhcpBadgeClass(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority') return 'bg-emerald-100 text-emerald-700';
        if (role === 'member') return 'bg-blue-100 text-blue-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public clusterRelayCandidateServerNodes(): any[] {
        return (this.clusterNodes || []).filter((node: any) => this.isClusterRelayServer(node));
    }

    public isClusterRelayExcluded(node: any): boolean {
        return !!node?.cluster_relay_excluded;
    }

    public clusterRelayServerNodes(): any[] {
        return this.clusterRelayCandidateServerNodes().filter((node: any) => !this.isClusterRelayExcluded(node));
    }

    public clusterRelayExcludedServerNodes(): any[] {
        return this.clusterRelayCandidateServerNodes().filter((node: any) => this.isClusterRelayExcluded(node));
    }

    private clusterRelayActiveServerIdSet(): Set<string> {
        return new Set(this.clusterRelayServerNodes().map((node: any) => String(node.id)));
    }

    private clusterRelayCandidateServerIdSet(): Set<string> {
        return new Set(this.clusterRelayCandidateServerNodes().map((node: any) => String(node.id)));
    }

    public isClusterRelayHiddenByInactiveServer(node: any): boolean {
        if (!node || this.isClusterRelayServer(node)) return false;
        if (this.clusterRelayCandidateServerNodes().length === 0) return false;
        if (this.clusterRelayServerNodes().length === 0) return true;
        const assigned = String(node.cluster_relay_id || '');
        return !!assigned && this.clusterRelayCandidateServerIdSet().has(assigned) && !this.clusterRelayActiveServerIdSet().has(assigned);
    }

    public clusterRelayCandidateComputingNodes(): any[] {
        return (this.clusterNodes || []).filter((node: any) => {
            return !this.isClusterRelayServer(node) && !this.isClusterRelayHiddenByInactiveServer(node);
        });
    }

    public clusterRelayComputingNodes(): any[] {
        return this.clusterRelayCandidateComputingNodes().filter((node: any) => !this.isClusterRelayExcluded(node) && !node.cluster_relay_unassigned);
    }

    public clusterRelayExcludedComputingNodes(): any[] {
        return (this.clusterNodes || []).filter((node: any) => {
            return !this.isClusterRelayServer(node) && (this.isClusterRelayExcluded(node) || this.isClusterRelayHiddenByInactiveServer(node));
        });
    }

    public clusterRelayUnassignedComputingNodes(): any[] {
        return (this.clusterNodes || []).filter((node: any) => {
            return !this.isClusterRelayServer(node)
                && !this.isClusterRelayExcluded(node)
                && !!node.cluster_relay_unassigned
                && !String(node.cluster_relay_id || '').trim();
        });
    }

    public clusterRelayExcludedWorkNodes(): any[] {
        const rows: any[] = [];
        for (const node of this.clusterNodes || []) {
            if (this.isClusterRelayServer(node)) {
                if (this.isClusterRelayExcluded(node)) rows.push(node);
                continue;
            }
            if (this.isClusterRelayExcluded(node) || this.isClusterRelayHiddenByInactiveServer(node)) {
                rows.push(node);
            }
        }
        return rows;
    }

    private relayDeployTargetGroupKey(): string {
        return String(this.relayDeployTarget?.groupKey || '').trim();
    }

    private relayDeployHasTarget(): boolean {
        return this.relayView === 'deploy' && !!this.relayDeployTargetGroupKey();
    }

    private relayDeployServerMatchesTarget(server: any): boolean {
        const groupKey = this.relayDeployTargetGroupKey();
        if (!groupKey) return true;
        return this.clusterRelayDhcpGroupKey(server) === groupKey;
    }

    public relayDeployCandidateServerNodes(): any[] {
        const nodes = this.clusterRelayCandidateServerNodes();
        if (!this.relayDeployHasTarget()) return nodes;
        return nodes.filter((server: any) => this.relayDeployServerMatchesTarget(server));
    }

    public relayDeployServerNodes(): any[] {
        return this.relayDeployCandidateServerNodes().filter((node: any) => !this.isClusterRelayExcluded(node));
    }

    public relayDeployExcludedServerNodes(): any[] {
        return this.relayDeployCandidateServerNodes().filter((node: any) => this.isClusterRelayExcluded(node));
    }

    private relayDeployCandidateServerIdSet(): Set<string> {
        return new Set(this.relayDeployCandidateServerNodes().map((node: any) => String(node.id)));
    }

    private relayDeployComputingNodeMatchesTarget(node: any): boolean {
        const groupKey = this.relayDeployTargetGroupKey();
        if (!groupKey) return true;
        const assigned = String(node?.cluster_relay_id || '');
        if (assigned && this.relayDeployCandidateServerIdSet().has(assigned)) return true;
        return this.clusterRelayNodeMatchesGroupKey(node, groupKey) || this.clusterRelayDhcpGroupKey(node) === groupKey;
    }

    public relayDeployCandidateComputingNodes(): any[] {
        const nodes = this.clusterRelayCandidateComputingNodes();
        if (!this.relayDeployHasTarget()) return nodes;
        return nodes.filter((node: any) => this.relayDeployComputingNodeMatchesTarget(node));
    }

    public relayDeployComputingNodes(): any[] {
        return this.relayDeployCandidateComputingNodes().filter((node: any) => !this.isClusterRelayExcluded(node) && !node.cluster_relay_unassigned);
    }

    public relayDeployExcludedComputingNodes(): any[] {
        const nodes = this.clusterRelayExcludedComputingNodes();
        if (!this.relayDeployHasTarget()) return nodes;
        return nodes.filter((node: any) => this.relayDeployComputingNodeMatchesTarget(node));
    }

    public relayDeployExcludedWorkNodes(): any[] {
        return [
            ...this.relayDeployExcludedServerNodes(),
            ...this.relayDeployExcludedComputingNodes(),
        ];
    }

    public relayDeployConfigValid(): boolean {
        const servers = this.relayDeployServerNodes();
        if (servers.length === 0) return false;
        const groups: any = {};
        for (const server of servers) {
            const key = this.clusterRelayDhcpGroupKey(server);
            if (!groups[key]) groups[key] = 0;
            if (String(server.cluster_relay_role || '') === 'authority') groups[key] += 1;
        }
        return Object.values(groups).every((count: any) => Number(count) === 1);
    }

    public clusterRelayAuthorityNodes(): any[] {
        return this.clusterRelayServerNodes().filter((node: any) => String(node.cluster_relay_role || '') === 'authority');
    }

    public relayDeployAuthorityNodes(): any[] {
        return this.relayDeployServerNodes().filter((node: any) => String(node.cluster_relay_role || '') === 'authority');
    }

    public clusterRelayAuthorityOptions(excludeNode?: any): any[] {
        const seen = new Set<string>();
        return this.clusterRelayAuthorityNodes()
            .filter((node: any) => String(node.id) !== String(excludeNode?.id || ''))
            .map((node: any) => {
                const groupKey = this.clusterRelayDhcpGroupKey(node);
                return {
                    node,
                    groupKey,
                    label: `${node.name || 'Node'} (#${node.id})`,
                    meta: this.clusterRelayDhcpGroupLabel(node),
                };
            })
            .filter((item: any) => {
                if (seen.has(item.groupKey)) return false;
                seen.add(item.groupKey);
                return true;
            });
    }

    public clusterRelayAuthorityForNode(node: any): any {
        if (!node || !this.isClusterRelayServer(node)) return null;
        const groupKey = this.clusterRelayDhcpGroupKey(node);
        return this.clusterRelayAuthorityNodes().find((server: any) =>
            this.clusterRelayDhcpGroupKey(server) === groupKey
        ) || null;
    }

    public clusterRelayAuthorityLabel(node: any): string {
        if (!node || !this.isClusterRelayServer(node)) return '-';
        const authority = this.clusterRelayAuthorityForNode(node);
        if (!authority) return 'No authority';
        return `${authority.name || 'Node'} (#${authority.id})`;
    }

    public clusterRelayServerName(serverId: any): string {
        const server = this.clusterRelayServerNodes().find((node: any) => String(node.id) === String(serverId));
        return server?.name || '';
    }

    public clusterRelayAssignedServer(node: any): any {
        if (!node || this.isClusterRelayServer(node)) return null;
        return this.clusterRelayServerNodes().find((server: any) => String(server.id) === String(node.cluster_relay_id)) || null;
    }

    public clusterRelayAssignedServerLabel(node: any): string {
        if (!node) return '-';
        if (this.isClusterRelayServer(node)) return '-';
        const server = this.clusterRelayAssignedServer(node);
        return server ? server.name : 'Unassigned';
    }

    public clusterRelayConfigValid(): boolean {
        const servers = this.clusterRelayServerNodes();
        if (servers.length === 0) return false;
        const groups: any = {};
        for (const server of servers) {
            const key = this.clusterRelayDhcpGroupKey(server);
            if (!groups[key]) groups[key] = 0;
            if (String(server.cluster_relay_role || '') === 'authority') groups[key] += 1;
        }
        return Object.values(groups).every((count: any) => Number(count) === 1);
    }

    private normalizeClusterRelayConfig() {
        const serverIds = new Set(this.clusterRelayServerNodes().map((node: any) => String(node.id)));
        const candidateServerIds = this.clusterRelayCandidateServerIdSet();
        const groups: any = {};
        for (const node of this.clusterRelayCandidateServerNodes()) {
            const key = this.clusterRelayDhcpGroupKey(node);
            if (!groups[key]) groups[key] = [];
            groups[key].push(node);
            node.cluster_relay_id = '';
            node.cluster_relay_unassigned = false;
            node.cluster_relay_dhcp_group_key = key;
            if (String(node.cluster_relay_role || '') === 'authority' && key.startsWith('authority:')) {
                node.cluster_relay_dhcp_group_key = this.promotedClusterRelayAuthorityGroupKey(node);
            }
        }

        const authorityOptions = this.clusterRelayAuthorityOptions();
        const authorityGroupKeys = new Set(authorityOptions.map((item: any) => item.groupKey));
        for (const node of this.clusterRelayCandidateServerNodes()) {
            if (String(node.cluster_relay_role || '') !== 'member') continue;
            const currentKey = this.clusterRelayDhcpGroupKey(node);
            if (!this.isClusterRelayExcluded(node) && !authorityGroupKeys.has(currentKey) && authorityOptions.length > 0) {
                node.cluster_relay_dhcp_group_key = authorityOptions[0].groupKey;
            }
        }

        for (const node of (this.clusterNodes || []).filter((item: any) => !this.isClusterRelayServer(item))) {
            if (this.isClusterRelayExcluded(node)) {
                continue;
            }
            if (node.cluster_relay_unassigned) {
                node.cluster_relay_id = '';
                continue;
            }
            const assigned = String(node.cluster_relay_id || '');
            const assignedServer = this.clusterRelayServerNodes().find((server: any) => String(server.id) === assigned) || null;
            if (assignedServer && !this.clusterRelayNodeMatchesServer(node, assignedServer)) {
                const relay = this.clusterRelayFallbackServerForNode(node);
                node.cluster_relay_id = relay?.id || '';
                node.cluster_relay_unassigned = !relay;
                continue;
            }
            if (!assigned || (!serverIds.has(assigned) && !candidateServerIds.has(assigned))) {
                const relay = this.clusterRelayFallbackServerForNode(node);
                node.cluster_relay_id = relay?.id || '';
                node.cluster_relay_unassigned = !relay;
            }
        }
    }

    private relayBoundedInteger(value: any, defaultValue: number, minimum: number, maximum: number): number {
        const parsed = Number.parseInt(String(value), 10);
        if (Number.isNaN(parsed)) return defaultValue;
        return Math.min(maximum, Math.max(minimum, parsed));
    }

    private normalizedRelayWindowSettings(): any {
        return {
            window_size: this.relayBoundedInteger(this.relayWindowSize, this.relayDefaultWindowSize, 1, this.relayMaxWindowSize),
            inter_window_gap_seconds: this.relayBoundedInteger(this.relayWindowGapSeconds, this.relayDefaultWindowGapSeconds, 0, this.relayMaxWindowGapSeconds)
        };
    }

    private applyRelayWindowSettings(settings: any) {
        settings = settings && typeof settings === 'object' ? settings : {};
        this.relayWindowSize = this.relayBoundedInteger(
            settings.window_size
                ?? settings.per_authority_window_size
                ?? settings.window_count
                ?? settings.wave_size
                ?? settings.per_authority_wave_size
                ?? settings.wave_count,
            this.relayDefaultWindowSize,
            1,
            this.relayMaxWindowSize
        );
        this.relayWindowGapSeconds = this.relayBoundedInteger(
            settings.inter_window_gap_seconds
                ?? settings.window_gap_seconds
                ?? settings.gap_seconds
                ?? settings.inter_wave_gap_seconds
                ?? settings.wave_gap_seconds,
            this.relayDefaultWindowGapSeconds,
            0,
            this.relayMaxWindowGapSeconds
        );
    }

    public async onClusterRelayWindowSettingsChanged() {
        await this.autoSaveClusterRelayGroup('Relay window settings saved.');
    }

    private applyClusterRelayConfig() {
        const relayGroup = this.clusterRelayGroup();
        const relayServers = relayGroup?.relay_servers || [];
        const computingNodes = relayGroup?.computing_nodes || [];
        const nodeSelection = relayGroup?.node_selection && typeof relayGroup.node_selection === 'object'
            ? relayGroup.node_selection
            : {};
        this.relayDomainMetadata = nodeSelection.relay_domain_metadata && typeof nodeSelection.relay_domain_metadata === 'object'
            ? { ...nodeSelection.relay_domain_metadata }
            : {};
        this.applyRelayWindowSettings(
            nodeSelection.compute_window_settings
            || nodeSelection.window_settings
            || nodeSelection.compute_wave_settings
            || nodeSelection.wave_settings
        );
        const excludedNodeIdList = Array.isArray(nodeSelection.excluded_node_ids)
            ? nodeSelection.excluded_node_ids
            : [];
        const excludedNodeIds = new Set(excludedNodeIdList.map((nodeId: any) => String(nodeId)));
        const relayServerConfigs = Array.isArray(nodeSelection.relay_server_configs)
            ? nodeSelection.relay_server_configs
            : [];
        const allAssignments = nodeSelection.all_assignments && typeof nodeSelection.all_assignments === 'object'
            ? nodeSelection.all_assignments
            : {};
        const unassignedComputingNodeIds = new Set((Array.isArray(nodeSelection.unassigned_computing_node_ids)
            ? nodeSelection.unassigned_computing_node_ids
            : []).map((nodeId: any) => String(nodeId)));
        const serverByNodeId: any = {};
        const assignedByNodeId: any = {};

        for (const server of relayServers) {
            const nodeId = String(server.node_id || '');
            if (!nodeId) continue;
            serverByNodeId[nodeId] = server;
        }
        for (const server of relayServerConfigs) {
            const nodeId = String(server.node_id || server.id || '');
            if (!nodeId || serverByNodeId[nodeId]) continue;
            if (server.excluded) excludedNodeIds.add(nodeId);
            serverByNodeId[nodeId] = server;
        }
        for (const node of computingNodes) {
            const nodeId = String(node.node_id || '');
            if (!nodeId) continue;
            assignedByNodeId[nodeId] = node;
        }
        for (const [relayServerId, nodeIds] of Object.entries(allAssignments)) {
            if (!Array.isArray(nodeIds)) continue;
            for (const nodeId of nodeIds as any[]) {
                const nodeKey = String(nodeId || '');
                if (!nodeKey || assignedByNodeId[nodeKey]) continue;
                assignedByNodeId[nodeKey] = {
                    node_id: nodeId,
                    relay_server_id: relayServerId,
                    relay_server_node_id: relayServerId,
                };
            }
        }

        const hasPersistedRelay = Object.keys(serverByNodeId).length > 0 || Object.keys(assignedByNodeId).length > 0;
        const legacyHead = !hasPersistedRelay
            ? (this.clusterNodes || []).find((node: any) => Number(node.is_cluster_head || 0) === 1)
            : null;

        for (const node of this.clusterNodes || []) {
            const nodeKey = String(node.id);
            const server = serverByNodeId[nodeKey];
            const assignment = assignedByNodeId[nodeKey];
            node.cluster_relay_excluded = excludedNodeIds.has(nodeKey);
            node.cluster_relay_dhcp_group_key = server?.dhcp_group_key || this.defaultClusterRelayGroupKey(node);
            if (server) {
                node.cluster_relay_unassigned = false;
                node.cluster_relay_role = Number(server.is_dhcp_server || 0) === 1 ? 'authority' : 'member';
                node.cluster_relay_server_row_id = server.id || '';
                node.cluster_relay_id = '';
            } else if (legacyHead && String(legacyHead.id) === nodeKey) {
                node.cluster_relay_unassigned = false;
                node.cluster_relay_role = 'authority';
                node.cluster_relay_server_row_id = '';
                node.cluster_relay_id = '';
            } else {
                node.cluster_relay_unassigned = unassignedComputingNodeIds.has(nodeKey);
                node.cluster_relay_role = '';
                node.cluster_relay_server_row_id = '';
                node.cluster_relay_id = node.cluster_relay_unassigned ? '' : (assignment?.relay_server_node_id || assignment?.relay_server_id || (legacyHead?.id || ''));
            }
        }

        if (relayGroup?.id) this.relayCreatedId = relayGroup.id;
        if (relayGroup?.name && !this.relayName) this.relayName = relayGroup.name;
        this.normalizeClusterRelayConfig();
    }

    public async onClusterRelayRoleChanged(node: any) {
        if (!node) return;
        const role = String(node.cluster_relay_role || '').trim();
        if (role === 'authority') {
            node.cluster_relay_excluded = false;
            node.cluster_relay_dhcp_group_key = this.promotedClusterRelayAuthorityGroupKey(node);
        } else if (role === 'member') {
            node.cluster_relay_excluded = false;
            const authority = this.clusterRelayAuthorityForNode(node) || this.clusterRelayAuthorityOptions(node)[0]?.node;
            if (authority) {
                node.cluster_relay_dhcp_group_key = this.clusterRelayDhcpGroupKey(authority);
            }
        }
        this.normalizeClusterRelayConfig();
        await this.autoSaveClusterRelayGroup('Relay DHCP role saved.');
    }

    public async onClusterRelayAuthorityGroupChanged(node: any) {
        if (!node || String(node.cluster_relay_role || '') !== 'authority') return;
        node.cluster_relay_dhcp_group_key = this.clusterRelayDhcpGroupKey(node);
        this.normalizeClusterRelayConfig();
        await this.autoSaveClusterRelayGroup('Relay DHCP authority group saved.');
    }

    public async onClusterRelayAuthorityMembershipChanged(node: any) {
        if (!node || String(node.cluster_relay_role || '') !== 'member') return;
        node.cluster_relay_dhcp_group_key = this.clusterRelayDhcpGroupKey(node);
        this.normalizeClusterRelayConfig();
        await this.autoSaveClusterRelayGroup('Relay DHCP authority membership saved.');
    }

    public async onClusterRelayAssignmentChanged() {
        for (const node of this.clusterNodes || []) {
            if (!this.isClusterRelayServer(node) && String(node.cluster_relay_id || '').trim()) {
                node.cluster_relay_unassigned = false;
            }
        }
        this.normalizeClusterRelayConfig();
        await this.autoSaveClusterRelayGroup('Relay assignment saved.');
    }

    private refreshRelayWorkerStatusFromSelection() {
        const nextStatus: any = {};
        for (const node of this.clusterRelayWorkerNodes()) {
            const current = this.relayNodeDeployStatus[node.id] || null;
            const currentStatus = this.relayNormalizedStatus(current?.status);
            nextStatus[node.id] = currentStatus && currentStatus !== 'pending'
                ? current
                : this.relayWorkerDeploymentStateFromNode(node);
        }
        this.relayNodeDeployStatus = nextStatus;
        this.updateRelayDeployStats();
    }

    public async toggleClusterRelayWorkNode(node: any, event: any) {
        if (!node) return;
        const checked = !!event?.target?.checked;
        node.cluster_relay_excluded = !checked;
        this.normalizeClusterRelayConfig();
        this.relayPreflightReport = null;
        this.relayPreflightCollapsed = {};
        this.relayAllowOverride = false;
        this.syncRelayDeploymentStatusFromNodes();
        this.refreshRelayWorkerStatusFromSelection();
        const targetLabel = this.isClusterRelayServer(node) ? 'Relay server' : 'Node';
        await this.autoSaveClusterRelayGroup(
            node.cluster_relay_excluded ? `${targetLabel} excluded from relay work and saved.` : `${targetLabel} included in relay work and saved.`
        );
    }

    public async toggleClusterRelayWorkerNode(node: any, event: any) {
        if (!node || this.isClusterRelayServer(node)) return;
        await this.toggleClusterRelayWorkNode(node, event);
    }

    private actionTimestamp(): string {
        const pad = (value: number) => String(value).padStart(2, '0');
        const now = new Date();
        return [
            now.getFullYear(),
            pad(now.getMonth() + 1),
            pad(now.getDate()),
        ].join('-') + ' ' + [
            pad(now.getHours()),
            pad(now.getMinutes()),
            pad(now.getSeconds()),
        ].join(':');
    }

    private clusterActionNodeName(nodeId: number): string {
        const node = this.clusterNodes.find((item: any) => Number(item.id) === Number(nodeId));
        return node?.name || `Node ${nodeId}`;
    }

    private buildClusterActionSummary(results: any[], operations: any[]): any {
        const rows = Array.isArray(results) ? results : [];
        const success = rows.filter((row: any) => !!row.success).length;
        const failed = rows.filter((row: any) => !row.success).length;
        const queued = rows.filter((row: any) => !!row.queued || !!row.operation_id).length;
        return {
            total: rows.length,
            success,
            failed,
            queued,
            operations: Array.isArray(operations) ? operations.length : 0,
            allSuccess: failed === 0 && success > 0,
        };
    }

    private normalizeClusterActionResults(results: any[], operations: any[], nodeIds: number[]): any[] {
        const rows = Array.isArray(results) ? results : [];
        if (rows.length > 0) {
            return rows.map((row: any) => {
                const nodeId = Number(row.id || row.node_id || 0);
                return {
                    ...row,
                    id: nodeId || row.id,
                    name: row.name || this.clusterActionNodeName(nodeId),
                };
            });
        }

        const operationRows = Array.isArray(operations) ? operations : [];
        if (operationRows.length > 0) {
            return operationRows.map((operation: any) => {
                const nodeId = Number(operation.node_id || 0);
                const duplicate = !!operation.duplicate;
                return {
                    id: nodeId,
                    name: this.clusterActionNodeName(nodeId),
                    success: true,
                    queued: !duplicate,
                    duplicate,
                    operation_id: operation.id,
                    operation_status: operation.status,
                    data: duplicate
                        ? `Operation #${operation.id} already active`
                        : `Queued operation #${operation.id}`,
                };
            });
        }

        return nodeIds.map((nodeId: number) => ({
            id: Number(nodeId),
            name: this.clusterActionNodeName(Number(nodeId)),
            success: false,
            data: 'No result returned.',
        }));
    }

    private setClusterActionResult(base: any, results: any[], operations: any[], status: string, message: string) {
        this.clusterActionResult = {
            ...base,
            status,
            message,
            results,
            operations,
            completedAt: status === 'running' ? '' : this.actionTimestamp(),
            summary: this.buildClusterActionSummary(results, operations),
        };
    }

    public getClusterActionResultStatusClass(result: any): string {
        if (!result || result.status === 'running') return 'bg-indigo-50 text-indigo-700 border-indigo-100';
        if (result.status === 'failed') return 'bg-red-50 text-red-700 border-red-100';
        if (result.summary?.failed > 0) return 'bg-red-50 text-red-700 border-red-100';
        return 'bg-green-50 text-green-700 border-green-100';
    }

    public getClusterActionResultStatusText(result: any): string {
        if (!result || result.status === 'running') return 'Running';
        if (result.status === 'failed') return 'Failed';
        if (result.summary?.failed > 0) return 'Partial failed';
        if (result.summary?.queued > 0) return 'Queued';
        return 'Completed';
    }

    public getClusterActionResultIcon(result: any): string {
        if (result?.success) return 'bx bx-check-circle';
        const message = String(result?.data || result?.message || '');
        if (message.includes('Timeout')) return 'bx bx-timer';
        return 'bx bx-x-circle';
    }

    public getClusterActionResultColor(result: any): string {
        if (result?.success) return 'text-green-600';
        const message = String(result?.data || result?.message || '');
        if (message.includes('Timeout')) return 'text-amber-500';
        return 'text-red-600';
    }

    public getClusterActionResultBadgeClass(result: any): string {
        if (result?.success) return 'bg-green-100 text-green-700';
        const message = String(result?.data || result?.message || '');
        if (message.includes('Timeout')) return 'bg-amber-100 text-amber-700';
        return 'bg-red-100 text-red-700';
    }

    public getClusterActionResultBadgeText(result: any): string {
        if (result?.success) return result?.queued ? 'Queued' : 'OK';
        const message = String(result?.data || result?.message || '');
        if (message.includes('Timeout')) return 'Timeout';
        return 'Failed';
    }

    public getClusterActionResultMessage(result: any): string {
        return String(result?.data || result?.message || '-');
    }

    public getClusterActionOperationLabel(result: any): string {
        if (!result?.operation_id) return '-';
        const status = result.operation_status ? ` · ${result.operation_status}` : '';
        return `#${result.operation_id}${status}`;
    }

    public async requestSelectedAction() {
        const nodeIds = this.selectedClusterNodeIdsArray();
        if (nodeIds.length === 0) {
            this.actionMessage = 'Select nodes first.';
            await this.service.render();
            return;
        }
        const action = this.selectedAction;
        const label = this.actionOptions.find((item: any) => item.value === action)?.label || action;
        if (!confirm(`Request ${label} for ${nodeIds.length} node(s)?`)) return;
        this.actionRunning = true;
        this.actionMessage = '';
        const resultBase = {
            action,
            label,
            targetCount: nodeIds.length,
            nodeIds,
            startedAt: this.actionTimestamp(),
        };
        this.setClusterActionResult(resultBase, [], [], 'running', `Requesting ${label} for ${nodeIds.length} node(s)...`);
        await this.service.render();
        const { code, data } = await wiz.call("cluster_action", {
            id: this.id,
            action,
            node_ids: JSON.stringify(nodeIds),
        });
        this.actionRunning = false;
        if (code === 200) {
            const operations = data?.operations || [];
            const results = this.normalizeClusterActionResults(data?.results || [], operations, nodeIds);
            this.actionMessage = operations.length > 0
                ? `${operations.length} operation(s) queued.`
                : `${results.length || nodeIds.length} result(s) returned.`;
            this.setClusterActionResult(resultBase, results, operations, 'completed', this.actionMessage);
        } else {
            this.actionMessage = data?.message || 'Action request failed.';
            const results = nodeIds.map((nodeId: number) => ({
                id: Number(nodeId),
                name: this.clusterActionNodeName(Number(nodeId)),
                success: false,
                data: this.actionMessage,
            }));
            this.setClusterActionResult(resultBase, results, [], 'failed', this.actionMessage);
        }
        await this.loadNodes();
        await this.service.render();
    }

    public clusterHeadNode(): any {
        return this.clusterRelayAuthorityNodes()[0] || this.clusterRelayServerNodes()[0] || null;
    }

    public async loadClusterSshKey() {
        const { code, data } = await wiz.call("cluster_ssh_key", { id: this.id });
        this.clusterSshKey = code === 200 ? (data || null) : null;
    }

    public sshKeyCopyTargets(): any[] {
        return this.clusterNodes || [];
    }

    public sshKeyCopyDeployedTargets(): any[] {
        return this.sshKeyCopyTargets().filter((node: any) => this.isNodeDeployed(node));
    }

    public sshKeyCopyPendingDeployTargets(): any[] {
        return this.sshKeyCopyTargets().filter((node: any) => !this.isNodeDeployed(node));
    }

    public isNodeDeployed(node: any): boolean {
        const status = String(node?.status || '').toLowerCase();
        const deployStatus = String(node?.deploy_status || '').toLowerCase();
        return status === 'deployed' || deployStatus === 'deployed';
    }

    public getSshKeyCopyResultStatusClass(result: any): string {
        const failed = Number(result?.summary?.failed || 0);
        const pending = Number(result?.summary?.pending_deploy || 0);
        if (this.sshKeyCopyRunning) return 'bg-indigo-50 text-indigo-700 border-indigo-100';
        if (failed > 0) return 'bg-red-50 text-red-700 border-red-100';
        if (pending > 0) return 'bg-amber-50 text-amber-700 border-amber-100';
        return 'bg-green-50 text-green-700 border-green-100';
    }

    public getSshKeyCopyResultStatusText(result: any): string {
        const summary = result?.summary || {};
        if (this.sshKeyCopyRunning) return 'Running';
        if (Number(summary.failed || 0) > 0) return 'Partial failed';
        if (Number(summary.pending_deploy || 0) > 0 && Number(summary.registered || 0) === 0) return 'Pending deploy';
        if (Number(summary.success || 0) > 0) return 'Completed';
        return 'Ready';
    }

    public getSshKeyCopyRowClass(row: any): string {
        if (row?.pending_deploy) return 'bg-amber-100 text-amber-700';
        if (row?.success && row?.test_warning) return 'bg-amber-100 text-amber-700';
        return row?.success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';
    }

    public getSshKeyCopyRowIcon(row: any): string {
        if (row?.pending_deploy) return 'bx bx-time-five text-amber-600';
        if (row?.success && row?.test_warning) return 'bx bx-info-circle text-amber-600';
        return row?.success ? 'bx bx-check-circle text-green-600' : 'bx bx-x-circle text-red-600';
    }

    public getSshKeyCopyStageClass(row: any, stage: string): string {
        if (row?.pending_deploy) return 'bg-amber-100 text-amber-700';
        if (stage === 'copy') return row?.copy_success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';
        if (!row?.copy_success) return 'bg-zinc-100 text-zinc-500';
        if (row?.test_success && row?.test_warning) return 'bg-amber-100 text-amber-700';
        return row?.test_success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';
    }

    public getSshKeyCopyStageText(row: any, stage: string): string {
        if (row?.pending_deploy) return 'Pending';
        if (stage === 'copy') return row?.copy_success ? 'Registered' : 'Failed';
        if (!row?.copy_success) return 'Skipped';
        if (row?.test_success && row?.test_warning) return 'Verified';
        return row?.test_success ? 'Verified' : 'Failed';
    }

    public getSshKeyCopyRowStatusText(row: any): string {
        if (row?.pending_deploy) return 'Pending deploy';
        if (row?.success && row?.test_warning) return 'Verified with warning';
        if (row?.success) return 'Registered';
        if (row?.copy_success && !row?.test_success) return 'Verify failed';
        return 'Register failed';
    }

    public async copyClusterSshKey() {
        const key = String(this.clusterSshKey?.public_key || '').trim();
        if (!key) {
            this.sshKeyCopyMessage = 'No main server key to copy.';
            await this.service.render();
            return;
        }

        let copied = false;
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(key);
                copied = true;
            }
        } catch (e) {
            copied = false;
        }

        if (!copied) {
            try {
                const textarea = document.createElement('textarea');
                textarea.value = key;
                textarea.setAttribute('readonly', 'true');
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                copied = document.execCommand('copy');
                document.body.removeChild(textarea);
            } catch (e) {
                copied = false;
            }
        }

        this.sshKeyCopyMessage = copied ? 'Main server key copied.' : 'Failed to copy main server key.';
        await this.service.render();
    }

    public async registerClusterKey() {
        const targets = this.sshKeyCopyTargets();
        if (targets.length === 0) {
            this.sshKeyCopyMessage = 'No cluster nodes to register SSH keys.';
            await this.service.render();
            return;
        }
        const deployed = this.sshKeyCopyDeployedTargets().length;
        const pending = this.sshKeyCopyPendingDeployTargets().length;
        if (!confirm(`Register cluster SSH key to ${deployed} deployed node(s)? ${pending} node(s) will receive it during next image deploy.`)) return;
        this.sshKeyCopyRunning = true;
        this.sshKeyCopyMessage = `Registering cluster SSH key to ${deployed} deployed node(s)...`;
        this.sshKeyCopyResult = {
            results: [],
            summary: { total: targets.length, success: 0, registered: 0, verified: 0, pending_deploy: pending, failed: 0 },
        };
        await this.service.render();
        const { code, data } = await wiz.call("register_cluster_key", { id: this.id });
        this.sshKeyCopyRunning = false;
        if (code === 200) {
            this.sshKeyCopyResult = data || {};
            this.clusterSshKey = {
                ...(this.clusterSshKey || {}),
                key_name: data?.key_name || this.clusterSshKey?.key_name,
                public_key: data?.public_key || this.clusterSshKey?.public_key,
                fingerprint: data?.fingerprint || this.clusterSshKey?.fingerprint,
                created: data?.created || this.clusterSshKey?.created,
                updated: data?.updated || this.clusterSshKey?.updated,
            };
            const summary = data?.summary || {};
            this.sshKeyCopyMessage = `${summary.registered || 0} registered · ${summary.verified || 0} verified · ${summary.pending_deploy || 0} pending deploy · ${summary.failed || 0} failed.`;
        } else {
            this.sshKeyCopyMessage = data?.message || 'Cluster SSH key registration failed.';
            this.sshKeyCopyResult = {
                results: targets.map((node: any) => ({
                    id: node.id,
                    name: node.name,
                    ip_address: node.ip_address,
                    success: false,
                    copy_success: false,
                    test_success: false,
                    pending_deploy: false,
                    copy_message: this.sshKeyCopyMessage,
                    test_message: 'skipped',
                    message: this.sshKeyCopyMessage,
                })),
                summary: { total: targets.length, success: 0, registered: 0, verified: 0, pending_deploy: 0, failed: targets.length },
            };
        }
        await this.loadNodes();
        await this.loadClusterSshKey();
        await this.service.render();
    }

    // =========================================================================
    // Zabbix 관리
    // =========================================================================

    public async loadClusterZabbixConfig() {
        await this.loadNodes();
        if (!this.zabbixConfigLoaded) {
            const { code, data } = await wiz.call("cluster_zabbix_config", { id: this.id });
            if (code === 200 && data?.server_ip && !this.zabbixServerIp) {
                this.zabbixServerIp = data.server_ip;
            }
            this.zabbixConfigLoaded = true;
        }
        this.initializeZabbixDefaults();
    }

    private initializeZabbixDefaults() {
        if (!this.zabbixProxyNodeId) {
            const head = this.clusterHeadNode();
            const fallback = this.clusterNodes.find((node: any) => !!node.ip_address);
            const proxy = head?.ip_address ? head : fallback;
            if (proxy) this.zabbixProxyNodeId = proxy.id;
        }
        const proxy = this.zabbixProxyNode();
        if (proxy && !this.zabbixProxyName) {
            this.zabbixProxyName = proxy.name || `proxy-${proxy.id}`;
        }
    }

    public zabbixProxyCandidates(): any[] {
        return (this.clusterNodes || []).filter((node: any) => !!node.ip_address);
    }

    public zabbixProxyNode(): any {
        const proxyId = Number(this.zabbixProxyNodeId || 0);
        if (!proxyId) return null;
        return (this.clusterNodes || []).find((node: any) => Number(node.id) === proxyId) || null;
    }

    public async onZabbixProxyNodeChanged() {
        const proxy = this.zabbixProxyNode();
        if (proxy) this.zabbixProxyName = proxy.name || `proxy-${proxy.id}`;
        await this.service.render();
    }

    public zabbixSelectedTargets(): any[] {
        const selected = new Set(this.selectedClusterNodeIdsArray().map((nodeId: number) => Number(nodeId)));
        return (this.clusterNodes || []).filter((node: any) => selected.has(Number(node.id)));
    }

    public getZabbixResultStatusClass(result: any): string {
        if (this.zabbixRunning) return 'bg-indigo-50 text-indigo-700 border-indigo-100';
        if (!result) return 'bg-zinc-50 text-zinc-600 border-zinc-100';
        if (Number(result?.summary?.failed || 0) > 0) return 'bg-red-50 text-red-700 border-red-100';
        if (Number(result?.summary?.api_warnings || 0) > 0) return 'bg-amber-50 text-amber-700 border-amber-100';
        if (Number(result?.summary?.success || 0) > 0) return 'bg-green-50 text-green-700 border-green-100';
        return 'bg-zinc-50 text-zinc-600 border-zinc-100';
    }

    public getZabbixResultStatusText(result: any): string {
        if (this.zabbixRunning) return 'Running';
        if (!result) return 'Ready';
        if (Number(result?.summary?.failed || 0) > 0) return 'Partial failed';
        if (Number(result?.summary?.api_warnings || 0) > 0) return 'Completed with warning';
        if (Number(result?.summary?.success || 0) > 0) return 'Completed';
        return 'Ready';
    }

    public getZabbixRowBadgeClass(row: any): string {
        if (row?.success) return row?.zabbix_api_warning ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700';
        return 'bg-red-100 text-red-700';
    }

    public getZabbixRowIcon(row: any): string {
        if (row?.success) return row?.zabbix_api_warning ? 'bx bx-info-circle text-amber-600' : 'bx bx-check-circle text-green-600';
        return 'bx bx-x-circle text-red-600';
    }

    public getZabbixRowStatusText(row: any): string {
        if (row?.success && row?.zabbix_api_warning) return 'Configured';
        if (row?.success) return 'OK';
        return 'Failed';
    }

    public getZabbixRowMessage(row: any): string {
        return String(row?.message || row?.zabbix_api_message || row?.data || '-');
    }

    public async installClusterZabbixProxy() {
        const proxy = this.zabbixProxyNode();
        if (!proxy) {
            this.zabbixMessage = 'Select a proxy node first.';
            await this.service.render();
            return;
        }
        if (!this.zabbixServerIp) {
            this.zabbixMessage = 'Zabbix Server IP is required.';
            await this.service.render();
            return;
        }
        const proxyName = this.zabbixProxyName || proxy.name || `proxy-${proxy.id}`;
        if (!confirm(`Install Zabbix Proxy on ${proxy.name}?`)) return;
        this.zabbixRunning = true;
        this.zabbixMessage = `Installing Zabbix Proxy on ${proxy.name}...`;
        this.zabbixResult = {
            action: 'install_proxy',
            results: [],
            summary: { total: 1, success: 0, failed: 0 },
        };
        await this.service.render();
        const { code, data } = await wiz.call("cluster_zabbix_install_proxy", {
            id: this.id,
            node_id: proxy.id,
            ssh_user: this.zabbixSshUser,
            ssh_password: this.zabbixSshPassword,
            zabbix_server: this.zabbixServerIp,
            proxy_name: proxyName,
        });
        this.zabbixRunning = false;
        if (code === 200) {
            this.zabbixResult = data || null;
            this.zabbixMessage = data?.message || 'Zabbix Proxy install command completed.';
        } else {
            this.zabbixMessage = data?.message || 'Zabbix Proxy install command failed.';
            this.zabbixResult = {
                action: 'install_proxy',
                results: [{ id: proxy.id, name: proxy.name, success: false, message: this.zabbixMessage }],
                summary: { total: 1, success: 0, failed: 1 },
            };
        }
        await this.loadNodes();
        await this.service.render();
    }

    public async assignClusterZabbixProxy() {
        const proxy = this.zabbixProxyNode();
        const nodeIds = this.selectedClusterNodeIdsArray();
        if (!proxy) {
            this.zabbixMessage = 'Select a proxy node first.';
            await this.service.render();
            return;
        }
        if (nodeIds.length === 0) {
            this.zabbixMessage = 'Select nodes to point at the proxy.';
            await this.service.render();
            return;
        }
        const proxyName = this.zabbixProxyName || proxy.name || `proxy-${proxy.id}`;
        if (!confirm(`Configure ${nodeIds.length} node(s) to use proxy ${proxyName}?`)) return;
        this.zabbixRunning = true;
        this.zabbixMessage = `Configuring ${nodeIds.length} node(s) to use proxy ${proxyName}...`;
        this.zabbixResult = {
            action: 'assign_proxy',
            results: [],
            summary: { total: nodeIds.length, success: 0, failed: 0 },
        };
        await this.service.render();
        const { code, data } = await wiz.call("cluster_zabbix_assign_proxy", {
            id: this.id,
            node_ids: JSON.stringify(nodeIds),
            proxy_node_id: proxy.id,
            ssh_user: this.zabbixSshUser,
            ssh_password: this.zabbixSshPassword,
            proxy_name: proxyName,
        });
        this.zabbixRunning = false;
        if (code === 200) {
            this.zabbixResult = data || null;
            const summary = data?.summary || {};
            this.zabbixMessage = `${summary.success || 0} configured · ${summary.failed || 0} failed.`;
        } else {
            this.zabbixMessage = data?.message || 'Zabbix proxy assignment failed.';
            this.zabbixResult = {
                action: 'assign_proxy',
                results: this.zabbixSelectedTargets().map((node: any) => ({
                    id: node.id,
                    name: node.name,
                    success: false,
                    message: this.zabbixMessage,
                })),
                summary: { total: nodeIds.length, success: 0, failed: nodeIds.length },
            };
        }
        await this.loadNodes();
        await this.service.render();
    }

    public async removeNode(node: any) {
        const restoreMsg = node.old_name
            ? this.translate.instant('page.clusters.item.restore_original_name', { name: node.old_name })
            : '';
        if (!confirm(this.translate.instant('page.clusters.item.confirm_remove_node', { name: node.name, restore: restoreMsg }))) return;
        const { code } = await wiz.call("remove_nodes", { id: this.id, node_ids: JSON.stringify([node.id]) });
        if (code === 200) {
            this.selectedClusterNodeIds.delete(Number(node.id));
            await this.load();
        }
        await this.service.render();
    }

    // =========================================================================
    // Network 관리
    // =========================================================================

    public async loadNetworks(renderLoading: boolean = false) {
        if (renderLoading) {
            this.networkRefreshing = true;
            await this.service.render();
        }
        try {
            const { code, data } = await wiz.call("networks", { id: this.id });
            if (code === 200) {
                this.networkRows = (data?.rows || []).map((row: any) => {
                    return { ...row, network_mode: this.resolveNetworkMode(row.network_mode) };
                });
                const validIds = new Set(this.networkRows.map((row: any) => Number(row.id)));
                Array.from(this.selectedNetworkIds).forEach((networkId: number) => {
                    if (!validIds.has(networkId)) this.selectedNetworkIds.delete(networkId);
                });
            }
        } finally {
            if (renderLoading) {
                this.networkRefreshing = false;
                await this.service.render();
            }
        }
    }

    private networkSearchActive(): boolean {
        return ['text', 'node', 'role', 'interface', 'state'].some((key: string) => {
            return String(this.networkSearch?.[key] || '').trim() !== '';
        });
    }

    private networkRowMatchesText(row: any): boolean {
        const text = String(this.networkSearch.text || '').trim().toLowerCase();
        if (!text) return true;
        const values = [
            row.node_name,
            this.networkRoleLabel(row),
            row.name,
            row.mac_address,
            this.networkIpAddressLabel(row),
            row.gateway,
            row.network_mode,
            this.networkModeLabel(row.network_mode),
            row.connected_domain_label,
            row.connected_domain_cidr,
            this.networkInterfaceTypeLabel(row),
            this.networkStateLabel(row),
        ];
        return values.some((value: any) => String(value || '').toLowerCase().includes(text));
    }

    private networkRowMatchesFilters(row: any): boolean {
        const node = String(this.networkSearch.node || '').trim();
        const role = String(this.networkSearch.role || '').trim();
        const iface = String(this.networkSearch.interface || '').trim();
        const state = String(this.networkSearch.state || '').trim();
        return (!node || String(row.node_id || '') === node)
            && (!role || this.networkRoleKey(row) === role)
            && (!iface || String(row.name || '') === iface)
            && (!state || this.networkStateKey(row) === state)
            && this.networkRowMatchesText(row);
    }

    public filteredNetworkRows(): any[] {
        const rows = this.networkRows || [];
        if (!this.networkSearchActive()) return rows;
        return rows.filter((row: any) => this.networkRowMatchesFilters(row));
    }

    private networkUniqueOptions(rows: any[], keyGetter: any, labelGetter: any): any[] {
        const map: any = {};
        for (const row of rows || []) {
            const key = String(keyGetter(row) || '').trim();
            if (!key) continue;
            if (!map[key]) map[key] = { value: key, label: String(labelGetter(row) || key), count: 0 };
            map[key].count++;
        }
        return (Object.values(map) as any[]).sort((left: any, right: any) => String(left.label || '').localeCompare(String(right.label || '')));
    }

    public networkNodeFilterOptions(): any[] {
        return this.networkUniqueOptions(this.networkRows, (row: any) => row.node_id, (row: any) => row.node_name || `Node #${row.node_id}`);
    }

    public networkRoleFilterOptions(): any[] {
        return this.networkUniqueOptions(this.networkRows, (row: any) => this.networkRoleKey(row), (row: any) => this.networkRoleLabel(row));
    }

    public networkInterfaceFilterOptions(): any[] {
        return this.networkUniqueOptions(this.networkRows, (row: any) => row.name, (row: any) => row.name);
    }

    public networkStateFilterOptions(): any[] {
        return this.networkUniqueOptions(this.networkRows, (row: any) => this.networkStateKey(row), (row: any) => this.networkStateLabel(row));
    }

    public async clearNetworkFilters() {
        this.networkSearch = { text: '', node: '', role: '', interface: '', state: '' };
        await this.service.render();
    }

    public async toggleNetworkFilters() {
        this.networkFiltersVisible = !this.networkFiltersVisible;
        await this.service.render();
    }

    public resolveNetworkMode(value: any): string {
        const normalized = String(value || '').trim().toLowerCase();
        return this.networkModeOptions.some((mode: any) => mode.value === normalized) ? normalized : 'static';
    }

    public networkModeLabel(value: any): string {
        const mode = this.networkModeOptions.find((item: any) => item.value === this.resolveNetworkMode(value));
        return mode ? mode.label : 'Static';
    }

    public networkModeClass(value: any): string {
        const mode = this.resolveNetworkMode(value);
        if (mode === 'dhcp') return 'bg-orange-100 text-orange-700';
        if (mode === 'unconfigured') return 'bg-zinc-100 text-zinc-600';
        return 'bg-blue-100 text-blue-700';
    }

    public networkRoleKey(row: any): string {
        const explicit = String(row?.node_inventory_role || row?.node_role_key || row?.role_type || '').trim().toLowerCase();
        if (['relay', 'compute', 'storage'].includes(explicit)) return explicit;
        const nodeName = String(row?.node_name || '').trim().toLowerCase();
        if (nodeName.startsWith('relay')) return 'relay';
        if (nodeName.startsWith('stor') || nodeName.startsWith('storage')) return 'storage';
        return 'compute';
    }

    public networkRoleLabel(row: any): string {
        const role = this.networkRoleKey(row);
        if (role === 'relay') return 'Relay';
        if (role === 'storage') return 'Storage';
        return 'Compute';
    }

    public networkRoleBadgeClass(row: any): string {
        const role = this.networkRoleKey(row);
        if (role === 'relay') return 'bg-blue-100 text-blue-700';
        if (role === 'storage') return 'bg-amber-100 text-amber-700';
        return 'bg-emerald-100 text-emerald-700';
    }

    public networkInterfaceTypeLabel(row: any): string {
        const raw = String(row?.interface_type_label || row?.network_interface_type || row?.interface_type || row?.type || '').trim().toLowerCase();
        const name = String(row?.name || '').trim().toLowerCase();
        if (raw.includes('opa') || name.startsWith('opa')) return 'OPA';
        if (raw.includes('infiniband') || raw === 'ib' || raw === 'ipoib' || name.startsWith('ib')) return 'InfiniBand';
        if (raw.includes('ethernet') || raw === 'eth' || raw === 'general') return 'Ethernet';
        return raw ? raw.replace(/\b\w/g, (letter: string) => letter.toUpperCase()) : 'Ethernet';
    }

    public networkDomainLabel(row: any): string {
        const label = String(row?.connected_domain_label || row?.connected_domain || row?.dhcp_domain_label || '').trim();
        if (label) return label;
        const vlanId = Number(row?.connected_domain_vlan_id || row?.vlan_id || 0);
        if (vlanId > 0) return `VLAN ${vlanId}`;
        return '-';
    }

    public networkDomainBadgeClass(row: any): string {
        const type = this.networkInterfaceTypeLabel(row).toLowerCase();
        if (type.includes('infiniband') || type.includes('opa')) return 'bg-indigo-100 text-indigo-700';
        return this.networkDomainLabel(row) === '-' ? 'bg-zinc-100 text-zinc-500' : 'bg-emerald-100 text-emerald-700';
    }

    public networkGatewayLabel(row: any): string {
        return String(row?.gateway || row?.connected_gateway || '').trim() || '-';
    }

    public networkIpAddressLabel(row: any): string {
        const ip = String(row?.ip_address || '').trim();
        if (!ip) return '-';
        if (ip.includes('/')) return ip;
        const cidr = String(row?.connected_domain_cidr || row?.dhcp_domain_cidr || '').trim();
        const prefix = cidr.includes('/') ? cidr.split('/').pop() : '';
        return prefix ? `${ip}/${prefix}` : ip;
    }

    public networkStateKey(row: any): string {
        const state = String(row?.oper_state || row?.state || '').trim().toLowerCase();
        if (['up', 'active', 'running', 'ready', 'online'].includes(state)) return 'up';
        if (['down', 'inactive', 'failed', 'error', 'offline'].includes(state)) return 'down';
        return 'unknown';
    }

    public networkStateLabel(row: any): string {
        const state = this.networkStateKey(row);
        if (state === 'up') return 'Up';
        if (state === 'down') return 'Down';
        return 'Unknown';
    }

    public networkStateDotClass(row: any): string {
        const state = this.networkStateKey(row);
        if (state === 'up') return 'bg-emerald-500';
        if (state === 'down') return 'bg-red-500';
        return 'bg-zinc-400';
    }

    public networkStateTextClass(row: any): string {
        const state = this.networkStateKey(row);
        if (state === 'up') return 'text-emerald-700';
        if (state === 'down') return 'text-red-700';
        return 'text-zinc-500';
    }

    public isNetworkSelected(networkId: number): boolean {
        return this.selectedNetworkIds.has(Number(networkId));
    }

    public toggleNetworkSelect(networkId: number) {
        networkId = Number(networkId);
        if (this.selectedNetworkIds.has(networkId)) this.selectedNetworkIds.delete(networkId);
        else this.selectedNetworkIds.add(networkId);
    }

    public toggleAllFilteredNetworks(event: any) {
        const checked = !!event?.target?.checked;
        const rows = this.filteredNetworkRows();
        if (!checked) {
            rows.forEach((row: any) => this.selectedNetworkIds.delete(Number(row.id)));
            return;
        }
        rows.forEach((row: any) => this.selectedNetworkIds.add(Number(row.id)));
    }

    public allFilteredNetworksSelected(): boolean {
        const rows = this.filteredNetworkRows();
        return rows.length > 0 && rows.every((row: any) => this.selectedNetworkIds.has(Number(row.id)));
    }

    public selectedNetworkRows(): any[] {
        const selected = new Set(Array.from(this.selectedNetworkIds).map((networkId: number) => Number(networkId)));
        return this.networkRows.filter((row: any) => selected.has(Number(row.id)));
    }

    private networkCsvValue(value: any): string {
        const text = String(value ?? '').replace(/"/g, '""');
        return /[",\n\r]/.test(text) ? `"${text}"` : text;
    }

    public async exportNetworkCsv() {
        if (this.exportingNetworkCsv || this.filteredNetworkRows().length === 0) return;
        this.exportingNetworkCsv = true;
        await this.service.render();
        try {
            const columns = [
                { label: 'Node', value: (row: any) => row.node_name || '' },
                { label: 'Role', value: (row: any) => this.networkRoleLabel(row) },
                { label: 'Interface', value: (row: any) => row.name || '' },
                { label: 'Connected Domain', value: (row: any) => this.networkDomainLabel(row) },
                { label: 'IP Mode', value: (row: any) => this.networkModeLabel(row.network_mode) },
                { label: 'IP Address', value: (row: any) => this.networkIpAddressLabel(row) },
                { label: 'Gateway', value: (row: any) => this.networkGatewayLabel(row) },
                { label: 'MAC Address', value: (row: any) => row.mac_address || '' },
                { label: 'Interface Type', value: (row: any) => this.networkInterfaceTypeLabel(row) },
                { label: 'State', value: (row: any) => this.networkStateLabel(row) },
            ];
            const lines = [
                columns.map((column: any) => this.networkCsvValue(column.label)).join(','),
                ...this.filteredNetworkRows().map((row: any) => columns.map((column: any) => this.networkCsvValue(column.value(row))).join(',')),
            ];
            const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const clusterName = String(this.item?.name || this.id || 'cluster').replace(/[^a-zA-Z0-9_-]+/g, '-');
            link.href = URL.createObjectURL(blob);
            link.download = `cluster-${clusterName}-network-interfaces.csv`;
            link.click();
            URL.revokeObjectURL(link.href);
        } finally {
            this.exportingNetworkCsv = false;
            await this.service.render();
        }
    }

    public openNetworkRowConfigure(row: any) {
        const networkId = Number(row?.id || 0);
        if (!networkId) return;
        this.selectedNetworkIds = new Set([networkId]);
        this.openNetworkBulkModal();
    }

    public isNetworkBulkStatic(): boolean {
        return this.resolveNetworkMode(this.networkBulkForm.network_mode) === 'static';
    }

    public openNetworkBulkModal() {
        const selected = this.selectedNetworkRows();
        if (selected.length === 0) {
            alert('Select network interfaces first.');
            return;
        }
        const first = selected[0];
        this.networkBulkForm = {
            network_mode: this.resolveNetworkMode(first?.network_mode),
            start_ip: String(first?.ip_address || ''),
            mask_bits: this.networkBulkForm?.mask_bits || 24,
            gateway: this.networkBulkForm?.gateway || '',
        };
        this.showNetworkBulkModal = true;
        this.networkBulkMessage = '';
    }

    public closeNetworkBulkModal() {
        if (this.networkBulkSaving) return;
        this.showNetworkBulkModal = false;
    }

    private networkBulkPayload(force: boolean = false): any {
        return {
            network_ids: this.selectedNetworkRows().map((row: any) => Number(row.id)),
            network_mode: this.resolveNetworkMode(this.networkBulkForm.network_mode),
            start_ip: String(this.networkBulkForm.start_ip || '').trim(),
            mask_bits: Number(this.networkBulkForm.mask_bits || 24),
            gateway: String(this.networkBulkForm.gateway || '').trim(),
            force: force ? 1 : 0,
        };
    }

    private networkConflictMessage(data: any): string {
        const conflicts = data?.conflicts || [];
        if (!conflicts.length) return data?.message || 'IP address is already used by another node.';
        const preview = conflicts.slice(0, 5).map((item: any) => {
            const node = item.node_name || (`Node ${item.node_id || ''}`);
            const iface = item.interface_name ? ` ${item.interface_name}` : '';
            return `${item.ip_address}: ${node}${iface}`;
        }).join('\n');
        const suffix = conflicts.length > 5 ? `\n...and ${conflicts.length - 5} more` : '';
        return `${data?.message || 'IP address is already used by another node.'}\n\n${preview}${suffix}\n\nApply anyway?`;
    }

    public async applyBulkNetworks(force: boolean = false) {
        const payload = this.networkBulkPayload(force);
        if (payload.network_ids.length === 0) return;
        if (payload.network_mode === 'static' && !payload.start_ip) {
            alert('Start IP address is required.');
            return;
        }
        this.networkBulkSaving = true;
        this.networkBulkMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("network_bulk_apply", {
                id: this.id,
                data: JSON.stringify(payload),
                force: force ? 1 : 0,
            });
            if (code === 409 && !force) {
                this.networkBulkSaving = false;
                await this.service.render();
                if (!confirm(this.networkConflictMessage(data))) return;
                await this.applyBulkNetworks(true);
                return;
            }
            if (code === 200) {
                this.networkBulkMessage = `${data?.count || payload.network_ids.length} network interface(s) updated.`;
                this.showNetworkBulkModal = false;
                this.selectedNetworkIds.clear();
                await this.loadNetworks();
            } else {
                this.networkBulkMessage = data?.message || 'Bulk network configuration failed.';
            }
        } finally {
            this.networkBulkSaving = false;
            await this.service.render();
        }
    }

    // =========================================================================
    // Script 관리
    // =========================================================================

    public async loadScriptConfigs() {
        const { code, data } = await wiz.call("scripts", { id: this.id });
        if (code === 200) {
            this.scriptRows = data?.rows || [];
            this.scriptOptions = data?.scripts || [];
        }
    }

    public async saveScriptConfig(row: any) {
        const payload = {
            node_id: row.node_id,
            pre_script_id: row.pre_script_id || '',
            post_script_id: row.post_script_id || '',
        };
        const { code, data } = await wiz.call("script_save", { id: this.id, data: JSON.stringify(payload) });
        this.scriptMessage = code === 200 ? 'Script setting saved.' : (data?.message || 'Failed to save script setting.');
        if (code === 200) await this.loadScriptConfigs();
        await this.service.render();
    }

    public async applyBulkScripts() {
        const nodeIds = this.scriptRows.map((row: any) => row.node_id);
        if (nodeIds.length === 0) return;
        if (!confirm(`Apply script settings to ${nodeIds.length} node(s)?`)) return;
        const payload = {
            node_ids: nodeIds,
            pre_script_id: this.bulkScript.pre_script_id || '',
            post_script_id: this.bulkScript.post_script_id || '',
        };
        const { code, data } = await wiz.call("script_bulk_apply", { id: this.id, data: JSON.stringify(payload) });
        this.scriptMessage = code === 200 ? `${data?.count || nodeIds.length} node(s) updated.` : (data?.message || 'Bulk apply failed.');
        if (code === 200) await this.loadScriptConfigs();
        await this.service.render();
    }

    // =========================================================================
    // Relay 관리
    // =========================================================================

    private async relayApi(name: string, params: any = {}) {
        const formData = new FormData();
        Object.entries(params || {}).forEach(([key, value]: any) => {
            if (value !== undefined && value !== null) formData.append(key, String(value));
        });

        try {
            const response = await fetch(`/wiz/api/page.kiera.relay/${name}`, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            });
            const result = await response.json();
            return { code: result?.code || 0, data: result?.data ?? result };
        } catch (error: any) {
            return { code: 0, data: { message: error?.message || 'Relay API request failed.' } };
        }
    }

    private applyRelayServerPowerState(nodeId: any, powerState: any) {
        const state = String(powerState || '').trim().toLowerCase();
        if (!state) return;
        const server = this.clusterRelayServerNodes().find((node: any) => String(node.id) === String(nodeId));
        if (server) server.power_status = state;
    }

    private clearRelayHeadPowerCheckTimer() {
        if (this.relayHeadPowerCheckTimer) {
            clearTimeout(this.relayHeadPowerCheckTimer);
            this.relayHeadPowerCheckTimer = null;
        }
    }

    private scheduleRelayHeadPowerCheck() {
        const head = this.clusterRelayHeadNode();
        if (!head) return;
        this.clearRelayHeadPowerCheckTimer();
        this.relayHeadPowerCheckTimer = setTimeout(async () => {
            this.relayHeadPowerCheckTimer = null;
            await this.refreshRelayHeadPowerStatus(false);
            await this.service.render();
        }, this.relayHeadPowerCheckDelayMs);
    }

    public async refreshRelayHeadPowerStatus(shouldRender: boolean = true): Promise<string> {
        const relayServers = this.relayDeployServerNodes();
        if (relayServers.length === 0) {
            if (shouldRender) await this.service.render();
            return '';
        }

        const { code, data } = await this.relayApi("get_power_status", {
            data: JSON.stringify({ node_ids: relayServers.map((node: any) => node.id), timeout: 5, retries: 1 })
        });
        if (code === 200) {
            const results = data?.results || {};
            relayServers.forEach((server: any) => {
                this.applyRelayServerPowerState(server.id, results[String(server.id)] ?? results[server.id]);
            });
        }
        if (shouldRender) await this.service.render();
        return relayServers.map((server: any) => server.power_status || '').filter(Boolean).join(', ');
    }

    public async loadRelay() {
        this.relayLoading = true;
        this.relayMessage = '';
        await this.loadNodes();
        this.initializeRelayDefaults();

        const { code, data } = await this.relayApi("images");
        if (code === 200) {
            this.relayImages = Array.isArray(data) ? data : (data?.rows || data?.images || []);
        } else {
            this.relayMessage = data?.message || 'Failed to load relay images.';
        }

        this.syncRelayDeploymentStatusFromNodes();
        await this.refreshRelayHeadStatus(false);
        const syncedJob = await this.syncRelayPersistedJob(false);
        if (
            syncedJob
            && this.relayOrchestrationInProgressStatus(this.relayOrchestrationJob?.status)
            && !this.relayJobPoller
        ) {
            this.startRelayJobPoll();
        }
        this.relayLoading = false;
    }

    private initializeRelayDefaults() {
        this.normalizeClusterRelayConfig();
        const relayServers = this.clusterRelayCandidateServerNodes();
        const workers = this.clusterRelayWorkerNodes();
        const excludedWorkNodes = this.clusterRelayExcludedWorkNodes();
        const signature = `${relayServers.map((node: any) => `${node.id}:${node.cluster_relay_role}:${this.clusterRelayDhcpGroupKey(node)}:${this.isClusterRelayExcluded(node) ? 'off' : 'on'}`).join(',')}:${workers.map((node: any) => `${node.id}:${node.cluster_relay_id || ''}`).join(',')}:excluded:${excludedWorkNodes.map((node: any) => node.id).join(',')}`;
        if (this.relaySignature && this.relaySignature !== signature) {
            this.relayCreatedId = '';
            this.relayPreflightReport = null;
            this.relayPreflightCollapsed = {};
            this.relayOrchestrationJobId = '';
            this.relayOrchestrationJob = null;
            this.relayDeployStarted = false;
            this.relayDeployCompleted = false;
            this.relayDeployStarting = false;
            this.relayHeadDeploySubmitted = false;
            this.relayHeadDeployStartedAt = '';
            this.relayHeadDeployCompletedAt = '';
        }
        this.relaySignature = signature;

        if (!this.relayName) {
            this.relayName = `Cluster-${this.item?.name || this.id}-Relay`;
        }
        if (!this.relayForm.computing_image_id && this.relayForm.relay_image_id) {
            this.relayForm.computing_image_id = this.relayForm.relay_image_id;
        }

        this.refreshRelayWorkerStatusFromSelection();
    }

    private relayWorkerDeploymentStateFromNode(node: any): any {
        const status = this.relayNormalizedStatus(node?.status);
        const deployStatus = this.relayNormalizedStatus(node?.deploy_status);
        const failed = status === 'failed' || status === 'error' || deployStatus.endsWith('failed');
        if (failed) {
            return { status: 'failed', message: deployStatus || status || 'Deploy failed' };
        }
        if (
            ['deployed', 'active', 'commissioned'].includes(status) ||
            ['deployed', 'active', 'verify-pending'].includes(deployStatus)
        ) {
            return { status: 'deployed', message: '' };
        }
        if (status === 'ready') {
            return { status: 'ready', message: '' };
        }
        const combined = `${status} ${deployStatus}`;
        if (combined.includes('deploy') || combined.includes('diskless') || combined.includes('commission')) {
            return { status: 'deploying', message: '' };
        }
        return { status: status || (deployStatus && deployStatus !== 'none' ? deployStatus : 'pending'), message: '' };
    }

    public clusterRelayHeadNode(): any {
        return this.relayDeployAuthorityNodes()[0] || this.relayDeployServerNodes()[0] || null;
    }

    public clusterRelayWorkerNodes(): any[] {
        return this.relayDeployComputingNodes();
    }

    private relayAssignmentsFor(relayServers: any[], computingNodes: any[]): any {
        const assignments: any = {};
        for (const server of relayServers || []) {
            assignments[server.id] = [];
        }
        for (const node of computingNodes || []) {
            const serverId = String(node.cluster_relay_id || '');
            if (!serverId) continue;
            if (!assignments[serverId]) assignments[serverId] = [];
            assignments[serverId].push(node.id);
        }
        return assignments;
    }

    public clusterRelayAssignments(): any {
        return this.relayAssignmentsFor(this.clusterRelayServerNodes(), this.clusterRelayComputingNodes());
    }

    public relayDeployAssignments(): any {
        return this.relayAssignmentsFor(this.relayDeployServerNodes(), this.relayDeployComputingNodes());
    }

    public clusterRelayAllAssignments(): any {
        const assignments: any = {};
        const candidateServerIds = this.clusterRelayCandidateServerIdSet();
        for (const server of this.clusterRelayCandidateServerNodes()) {
            assignments[server.id] = [];
        }
        for (const node of (this.clusterNodes || []).filter((item: any) => !this.isClusterRelayServer(item))) {
            const serverId = String(node.cluster_relay_id || '');
            if (!serverId || !candidateServerIds.has(serverId)) continue;
            if (!assignments[serverId]) assignments[serverId] = [];
            assignments[serverId].push(node.id);
        }
        return assignments;
    }

    public relayDeployAllAssignments(): any {
        return this.relayAssignmentsFor(this.relayDeployCandidateServerNodes(), this.relayDeployCandidateComputingNodes());
    }

    public clusterRelayServerConfigSnapshot(): any[] {
        return this.clusterRelayCandidateServerNodes().map((server: any) => ({
            node_id: server.id,
            dhcp_group_key: this.clusterRelayDhcpGroupKey(server),
            is_dhcp_server: String(server.cluster_relay_role || '') === 'authority' ? 1 : 0,
            excluded: this.isClusterRelayExcluded(server),
        }));
    }

    private relayNonEmpty(...values: any[]): string {
        for (const value of values) {
            const normalized = String(value ?? '').trim();
            if (normalized) return normalized;
        }
        return '';
    }

    private relayDomainMetadataForKey(key: any): any {
        const normalized = String(key || '').trim();
        if (!normalized || !this.relayDomainMetadata || typeof this.relayDomainMetadata !== 'object') return {};
        const metadata = this.relayDomainMetadata[normalized];
        return metadata && typeof metadata === 'object' ? metadata : {};
    }

    private relayVlanIdFromKey(key: any): string {
        const normalized = String(key || '').trim();
        if (!normalized.startsWith('vlan:')) return '';
        return normalized.split(':').slice(1).join(':');
    }

    private relayDefaultGroupName(groupKey: any): string {
        const network = this.relayNetworkInfoForKey(groupKey);
        if (network.vlan_id) return `RG-${network.vlan_id}`;
        if (network.cidr) return `RG-${String(network.cidr).replace(/[^A-Za-z0-9]+/g, '-')}`;
        const suffix = String(groupKey || 'default').replace(/[^A-Za-z0-9]+/g, '-');
        return `RG-${suffix}`;
    }

    public relayNetworkInfoForKey(groupKey: any): any {
        const key = String(groupKey || '').trim();
        const subnet = this.clusterRelaySubnetForKey(key) || {};
        const metadata = this.relayDomainMetadataForKey(key);
        const dhcpStart = this.relayNonEmpty(metadata.dhcp_start, metadata.dhcp_pool_start, subnet.dhcp_start, subnet.dhcp_pool_start);
        const dhcpEnd = this.relayNonEmpty(metadata.dhcp_end, metadata.dhcp_pool_end, subnet.dhcp_end, subnet.dhcp_pool_end);
        return {
            key,
            source: this.relayNonEmpty(metadata.source, subnet.id || subnet.key ? 'existing' : 'custom'),
            label: this.relayNonEmpty(metadata.label, subnet.label, key),
            name: this.relayNonEmpty(metadata.subnet_name, metadata.network_name, subnet.name),
            vlan_id: this.relayNonEmpty(metadata.vlan_id, subnet.vlan_id, this.relayVlanIdFromKey(key)),
            cidr: this.relayNonEmpty(metadata.cidr, subnet.cidr),
            gateway: this.relayNonEmpty(metadata.gateway, subnet.gateway, subnet.gateway_ip),
            dhcp_start: dhcpStart,
            dhcp_end: dhcpEnd,
            dhcp_pool: this.relayNonEmpty(metadata.dhcp_pool, subnet.dhcp_pool, dhcpStart && dhcpEnd ? `${dhcpStart} ~ ${dhcpEnd}` : ''),
            description: this.relayNonEmpty(metadata.description_network, subnet.description),
            dns_server: this.relayNonEmpty(metadata.dns_server, subnet.dns_server),
            domain_name: this.relayNonEmpty(metadata.domain_name, subnet.domain_name),
            ntp_server: this.relayNonEmpty(metadata.ntp_server, subnet.ntp_server),
            wins_server: this.relayNonEmpty(metadata.wins_server, subnet.wins_server),
            network_type: this.relayNonEmpty(metadata.network_type, 'VLAN'),
            network_interface_type: this.relayNonEmpty(metadata.network_interface_type, subnet.network_interface_type, subnet.interface_type, subnet.type),
            interface_type_label: this.relayNonEmpty(metadata.interface_type_label, subnet.interface_type_label, this.networkInterfaceTypeLabel(subnet)),
        };
    }

    private buildRelayOverviewRow(groupKey: string): any {
        const network = this.relayNetworkInfoForKey(groupKey);
        const metadata = this.relayDomainMetadataForKey(groupKey);
        return {
            groupKey,
            name: this.relayNonEmpty(metadata.name, this.relayDefaultGroupName(groupKey)),
            description: this.relayNonEmpty(metadata.description, network.description),
            subnet_name: network.name || '-',
            vlan_id: network.vlan_id || '-',
            cidr: network.cidr || '-',
            gateway: network.gateway || '-',
            dhcp_pool: network.dhcp_pool || '-',
            source: network.source,
            source_label: network.source === 'existing' ? 'Global Network' : 'Custom Network',
            network,
            authority: null,
            members: [],
            computeNodes: [],
        };
    }

    public relayOverviewRows(): any[] {
        const rows: any = {};
        const ensure = (key: any) => {
            const groupKey = String(key || '').trim() || 'default';
            if (!rows[groupKey]) rows[groupKey] = this.buildRelayOverviewRow(groupKey);
            return rows[groupKey];
        };

        Object.keys(this.relayDomainMetadata || {}).forEach((key: string) => ensure(key));

        const serverGroupById: any = {};
        for (const server of this.clusterRelayCandidateServerNodes()) {
            const groupKey = this.clusterRelayDhcpGroupKey(server);
            const row = ensure(groupKey);
            serverGroupById[String(server.id)] = groupKey;
            if (this.isClusterRelayExcluded(server)) continue;
            if (String(server.cluster_relay_role || '') === 'authority') row.authority = server;
            if (String(server.cluster_relay_role || '') === 'member') row.members.push(server);
        }

        for (const node of this.clusterRelayCandidateComputingNodes()) {
            if (this.isClusterRelayExcluded(node)) continue;
            const serverId = String(node.cluster_relay_id || '');
            const groupKey = serverGroupById[serverId];
            if (!groupKey || !rows[groupKey]) continue;
            rows[groupKey].computeNodes.push(node);
        }

        return Object.values(rows).map((row: any) => ({
            ...row,
            authority_count: row.authority ? 1 : 0,
            member_count: row.members.length,
            compute_count: row.computeNodes.length,
            total_node_count: (row.authority ? 1 : 0) + row.members.length + row.computeNodes.length,
        })).sort((left: any, right: any) => {
            const leftVlan = Number(left.vlan_id || 0);
            const rightVlan = Number(right.vlan_id || 0);
            if (leftVlan && rightVlan && leftVlan !== rightVlan) return leftVlan - rightVlan;
            return String(left.name || '').localeCompare(String(right.name || ''));
        });
    }

    public relayFilteredOverviewRows(): any[] {
        const keyword = String(this.relayGroupSearch || '').trim().toLowerCase();
        const rows = this.relayOverviewRows();
        if (!keyword) return rows;
        return rows.filter((row: any) => [
            row.name,
            row.subnet_name,
            row.network?.interface_type_label,
            row.network?.network_interface_type,
            row.vlan_id,
            row.cidr,
            row.gateway,
            row.dhcp_pool,
            row.authority?.name,
            ...(row.members || []).map((member: any) => member.name),
        ].some((value: any) => String(value || '').toLowerCase().includes(keyword)));
    }

    public relayGroupPageCount(): number {
        return Math.max(1, Math.ceil(this.relayFilteredOverviewRows().length / this.relayGroupPageSize));
    }

    public relayPagedOverviewRows(): any[] {
        const rows = this.relayFilteredOverviewRows();
        const pageCount = Math.max(1, Math.ceil(rows.length / this.relayGroupPageSize));
        this.relayGroupPage = Math.min(Math.max(1, Number(this.relayGroupPage || 1)), pageCount);
        const start = (this.relayGroupPage - 1) * this.relayGroupPageSize;
        return rows.slice(start, start + this.relayGroupPageSize);
    }

    public relayGroupSelectedCount(): number {
        return this.relayGroupSelectedKeys.size;
    }

    public relayGroupRowSelected(row: any): boolean {
        return this.relayGroupSelectedKeys.has(String(row?.groupKey || '').trim());
    }

    public relayGroupPageAllSelected(): boolean {
        const rows = this.relayPagedOverviewRows();
        return rows.length > 0 && rows.every((row: any) => this.relayGroupRowSelected(row));
    }

    public relayGroupPageSomeSelected(): boolean {
        return this.relayPagedOverviewRows().some((row: any) => this.relayGroupRowSelected(row));
    }

    public toggleRelayGroupSelection(row: any, event: any = null) {
        if (event?.stopPropagation) event.stopPropagation();
        const key = String(row?.groupKey || '').trim();
        if (!key) return;
        const checked = event?.target ? !!event.target.checked : !this.relayGroupSelectedKeys.has(key);
        if (checked) this.relayGroupSelectedKeys.add(key);
        else this.relayGroupSelectedKeys.delete(key);
        this.service.render();
    }

    public toggleRelayGroupPageSelection(event: any) {
        const checked = !!event?.target?.checked;
        const rows = this.relayPagedOverviewRows();
        for (const row of rows) {
            const key = String(row?.groupKey || '').trim();
            if (!key) continue;
            if (checked) this.relayGroupSelectedKeys.add(key);
            else this.relayGroupSelectedKeys.delete(key);
        }
        this.service.render();
    }

    private relaySelectedGroupRows(): any[] {
        const selected = new Set(Array.from(this.relayGroupSelectedKeys).map((key: any) => String(key || '').trim()).filter(Boolean));
        return this.relayOverviewRows().filter((row: any) => selected.has(String(row.groupKey || '').trim()));
    }

    private unassignRelayGroupNodes(groupKeys: Set<string>) {
        const selectedServerIds = new Set<string>();
        for (const node of this.clusterNodes || []) {
            if (!this.isClusterRelayServer(node)) continue;
            const groupKey = this.clusterRelayDhcpGroupKey(node);
            if (!groupKeys.has(groupKey)) continue;
            selectedServerIds.add(String(node.id));
            node.cluster_relay_unassigned = true;
            node.cluster_relay_role = '';
            node.cluster_relay_dhcp_group_key = '';
            node.cluster_relay_id = '';
            node.cluster_relay_excluded = false;
        }

        for (const node of this.clusterNodes || []) {
            if (this.isClusterRelayServer(node)) continue;
            const assignedRelayId = String(node.cluster_relay_id || '');
            const groupKey = this.clusterRelayDhcpGroupKey(node);
            if (!selectedServerIds.has(assignedRelayId) && !groupKeys.has(groupKey)) continue;
            node.cluster_relay_unassigned = true;
            node.cluster_relay_role = '';
            node.cluster_relay_dhcp_group_key = '';
            node.cluster_relay_id = '';
            node.cluster_relay_excluded = false;
        }
    }

    public async deleteSelectedRelayGroups() {
        const rows = this.relaySelectedGroupRows();
        if (rows.length === 0) return;
        const groupKeys = new Set(rows.map((row: any) => String(row.groupKey || '').trim()).filter(Boolean));
        if (groupKeys.size === 0) return;
        if (!confirm(`Delete ${groupKeys.size} relay group(s)? Assigned nodes will be unassigned.`)) return;

        this.relayDomainMetadata = { ...(this.relayDomainMetadata || {}) };
        for (const key of groupKeys) {
            if (this.relayDomainMetadata[key]) delete this.relayDomainMetadata[key];
        }
        this.unassignRelayGroupNodes(groupKeys);
        if (this.relayDeployTarget && groupKeys.has(String(this.relayDeployTarget.groupKey || '').trim())) {
            this.relayDeployTarget = null;
            this.relayView = 'overview';
        }
        this.relayGroupSelectedKeys = new Set();
        this.relayMessage = 'Deleting relay group...';
        await this.service.render();

        const saved = await this.ensureClusterRelayGroupSaved(false, false, true);
        if (!saved) {
            this.relayMessage = this.relayMessage || 'Failed to delete relay group.';
            await this.service.render();
            return;
        }

        this.relayMessage = 'Relay group deleted.';
        this.openRelayOverview();
        await this.service.render();
    }

    public relayGroupRangeLabel(): string {
        const total = this.relayFilteredOverviewRows().length;
        if (total === 0) return '0 - 0 of 0';
        const start = (this.relayGroupPage - 1) * this.relayGroupPageSize + 1;
        const end = Math.min(total, start + this.relayGroupPageSize - 1);
        return `${start} - ${end} of ${total}`;
    }

    public relayGroupPagePrev() {
        this.relayGroupPage = Math.max(1, this.relayGroupPage - 1);
    }

    public relayGroupPageNext() {
        this.relayGroupPage = Math.min(this.relayGroupPageCount(), this.relayGroupPage + 1);
    }

    public relayAuthorityRelayCount(): number {
        return this.clusterRelayAuthorityNodes().length;
    }

    public relayMemberRelayCount(): number {
        return this.clusterRelayServerNodes().filter((node: any) => String(node.cluster_relay_role || '') === 'member').length;
    }

    public relayManagedComputeCount(): number {
        return this.clusterRelayComputingNodes().length;
    }

    public relayDeployMemberCount(): number {
        return this.relayDeployServerNodes().filter((node: any) => String(node.cluster_relay_role || '') === 'member').length;
    }

    public relayDeployTotalVmCount(): number {
        return this.relayDeployServerNodes().length + this.relayDeployComputingNodes().length;
    }

    public relayDeployScopeLabel(): string {
        if (this.relayDeployTarget) return this.relayDeployTargetLabel() || 'Selected Relay Group';
        return `All ${this.relayOverviewRows().length} Relay Groups`;
    }

    public relayDeployScopeBreakdown(): string {
        return `Authority ${this.relayDeployAuthorityNodes().length} · Member ${this.relayDeployMemberCount()} · Compute ${this.relayDeployComputingNodes().length} · Total ${this.relayDeployTotalVmCount()} VMs`;
    }

    private relayDeployWindowBucketCounts(): any[] {
        const buckets: any = {};
        for (const node of this.relayDeployComputingNodes()) {
            const server = this.clusterRelayAssignedServer(node);
            if (!server) continue;
            const groupKey = this.clusterRelayDhcpGroupKey(server);
            if (!buckets[groupKey]) buckets[groupKey] = { remote: 0, self: 0 };
            const phase = String(server.cluster_relay_role || '') === 'authority' ? 'self' : 'remote';
            buckets[groupKey][phase] += 1;
        }
        return Object.values(buckets);
    }

    public relayDeployEstimatedWindowCount(): number {
        const windowSize = this.normalizedRelayWindowSettings().window_size;
        return Math.max(0, ...this.relayDeployWindowBucketCounts().map((bucket: any) => {
            return Math.ceil(Number(bucket.remote || 0) / windowSize) + Math.ceil(Number(bucket.self || 0) / windowSize);
        }));
    }

    public relayDeployMaxNodesPerWindow(): number {
        const windowSize = this.normalizedRelayWindowSettings().window_size;
        return Math.min(
            this.relayDeployComputingNodes().length,
            this.relayDeployWindowBucketCounts().length * windowSize,
        );
    }

    public relayDeployWindowPlanSummary(): string {
        return `Estimated ${this.relayDeployEstimatedWindowCount()} ranges · up to ${this.relayDeployMaxNodesPerWindow()} active Compute slots · slots refill on completion · deployed VMs remain powered on`;
    }

    public relayDeployStartButtonLabel(): string {
        return this.relayDeployTarget ? 'Start Relay Group Deploy' : 'Start Full Cluster Deploy';
    }

    public relayGroupSummaryCards(): any[] {
        return [
            { label: 'Relay Groups', value: this.relayOverviewRows().length, icon: 'bx bx-sitemap', className: 'text-blue-600' },
            { label: 'Authority Relays', sub: '(DHCP Only)', value: this.relayAuthorityRelayCount(), icon: 'bx bx-shield-quarter', className: 'text-emerald-600' },
            { label: 'Member Relays', sub: '(TFTP/HTTP/NFS)', value: this.relayMemberRelayCount(), icon: 'bx bx-user', className: 'text-orange-500' },
            { label: 'Managed Compute Nodes', value: this.relayManagedComputeCount(), icon: 'bx bx-laptop', className: 'text-blue-600' },
        ];
    }

    public relayServerBadges(nodes: any[]): any[] {
        return (nodes || []).slice(0, 3);
    }

    public relayServerOverflow(nodes: any[]): number {
        return Math.max(0, (nodes || []).length - 3);
    }

    public relayNodeProvisioningIp(node: any): string {
        return this.relayNonEmpty(node?.ip_address, node?.provisioning_ip, node?.template_ip, node?.bmc_ip, '-');
    }

    public relayNodeInterface(node: any): string {
        return this.relayNonEmpty(node?.provisioning_interface, node?.interface, node?.nic, node?.pxe_interface, '-');
    }

    private relayFirstAvailableSubnetKey(): string {
        const used = new Set(this.relayOverviewRows().map((row: any) => String(row.groupKey || '')));
        const unused = (this.relaySubnets || []).find((subnet: any) => subnet?.key && !used.has(String(subnet.key)));
        return String((unused || this.relaySubnets[0] || {}).key || '');
    }

    public relayGroupFormNetworkRows(): any[] {
        const keyword = String(this.relayGroupForm?.network_search || '').trim().toLowerCase();
        const rows = this.relaySubnets || [];
        if (!keyword) return rows;
        return rows.filter((subnet: any) => [
            subnet.name,
            subnet.label,
            subnet.interface_type_label,
            subnet.network_interface_type,
            subnet.interface_type,
            subnet.type,
            subnet.vlan_id,
            subnet.cidr,
            subnet.gateway,
            subnet.dns_server,
            subnet.dns_servers,
            subnet.description,
        ].some((value: any) => String(value || '').toLowerCase().includes(keyword)));
    }

    public selectRelayGroupFormSubnet(subnet: any) {
        if (!subnet?.key) return;
        const network = this.relayNetworkInfoForKey(subnet.key);
        this.relayGroupForm.group_key = subnet.key;
        this.relayGroupForm.vlan_id = network.vlan_id;
        this.relayGroupForm.cidr = network.cidr;
        this.relayGroupForm.gateway = network.gateway;
        this.relayGroupForm.dhcp_start = network.dhcp_start;
        this.relayGroupForm.dhcp_end = network.dhcp_end;
        this.relayGroupForm.network_description = network.description;
        this.relayGroupForm.dns_server = network.dns_server;
        this.relayGroupForm.domain_name = network.domain_name;
        this.relayGroupForm.ntp_server = network.ntp_server;
        this.relayGroupForm.wins_server = network.wins_server;
        if (!this.relayGroupForm.name) this.relayGroupForm.name = this.relayDefaultGroupName(subnet.key);
    }

    public onRelayGroupFormNetworkModeChanged() {
        if (this.relayGroupForm.network_mode === 'existing') {
            const key = this.relayGroupForm.group_key || this.relayFirstAvailableSubnetKey();
            const subnet = (this.relaySubnets || []).find((row: any) => String(row.key) === String(key));
            if (subnet) this.selectRelayGroupFormSubnet(subnet);
        } else {
            this.relayGroupForm.group_key = '';
        }
    }

    private relayGroupFormFromRow(row: any = null): any {
        const groupKey = String(row?.groupKey || this.relayFirstAvailableSubnetKey() || '').trim();
        const network = this.relayNetworkInfoForKey(groupKey);
        return {
            original_group_key: groupKey,
            name: row?.name || this.relayDefaultGroupName(groupKey),
            description: row?.description || '',
            network_mode: row ? (network.source === 'existing' ? 'existing' : 'new') : 'existing',
            network_search: '',
            group_key: groupKey,
            network_type: network.network_type || 'VLAN',
            vlan_id: network.vlan_id,
            cidr: network.cidr,
            gateway: network.gateway,
            dhcp_start: network.dhcp_start,
            dhcp_end: network.dhcp_end,
            network_description: network.description,
            dns_server: network.dns_server,
            domain_name: network.domain_name,
            ntp_server: network.ntp_server,
            wins_server: network.wins_server,
        };
    }

    public openRelayOverview() {
        this.relayView = 'overview';
        this.relayGroupFormMessage = '';
        this.relayAssignmentMessage = '';
    }

    public openRelayGroupAdd() {
        this.relayGroupFormMode = 'add';
        this.relayGroupForm = this.relayGroupFormFromRow(null);
        this.relayGroupFormMessage = '';
        this.relayView = 'form';
    }

    public openRelayGroupEdit(row: any) {
        this.relayGroupFormMode = 'edit';
        this.relayGroupForm = this.relayGroupFormFromRow(row);
        this.relayGroupFormMessage = '';
        this.relayView = 'form';
    }

    public openRelayClusterDeploy(row: any) {
        this.relayDeployTarget = row ? {
            groupKey: row.groupKey,
            name: row.name,
            subnet_name: row.subnet_name,
            vlan_id: row.vlan_id,
            cidr: row.cidr,
            gateway: row.gateway,
            dhcp_pool: row.dhcp_pool,
        } : null;
        const persistedName = String(this.clusterRelayGroup()?.name || '').trim();
        this.relayName = persistedName || this.relayName || `Cluster-${this.item?.name || this.id}-Relay`;
        this.relayPreflightReport = null;
        this.relayPreflightCollapsed = {};
        this.relayAllowOverride = false;
        this.relayMessage = '';
        this.relayView = 'deploy';
        this.syncRelayDeploymentStatusFromNodes();
        this.updateRelayDeployStats();
    }

    public clearRelayDeployTarget() {
        this.relayDeployTarget = null;
        this.openRelayOverview();
    }

    public relayDeployTargetLabel(): string {
        const target = this.relayDeployTarget || {};
        const values = [
            target.name,
            target.subnet_name,
            target.vlan_id && target.vlan_id !== '-' ? `VLAN ${target.vlan_id}` : '',
            target.cidr,
        ];
        return values.filter((value: any) => String(value || '').trim() && String(value || '').trim() !== '-').join(' · ');
    }

    private relayCustomGroupKeyFromForm(): string {
        if (this.relayGroupForm.network_mode === 'existing') return String(this.relayGroupForm.group_key || '').trim();
        const vlanId = String(this.relayGroupForm.vlan_id || '').trim();
        if (vlanId) return `vlan:${vlanId}`;
        const cidr = String(this.relayGroupForm.cidr || '').trim();
        if (cidr) return `cidr:${cidr}`;
        const name = String(this.relayGroupForm.name || 'custom').trim().replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'custom';
        return `custom:${name.toLowerCase()}`;
    }

    private relayGroupNameExists(name: any, excludeGroupKey: any = ''): boolean {
        const normalized = String(name || '').trim().toLowerCase();
        const excluded = String(excludeGroupKey || '').trim();
        if (!normalized) return false;
        return this.relayOverviewRows().some((row: any) => {
            return String(row.groupKey || '').trim() !== excluded
                && String(row.name || '').trim().toLowerCase() === normalized;
        });
    }

    public async saveRelayGroupForm() {
        const name = String(this.relayGroupForm.name || '').trim();
        if (!name) {
            this.relayGroupFormMessage = 'Relay Group Name is required.';
            await this.service.render();
            return;
        }
        const oldKey = String(this.relayGroupForm.original_group_key || '').trim();
        if (this.relayGroupNameExists(name, oldKey)) {
            this.relayGroupFormMessage = 'Relay Group Name already exists.';
            await this.service.render();
            return;
        }
        const groupKey = this.relayCustomGroupKeyFromForm();
        if (!groupKey) {
            this.relayGroupFormMessage = 'Provisioning Network is required.';
            await this.service.render();
            return;
        }
        if (this.relayGroupForm.network_mode !== 'existing' && !String(this.relayGroupForm.cidr || '').trim()) {
            this.relayGroupFormMessage = 'CIDR is required for a new network.';
            await this.service.render();
            return;
        }

        const nextMetadata = {
            name,
            description: String(this.relayGroupForm.description || '').trim(),
            source: this.relayGroupForm.network_mode === 'existing' ? 'existing' : 'custom',
            network_type: String(this.relayGroupForm.network_type || 'VLAN').trim(),
            vlan_id: String(this.relayGroupForm.vlan_id || '').trim(),
            cidr: String(this.relayGroupForm.cidr || '').trim(),
            gateway: String(this.relayGroupForm.gateway || '').trim(),
            dhcp_start: String(this.relayGroupForm.dhcp_start || '').trim(),
            dhcp_end: String(this.relayGroupForm.dhcp_end || '').trim(),
            description_network: String(this.relayGroupForm.network_description || '').trim(),
            dns_server: String(this.relayGroupForm.dns_server || '').trim(),
            domain_name: String(this.relayGroupForm.domain_name || '').trim(),
            ntp_server: String(this.relayGroupForm.ntp_server || '').trim(),
            wins_server: String(this.relayGroupForm.wins_server || '').trim(),
        };

        this.relayDomainMetadata = { ...(this.relayDomainMetadata || {}) };
        if (oldKey && oldKey !== groupKey && this.relayDomainMetadata[oldKey]) delete this.relayDomainMetadata[oldKey];
        this.relayDomainMetadata[groupKey] = nextMetadata;
        if (oldKey && oldKey !== groupKey) {
            for (const node of this.clusterNodes || []) {
                if (this.clusterRelayDhcpGroupKey(node) === oldKey) node.cluster_relay_dhcp_group_key = groupKey;
            }
        }

        this.relayGroupFormMessage = 'Saving relay group...';
        await this.service.render();
        const saved = await this.ensureClusterRelayGroupSaved(false);
        if (!saved) {
            this.relayGroupFormMessage = this.relayMessage || 'Failed to save relay group.';
            await this.service.render();
            return;
        }
        this.relayMessage = this.relayGroupFormMode === 'edit' ? 'Relay group updated.' : 'Relay group added.';
        this.openRelayOverview();
        await this.service.render();
    }

    public openRelayAssignment(row: any) {
        this.relayAssignmentGroupKey = String(row?.groupKey || '').trim();
        this.relayAssignmentAuthorityId = row?.authority?.id ? String(row.authority.id) : '';
        this.relayAssignmentMemberIds = {};
        for (const member of row?.members || []) {
            if (member?.id) this.relayAssignmentMemberIds[String(member.id)] = true;
        }
        this.relayAssignmentMessage = '';
        this.relayView = 'assignment';
    }

    public relayAssignmentRow(): any {
        return this.relayOverviewRows().find((row: any) => String(row.groupKey) === String(this.relayAssignmentGroupKey)) || this.buildRelayOverviewRow(this.relayAssignmentGroupKey);
    }

    public relayAssignmentCandidateNodes(): any[] {
        const groupKey = String(this.relayAssignmentGroupKey || '').trim();
        const relayLike = (this.clusterNodes || []).filter((node: any) => {
            if (this.nodeMappingRoleKey(node) === 'relay') return true;
            return this.isClusterRelayServer(node) && this.clusterRelayDhcpGroupKey(node) === groupKey;
        });
        return relayLike.length > 0 ? relayLike : (this.clusterNodes || []);
    }

    public relayAssignmentMemberChecked(node: any): boolean {
        return !!this.relayAssignmentMemberIds[String(node?.id || '')];
    }

    public setRelayAssignmentAuthority(node: any) {
        const nodeId = String(node?.id || '');
        this.relayAssignmentAuthorityId = nodeId;
        if (nodeId && this.relayAssignmentMemberIds[nodeId]) delete this.relayAssignmentMemberIds[nodeId];
    }

    public toggleRelayAssignmentMember(node: any, event: any) {
        const nodeId = String(node?.id || '');
        if (!nodeId || nodeId === String(this.relayAssignmentAuthorityId || '')) return;
        this.relayAssignmentMemberIds = { ...(this.relayAssignmentMemberIds || {}) };
        if (event?.target?.checked) this.relayAssignmentMemberIds[nodeId] = true;
        else delete this.relayAssignmentMemberIds[nodeId];
    }

    public relayAssignmentSelectedMembers(): any[] {
        const selectedIds = new Set(Object.keys(this.relayAssignmentMemberIds || {}).filter((key: string) => this.relayAssignmentMemberIds[key]));
        return (this.clusterNodes || []).filter((node: any) => selectedIds.has(String(node.id)));
    }

    public relayAssignmentAuthorityNode(): any {
        const authorityId = String(this.relayAssignmentAuthorityId || '');
        return (this.clusterNodes || []).find((node: any) => String(node.id) === authorityId) || null;
    }

    public relayAssignmentComputeCandidates(): any[] {
        const row = this.relayAssignmentRow();
        const groupKey = String(this.relayAssignmentGroupKey || '').trim();
        const selectedServerIds = new Set([
            String(this.relayAssignmentAuthorityId || ''),
            ...Object.keys(this.relayAssignmentMemberIds || {}).filter((key: string) => this.relayAssignmentMemberIds[key]),
        ].filter(Boolean));
        const groupServerIds = new Set([
            ...(row.authority?.id ? [String(row.authority.id)] : []),
            ...(row.members || []).map((member: any) => String(member.id)),
            ...Array.from(selectedServerIds),
        ]);
        return (this.clusterNodes || []).filter((node: any) => {
            const nodeId = String(node.id);
            if (selectedServerIds.has(nodeId)) return false;
            if (this.isClusterRelayServer(node)) return false;
            const assigned = String(node.cluster_relay_id || '');
            return this.clusterRelayNodeMatchesGroupKey(node, groupKey) || groupServerIds.has(assigned);
        });
    }

    public relayAssignmentComputeSamples(): any[] {
        return this.relayAssignmentComputeCandidates().slice(0, 10);
    }

    public relayAssignmentSummaryMembersLabel(): string {
        const members = this.relayAssignmentSelectedMembers();
        if (members.length === 0) return '-';
        return `${members.length} node${members.length > 1 ? 's' : ''}`;
    }

    public async saveRelayAssignment() {
        const groupKey = String(this.relayAssignmentGroupKey || '').trim();
        const authorityId = String(this.relayAssignmentAuthorityId || '').trim();
        const memberIds = Object.keys(this.relayAssignmentMemberIds || {}).filter((key: string) => this.relayAssignmentMemberIds[key]);
        if (!groupKey) {
            this.relayAssignmentMessage = 'Relay group is not selected.';
            await this.service.render();
            return;
        }
        if (!authorityId) {
            this.relayAssignmentMessage = 'Select one Authority Relay.';
            await this.service.render();
            return;
        }
        if (memberIds.length === 0) {
            this.relayAssignmentMessage = 'Select at least one Member Relay.';
            await this.service.render();
            return;
        }

        const computeCandidates = this.relayAssignmentComputeCandidates();
        const selectedServerIds = new Set([authorityId, ...memberIds]);
        const primaryRelayIds = memberIds.length > 0 ? memberIds : [authorityId];

        for (const node of this.clusterNodes || []) {
            const nodeId = String(node.id);
            const nodeGroupKey = this.clusterRelayDhcpGroupKey(node);
            if (nodeId === authorityId) {
                node.cluster_relay_unassigned = false;
                node.cluster_relay_role = 'authority';
                node.cluster_relay_dhcp_group_key = groupKey;
                node.cluster_relay_id = '';
                node.cluster_relay_excluded = false;
                continue;
            }
            if (memberIds.includes(nodeId)) {
                node.cluster_relay_unassigned = false;
                node.cluster_relay_role = 'member';
                node.cluster_relay_dhcp_group_key = groupKey;
                node.cluster_relay_id = '';
                node.cluster_relay_excluded = false;
                continue;
            }
            if (this.isClusterRelayServer(node) && nodeGroupKey === groupKey && !selectedServerIds.has(nodeId)) {
                node.cluster_relay_unassigned = true;
                node.cluster_relay_role = '';
                node.cluster_relay_dhcp_group_key = '';
                node.cluster_relay_id = '';
                node.cluster_relay_excluded = false;
            }
        }

        computeCandidates.forEach((node: any, index: number) => {
            node.cluster_relay_unassigned = false;
            node.cluster_relay_role = '';
            node.cluster_relay_dhcp_group_key = this.defaultClusterRelayGroupKey(node);
            node.cluster_relay_id = primaryRelayIds[index % primaryRelayIds.length] || '';
            node.cluster_relay_excluded = false;
        });

        this.normalizeClusterRelayConfig();
        this.relayAssignmentMessage = 'Saving relay assignment...';
        await this.service.render();
        const saved = await this.ensureClusterRelayGroupSaved(false);
        if (!saved) {
            this.relayAssignmentMessage = this.relayMessage || 'Failed to save relay assignment.';
            await this.service.render();
            return;
        }
        this.relayMessage = 'Relay assignment saved.';
        this.openRelayOverview();
        await this.service.render();
    }

    public relaySelectedImage(kind: string): any {
        const imageId = Number(kind === 'head' ? this.relayForm.relay_image_id : this.relayForm.computing_image_id);
        return this.relayImages.find((image: any) => Number(image.id) === imageId) || null;
    }

    private relayImageMatches(node: any): boolean {
        const selectedImageId = String(this.relayForm.relay_image_id || '').trim();
        if (!selectedImageId) return true;
        return String(node?.image_id || '').trim() === selectedImageId;
    }

    private relayDeploymentStateFromNode(node: any): any {
        if (!this.relayForm.relay_image_id) {
            return {
                imageDeployed: false,
                ready: false,
                osReady: false,
                failed: false,
                status: 'pending',
                deployStatus: '',
                message: ''
            };
        }
        const status = String(node?.status || '').trim().toLowerCase();
        const deployStatus = String(node?.deploy_status || '').trim().toLowerCase();
        const imageMatches = this.relayImageMatches(node);
        const failed = status === 'failed' || status === 'error' || deployStatus.endsWith('failed');
        const ready = imageMatches && !failed && status === 'relay-ready';
        const deployed = imageMatches && !ready && !failed && (
            ['deployed', 'commissioned', 'active'].includes(status) ||
            ['deployed', 'active'].includes(deployStatus)
        );
        const deploying = imageMatches && !ready && !deployed && !failed && (
            status.includes('deploy') ||
            status.includes('diskless') ||
            status.includes('commission') ||
            deployStatus.includes('deploy') ||
            deployStatus.includes('diskless') ||
            deployStatus.includes('commission')
        );
        return {
            imageDeployed: ready || deployed || deploying,
            ready,
            osReady: ready,
            failed,
            status: ready ? 'relay-ready' : (deployed ? 'deployed' : (status || deployStatus)),
            deployStatus,
            message: imageMatches ? '' : 'Selected image does not match current relay server image.'
        };
    }

    private syncRelayDeploymentStatusFromNodes() {
        const relayServers = this.relayDeployServerNodes();
        if (relayServers.length === 0) {
            this.relayDeploymentStatus = {};
            return;
        }
        const nextStatus: any = {};
        for (const server of relayServers) {
            const current = this.relayDeploymentStatus[server.id] || {};
            nextStatus[server.id] = {
                ...this.relayDeploymentStateFromNode(server),
                deployStartedAt: current.deployStartedAt || this.relayHeadDeployStartedAt,
                deployCompletedAt: current.deployCompletedAt || this.relayHeadDeployCompletedAt,
                deployElapsedSeconds: current.deployElapsedSeconds || 0,
                deployDurationSeconds: current.deployDurationSeconds || 0
            };
        }
        this.relayDeploymentStatus = nextStatus;
    }

    public async onRelayImageChanged() {
        if (!this.relayForm.computing_image_id) {
            this.relayForm.computing_image_id = this.relayForm.relay_image_id;
        }
        this.relayPreflightReport = null;
        this.relayPreflightCollapsed = {};
        this.syncRelayDeploymentStatusFromNodes();
        const done = await this.refreshRelayHeadStatus(false);
        if (!done) this.startRelayHeadPoll();
        await this.service.render();
    }

    public relayStatus(nodeId: any): any {
        return this.relayDeploymentStatus[nodeId] || {};
    }

    private relayNormalizedStatus(value: any): string {
        return String(value || '').trim().toLowerCase();
    }

    private relayNowTimestamp(): string {
        return new Date().toISOString();
    }

    private relayTimestampMs(value: any): number {
        if (!value) return 0;
        if (value instanceof Date) return value.getTime();
        const raw = String(value || '').trim();
        if (!raw) return 0;
        const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const parsed = Date.parse(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    private relayElapsedSecondsValue(startedAt: any, completedAt: any = ''): number {
        const started = this.relayTimestampMs(startedAt);
        if (!started) return 0;
        const completed = this.relayTimestampMs(completedAt);
        const end = completed || Date.now();
        return Math.max(0, Math.floor((end - started) / 1000));
    }

    private relayNumericSeconds(value: any): number {
        const seconds = Number(value || 0);
        return Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
    }

    public relayFormatDuration(seconds: any): string {
        const total = this.relayNumericSeconds(seconds);
        if (total <= 0) return '';
        const hours = Math.floor(total / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const secs = total % 60;
        if (hours > 0) return `${hours}h ${minutes}m ${secs}s`;
        if (minutes > 0) return `${minutes}m ${secs}s`;
        return `${secs}s`;
    }

    private relayIsFinalStatus(status: any): boolean {
        return ['completed', 'failed', 'cancelled', 'error'].includes(this.relayNormalizedStatus(status));
    }

    private relayIsHeadFinalStatus(status: any): boolean {
        return ['relay-ready', 'ready', 'deployed', 'completed', 'active', 'commissioned', 'failed', 'error'].includes(this.relayNormalizedStatus(status));
    }

    private syncRelayHeadDeployTiming(data: any, finalState: boolean = false) {
        const startedAt = data?.deploy_started_at || '';
        const completedAt = data?.deploy_completed_at || '';
        if (startedAt) this.relayHeadDeployStartedAt = startedAt;
        if (completedAt) this.relayHeadDeployCompletedAt = completedAt;
        if (finalState && this.relayHeadDeployStartedAt && !this.relayHeadDeployCompletedAt) {
            this.relayHeadDeployCompletedAt = this.relayNowTimestamp();
        }
    }

    public relayHeadDeployDurationLabel(nodeId: any): string {
        const state = this.relayStatus(nodeId);
        const status = this.relayHeadDeployStatus(nodeId);
        const finalState = this.relayIsHeadFinalStatus(status);
        const startedAt = state?.deployStartedAt || this.relayHeadDeployStartedAt;
        const completedAt = state?.deployCompletedAt || this.relayHeadDeployCompletedAt;
        const serverSeconds = this.relayNumericSeconds(
            finalState ? (state?.deployDurationSeconds || state?.deployElapsedSeconds) : state?.deployElapsedSeconds
        );
        const seconds = serverSeconds || this.relayElapsedSecondsValue(startedAt, finalState ? completedAt : '');
        const formatted = this.relayFormatDuration(seconds);
        if (!formatted) return '';
        const label = finalState && ['failed', 'error'].includes(this.relayNormalizedStatus(status)) ? 'Ended in' : (finalState ? 'Completed in' : 'Elapsed');
        return `${label} ${formatted}`;
    }

    public relayOrchestrationDurationLabel(): string {
        const job = this.relayOrchestrationJob;
        if (!job) return '';
        const finalState = this.relayIsFinalStatus(job.status);
        const serverSeconds = this.relayNumericSeconds(
            finalState ? (job.duration_seconds || job.elapsed_seconds) : job.elapsed_seconds
        );
        const seconds = serverSeconds || this.relayElapsedSecondsValue(job.started || job.created, finalState ? job.completed : '');
        const formatted = this.relayFormatDuration(seconds);
        if (!formatted) return '';
        const label = finalState && this.relayNormalizedStatus(job.status) !== 'completed' ? 'Ended in' : (finalState ? 'Completed in' : 'Elapsed');
        return `${label} ${formatted}`;
    }

    public relayOrchestrationStepDurationLabel(step: any): string {
        if (!step) return '';
        const status = this.relayNormalizedStatus(step.status);
        const finalState = this.relayIsFinalStatus(status);
        const serverSeconds = this.relayNumericSeconds(
            finalState ? (step.duration_seconds || step.elapsed_seconds) : step.elapsed_seconds
        );
        const seconds = serverSeconds || this.relayElapsedSecondsValue(step.started, finalState ? step.completed : '');
        if (seconds < this.relayShortDurationThresholdSeconds) return '';
        const formatted = this.relayFormatDuration(seconds);
        if (!formatted) return '';
        if (status === 'completed') return `Completed in ${formatted}`;
        return `${finalState ? 'Ended in' : 'Elapsed'} ${formatted}`;
    }

    public relayHeadDeployStatus(nodeId: any): string {
        const state = this.relayStatus(nodeId);
        const status = this.relayNormalizedStatus(state?.status);
        const deployStatus = this.relayNormalizedStatus(state?.deployStatus || state?.deploy_status);
        const combined = `${status} ${deployStatus}`.trim();

        if (state?.failed || status === 'failed' || status === 'error' || deployStatus === 'error' || deployStatus.endsWith('failed')) {
            return 'failed';
        }
        if (state?.ready || status === 'relay-ready' || deployStatus === 'relay-ready') {
            return 'relay-ready';
        }
        if (status === 'ready' || deployStatus === 'ready') {
            return 'pending';
        }
        if (['deployed', 'completed', 'active', 'commissioned'].includes(status)) {
            return status;
        }
        if (['deployed', 'completed', 'active', 'commissioned'].includes(deployStatus)) {
            return deployStatus;
        }
        if (this.relayDeployingHead || this.relayHeadDeploySubmitted) {
            return 'deploying';
        }
        if (state?.imageDeployed || combined.includes('deploy') || combined.includes('diskless') || combined.includes('commission') || combined.includes('running') || combined.includes('progress') || combined.includes('queued')) {
            return 'deploying';
        }
        return status || deployStatus || 'pending';
    }

    private relayStatusInProgress(status: any): boolean {
        return ['deploying', 'queued', 'running', 'in_progress', 'diskless', 'commissioning'].includes(this.relayNormalizedStatus(status));
    }

    public relayHeadDeployInProgress(nodeId: any): boolean {
        if (this.relayDeployingHead) return true;
        const status = this.relayHeadDeployStatus(nodeId);
        if (['relay-ready', 'ready', 'deployed', 'completed', 'active', 'commissioned', 'failed', 'error'].includes(this.relayNormalizedStatus(status))) {
            return false;
        }
        return this.relayHeadDeploySubmitted || this.relayStatusInProgress(status);
    }

    public relayAnyServerDeployInProgress(): boolean {
        return this.relayDeployServerNodes().some((server: any) => this.relayHeadDeployInProgress(server.id));
    }

    public relayStatusBadgeClass(status: string): string {
        switch (String(status || '').toLowerCase()) {
            case 'ok':
            case 'relay-ready':
            case 'ready':
            case 'completed':
            case 'deployed':
            case 'active':
            case 'commissioned':
                return 'bg-green-100 text-green-700';
            case 'warning':
            case 'pending':
            case 'paused':
                return 'bg-amber-100 text-amber-700';
            case 'running':
            case 'in_progress':
            case 'deploying':
            case 'diskless':
            case 'queued':
                return 'bg-blue-100 text-blue-700';
            case 'failed':
            case 'error':
                return 'bg-red-100 text-red-700';
            default:
                return 'bg-zinc-100 text-zinc-600';
        }
    }

    public async deployRelayHead() {
        const relayServers = this.relayDeployServerNodes();
        if (relayServers.length === 0) {
            this.relayMessage = 'Check at least one relay server to work on.';
            await this.service.render();
            return;
        }
        if (!this.relayForm.relay_image_id) {
            this.relayMessage = 'Select a relay server image first.';
            await this.service.render();
            return;
        }
        if (relayServers.some((server: any) => this.relayHeadDeployInProgress(server.id))) {
            this.relayMessage = 'Relay server deploy is already in progress.';
            await this.service.render();
            return;
        }
        if (!confirm(`Deploy relay image to ${relayServers.length} relay server(s)?`)) return;

        this.clearRelayHeadPowerCheckTimer();
        this.relayDeployingHead = true;
        this.relayHeadDeploySubmitted = true;
        this.relayHeadDeployStartedAt = this.relayNowTimestamp();
        this.relayHeadDeployCompletedAt = '';
        this.relayMessage = '';
        for (const server of relayServers) {
            this.relayDeploymentStatus[server.id] = {
                imageDeployed: true,
                ready: false,
                osReady: false,
                failed: false,
                status: 'deploying',
                deployStatus: 'deploying',
                deployStartedAt: this.relayHeadDeployStartedAt,
                deployCompletedAt: ''
            };
        }
        await this.service.render();

        const failures: string[] = [];
        for (const server of relayServers) {
            const { code, data } = await this.relayApi("deploy_server", {
                node_id: server.id,
                image_id: this.relayForm.relay_image_id
            });
            if (code !== 200) {
                const completedAt = this.relayNowTimestamp();
                failures.push(`${server.name}: ${data?.message || 'Deploy failed.'}`);
                this.relayDeploymentStatus[server.id] = {
                    imageDeployed: false,
                    ready: false,
                    osReady: false,
                    failed: true,
                    status: 'failed',
                    deployStatus: 'failed',
                    message: data?.message || 'Deploy failed.',
                    deployStartedAt: this.relayHeadDeployStartedAt,
                    deployCompletedAt: completedAt,
                    deployElapsedSeconds: this.relayElapsedSecondsValue(this.relayHeadDeployStartedAt, completedAt),
                    deployDurationSeconds: this.relayElapsedSecondsValue(this.relayHeadDeployStartedAt, completedAt)
                };
            }
        }
        this.relayDeployingHead = false;
        if (failures.length > 0) {
            this.relayHeadDeploySubmitted = false;
            this.relayHeadDeployCompletedAt = this.relayNowTimestamp();
            this.relayMessage = failures.join('; ');
            await this.service.render();
            return;
        }
        this.relayMessage = 'Relay server deploy queued.';
        this.scheduleRelayHeadPowerCheck();
        const done = await this.refreshRelayHeadStatus(false);
        if (!done) this.startRelayHeadPoll();
        await this.service.render();
    }

    public async refreshRelayHeadStatus(shouldRender: boolean = true): Promise<boolean> {
        const relayServers = this.relayDeployServerNodes();
        if (relayServers.length === 0 || !this.relayForm.relay_image_id) {
            this.relayHeadDeploySubmitted = false;
            this.syncRelayDeploymentStatusFromNodes();
            if (shouldRender) await this.service.render();
            return false;
        }

        let allDone = true;
        let allReady = true;
        for (const server of relayServers) {
            const { code, data } = await this.relayApi("deploy_server_status", {
                node_id: server.id,
                image_id: this.relayForm.relay_image_id
            });
            if (code !== 200) {
                allDone = false;
                allReady = false;
                continue;
            }

            if (data?.failed) {
                this.syncRelayHeadDeployTiming(data, true);
                this.relayDeploymentStatus[server.id] = {
                    imageDeployed: false,
                    ready: false,
                    osReady: false,
                    failed: true,
                    status: data.status || 'failed',
                    deployStatus: data.deploy_status || '',
                    powerState: data?.power_state || '',
                    deployStartedAt: this.relayHeadDeployStartedAt,
                    deployCompletedAt: this.relayHeadDeployCompletedAt,
                    deployElapsedSeconds: this.relayNumericSeconds(data?.deploy_elapsed_seconds),
                    deployDurationSeconds: this.relayNumericSeconds(data?.deploy_duration_seconds),
                    readyWaitRemainingSeconds: this.relayNumericSeconds(data?.ready_wait_remaining_seconds),
                    message: data.message || ''
                };
                allReady = false;
                continue;
            }

            const imageMatches = data?.image_matches !== false;
            const statusText = `${data?.status || ''} ${data?.deploy_status || ''}`.toLowerCase();
            const imageDeployed = data?.image_deployed !== undefined
                ? !!data.image_deployed
                : imageMatches && (
                    data?.ready ||
                    statusText.includes('deploy') ||
                    statusText.includes('diskless') ||
                    statusText.includes('commission')
                );
            this.syncRelayHeadDeployTiming(data, !!data?.ready || !!data?.failed);
            this.relayDeploymentStatus[server.id] = {
                imageDeployed,
                ready: !!data?.ready,
                osReady: !!data?.os_ready,
                failed: !!data?.failed,
                status: data?.ready ? 'relay-ready' : (data?.status || ''),
                deployStatus: data?.deploy_status || '',
                powerState: data?.power_state || '',
                deployStartedAt: this.relayHeadDeployStartedAt,
                deployCompletedAt: this.relayHeadDeployCompletedAt,
                deployElapsedSeconds: this.relayNumericSeconds(data?.deploy_elapsed_seconds),
                deployDurationSeconds: this.relayNumericSeconds(data?.deploy_duration_seconds),
                readyWaitRemainingSeconds: this.relayNumericSeconds(data?.ready_wait_remaining_seconds),
                message: data?.message || ''
            };
            if (!data?.ready) {
                allDone = false;
                allReady = false;
            }
        }
        if (allDone) this.relayHeadDeploySubmitted = false;
        if (allReady && this.relayHeadPoller) {
            clearInterval(this.relayHeadPoller);
            this.relayHeadPoller = null;
        }
        if (!allReady) this.startRelayHeadPoll();
        if (shouldRender) await this.service.render();
        return allReady;
    }

    private startRelayHeadPoll() {
        if (this.relayHeadPoller) return;
        this.relayHeadPoller = setInterval(async () => {
            const done = await this.refreshRelayHeadStatus(false);
            if (done && this.relayHeadPoller) {
                clearInterval(this.relayHeadPoller);
                this.relayHeadPoller = null;
            }
            await this.service.render();
        }, 10000);
    }

    private clusterRelayServerPersistStatus(serverStatus: any): string {
        const status = this.relayNormalizedStatus(serverStatus?.status || serverStatus?.deployStatus || serverStatus?.deploy_status);
        if (serverStatus?.ready) return 'relay-ready';
        if (serverStatus?.failed || status === 'failed' || status === 'error') return 'error';
        if (serverStatus?.imageDeployed) {
            if (['deployed', 'active', 'commissioned'].includes(status)) return 'deployed';
            return 'deploying';
        }
        return 'pending';
    }

    private buildClusterRelayPayload(): any {
        this.normalizeClusterRelayConfig();
        const relayServers = this.clusterRelayServerNodes();
        const relayServerCandidates = this.clusterRelayCandidateServerNodes();
        const computingNodes = this.clusterRelayComputingNodes();
        const excludedNodes = (this.clusterNodes || []).filter((node: any) => this.isClusterRelayExcluded(node));
        const excludedComputingNodes = this.clusterRelayExcludedComputingNodes();
        const computeWindowSettings = this.normalizedRelayWindowSettings();
        const relayDomainMetadata = this.relayDomainMetadata && typeof this.relayDomainMetadata === 'object'
            ? this.relayDomainMetadata
            : {};
        const relayDomainKeys = Object.keys(relayDomainMetadata);
        return {
            name: this.relayName || `Cluster-${this.item?.name || this.id}-Relay`,
            is_dummy: false,
            compute_window_settings: computeWindowSettings,
            clear_computing_nodes: computingNodes.length === 0,
            clear_cluster_node_config: relayServers.length === 0 && computingNodes.length === 0 && relayDomainKeys.length === 0,
            node_selection: {
                mode: 'cluster',
                cluster_id: this.id,
                cluster_name: this.item?.name || '',
                relay_domain_keys: relayDomainKeys,
                relay_domain_metadata: relayDomainMetadata,
                relay_node_ids: relayServers.map((node: any) => node.id),
                relay_candidate_node_ids: relayServerCandidates.map((node: any) => node.id),
                inactive_relay_node_ids: this.clusterRelayExcludedServerNodes().map((node: any) => node.id),
                relay_server_configs: this.clusterRelayServerConfigSnapshot(),
                computing_node_ids: computingNodes.map((node: any) => node.id),
                unassigned_computing_node_ids: this.clusterRelayUnassignedComputingNodes().map((node: any) => node.id),
                excluded_computing_node_ids: excludedComputingNodes.map((node: any) => node.id),
                excluded_node_ids: excludedNodes.map((node: any) => node.id),
                assignments: this.clusterRelayAssignments(),
                all_assignments: this.clusterRelayAllAssignments(),
                compute_window_settings: computeWindowSettings
            },
            relay_servers: relayServers.map((server: any) => {
                const serverStatus = this.relayStatus(server.id);
                return {
                    node_id: server.id,
                    image_id: this.relayForm.relay_image_id,
                    dhcp_group_key: this.clusterRelayDhcpGroupKey(server),
                    is_dhcp_server: String(server.cluster_relay_role || '') === 'authority' ? 1 : 0,
                    status: this.clusterRelayServerPersistStatus(serverStatus),
                    ready: !!serverStatus.ready
                };
            }),
            computing_nodes: computingNodes.map((node: any) => ({
                node_id: node.id,
                relay_server_id: node.cluster_relay_id || '',
                relay_server_node_id: node.cluster_relay_id || '',
                status: this.relayNodeDeployStatus[node.id]?.status || 'pending'
            }))
        };
    }

    private buildClusterRelayRequestPayload(groupId: string = ''): any {
        this.normalizeClusterRelayConfig();
        const relayServers = this.relayDeployServerNodes();
        const computingNodes = this.relayDeployComputingNodes();
        return {
            group_id: groupId || this.relayCreatedId || '',
            target_relay_group_key: this.relayDeployTargetGroupKey(),
            target_relay_group: this.relayDeployTarget || null,
            group: this.buildClusterRelayPayload(),
            relay_servers: relayServers.map((server: any) => ({
                ...server,
                node_id: server.id,
                image_id: this.relayForm.relay_image_id,
                dhcp_group_key: this.clusterRelayDhcpGroupKey(server),
                is_dhcp_server: String(server.cluster_relay_role || '') === 'authority' ? 1 : 0,
            })),
            computing_nodes: computingNodes.map((node: any) => ({
                ...node,
                node_id: node.id,
                relay_server_id: node.cluster_relay_id || '',
                relay_server_node_id: node.cluster_relay_id || '',
            })),
            assignments: this.relayDeployAssignments(),
            all_assignments: this.relayDeployAllAssignments(),
            relay_image_id: this.relayForm.relay_image_id,
            computing_image_id: this.relayForm.computing_image_id,
            compute_window_settings: this.normalizedRelayWindowSettings(),
            use_dummy: false,
            clear_computing_nodes: computingNodes.length === 0,
            force: this.relayOverrideRequested()
        };
    }

    private async autoSaveClusterRelayGroup(successMessage: string = 'Relay config saved.') {
        this.relayConfigAutoSaveMessage = successMessage;
        if (this.relayConfigAutoSaveRunning) {
            this.relayConfigAutoSaveQueued = true;
            return;
        }

        this.relayConfigAutoSaveRunning = true;
        try {
            do {
                this.relayConfigAutoSaveQueued = false;
                this.relayMessage = 'Saving relay config...';
                const groupId = await this.ensureClusterRelayGroupSaved(false);
                if (groupId) this.relayMessage = this.relayConfigAutoSaveMessage;
            } while (this.relayConfigAutoSaveQueued);
        } finally {
            this.relayConfigAutoSaveRunning = false;
            await this.service.render();
        }
    }

    private async ensureClusterRelayGroupSaved(showAlert: boolean = false, deployScopeOnly: boolean = false, allowEmpty: boolean = false): Promise<string | null> {
        this.normalizeClusterRelayConfig();
        const activeRelayServerCount = deployScopeOnly ? this.relayDeployServerNodes().length : this.clusterRelayServerNodes().length;
        const candidateRelayServerCount = deployScopeOnly ? this.relayDeployCandidateServerNodes().length : this.clusterRelayCandidateServerNodes().length;
        const computingNodes = deployScopeOnly ? this.relayDeployComputingNodes() : this.clusterRelayComputingNodes();
        const configValid = deployScopeOnly ? this.relayDeployConfigValid() : this.clusterRelayConfigValid();
        const hasRelayDomainMetadata = Object.keys(this.relayDomainMetadata || {}).length > 0;
        if (!allowEmpty && candidateRelayServerCount === 0 && !hasRelayDomainMetadata) {
            this.relayMessage = 'Select at least one relay server in the Nodes tab first.';
            await this.service.render();
            return null;
        }
        if (activeRelayServerCount > 0 && !configValid) {
            this.relayMessage = 'Each DHCP group can have only one Authority relay server.';
            await this.service.render();
            return null;
        }
        if (activeRelayServerCount > 0 && computingNodes.some((node: any) => !node.cluster_relay_id)) {
            this.relayMessage = 'Assign every computing node to a relay server first.';
            await this.service.render();
            return null;
        }

        const payload = this.buildClusterRelayPayload();
        if (allowEmpty && !this.relayCreatedId && payload.clear_cluster_node_config) {
            if (this.item) this.item.relay_group = { ...payload, id: '' };
            await this.service.render();
            return 'cleared';
        }
        this.relayConfigSaving = true;
        await this.service.render();
        if (this.relayCreatedId) {
            const { code, data } = await this.relayApi("update", {
                id: this.relayCreatedId,
                data: JSON.stringify(payload)
            });
            this.relayConfigSaving = false;
            if (code === 200) {
                if (this.item) this.item.relay_group = { ...(this.item.relay_group || {}), ...payload, id: this.relayCreatedId };
                if (showAlert) this.relayMessage = 'Relay group saved.';
                await this.service.render();
                return this.relayCreatedId;
            }

            this.relayMessage = data?.message || 'Failed to update relay group.';
            await this.service.render();
            return null;
        }

        const { code, data } = await this.relayApi("create", { data: JSON.stringify(payload) });
        this.relayConfigSaving = false;
        if (code === 200 && data?.id) {
            this.relayCreatedId = data.id;
            if (this.item) this.item.relay_group = { ...payload, id: data.id };
            if (showAlert) this.relayMessage = 'Relay group saved.';
            await this.service.render();
            return this.relayCreatedId;
        }

        this.relayMessage = data?.message || 'Failed to create relay group.';
        await this.service.render();
        return null;
    }

    public async saveClusterRelayGroup() {
        await this.ensureClusterRelayGroupSaved(true);
        await this.service.render();
    }

    private setRelayPreflightReport(report: any) {
        this.relayPreflightReport = report;
        this.relayPreflightCollapsed = {};
        for (const section of this.relayPreflightSections()) {
            this.relayPreflightCollapsed[section.key] = true;
        }
    }

    public async runRelayPreflight(shouldRender: boolean = true) {
        if (!this.relayForm.relay_image_id || !this.relayForm.computing_image_id) {
            this.relayMessage = 'Select relay and computing images first.';
            if (shouldRender) await this.service.render();
            return;
        }
        if (this.relayDeployServerNodes().length === 0) {
            this.relayMessage = 'Check at least one relay server to work on.';
            if (shouldRender) await this.service.render();
            return;
        }
        if (this.relayDeployComputingNodes().length === 0) {
            this.relayMessage = 'Select at least one computing node to work on.';
            if (shouldRender) await this.service.render();
            return;
        }

        this.relayPreflightLoading = true;
        this.relayMessage = '';
        if (shouldRender) await this.service.render();

        const request = this.relayApi("preflight", { data: JSON.stringify(this.buildClusterRelayRequestPayload()) });
        const timeout = new Promise(resolve => setTimeout(() => resolve({
            code: 408,
            data: { message: 'Relay preflight timed out.' }
        }), 45000));
        const { code, data }: any = await Promise.race([request, timeout]);
        this.relayPreflightLoading = false;
        if (code === 200) {
            this.setRelayPreflightReport(data);
        } else {
            this.setRelayPreflightReport(data?.report || {
                ok: false,
                checked_at: new Date().toISOString(),
                verdict: 'fail',
                deploy_message: data?.message || 'Relay preflight failed.',
                summary: { ok_count: 0, warning_count: 0, error_count: 1 },
                environment: [{ name: 'Preflight API', status: 'error', checks: [{ status: 'error', title: 'Preflight failed', detail: data?.message || 'Unknown error' }] }],
                subnets: [],
                relay_servers: [],
                computing_nodes: []
            });
        }
        if (!this.relayPreflightForceable()) this.relayAllowOverride = false;
        if (shouldRender) await this.service.render();
    }

    public relayPreflightReady(): boolean {
        return !!this.relayPreflightReport?.ok;
    }

    public relayPreflightForceable(): boolean {
        return !!this.relayPreflightReport?.force_allowed && !(this.relayPreflightReport?.hard_error_count > 0);
    }

    public relayOverrideRequested(): boolean {
        return !this.relayPreflightReady() && this.relayPreflightForceable() && this.relayAllowOverride;
    }

    private relayOrchestrationInProgressStatus(status: any): boolean {
        return ['pending', 'running'].includes(this.relayNormalizedStatus(status));
    }

    public relayClusterDeployInProgress(): boolean {
        const jobStatus = this.relayNormalizedStatus(this.relayOrchestrationJob?.status);
        if (this.relayDeployStarting || this.relayOrchestrationInProgressStatus(jobStatus)) return true;
        if (!this.relayDeployStarted || this.relayDeployCompleted) return false;
        return !['completed', 'failed', 'cancelled', 'review-needed', 'error'].includes(jobStatus);
    }

    public relayCanDeployAll(): boolean {
        return !!this.relayForm.relay_image_id &&
            !!this.relayForm.computing_image_id &&
            this.relayDeployServerNodes().length > 0 &&
            this.relayDeployComputingNodes().length > 0 &&
            this.relayDeployConfigValid() &&
            !this.relayPreflightLoading &&
            !this.relayClusterDeployInProgress() &&
            (this.relayPreflightReady() || this.relayOverrideRequested());
    }

    public relayPreflightSections(): any[] {
        if (!this.relayPreflightReport) return [];
        return [
            { key: 'environment', title: 'Environment', items: this.relayPreflightReport.environment || [] },
            { key: 'subnets', title: 'Subnets', items: this.relayPreflightReport.subnets || [] },
            { key: 'relay_servers', title: 'Relay Servers', items: this.relayPreflightReport.relay_servers || [] },
            { key: 'computing_nodes', title: 'Computing Nodes', items: this.relayPreflightReport.computing_nodes || [] },
        ].filter((section: any) => section.items.length > 0);
    }

    public isRelayPreflightSectionCollapsed(key: string): boolean {
        return !!this.relayPreflightCollapsed[key];
    }

    public async toggleRelayPreflightSection(key: string) {
        this.relayPreflightCollapsed[key] = !this.relayPreflightCollapsed[key];
        await this.service.render();
    }

    public async startClusterRelayDeploy() {
        if (this.relayClusterDeployInProgress()) {
            this.relayMessage = 'Relay deploy is already in progress.';
            await this.service.render();
            return;
        }
        if (!this.relayForm.computing_image_id) {
            this.relayMessage = 'Select a computing image first.';
            await this.service.render();
            return;
        }
        if (this.relayDeployServerNodes().length === 0) {
            this.relayMessage = 'Check at least one relay server to work on.';
            await this.service.render();
            return;
        }
        if (!this.relayDeployConfigValid()) {
            this.relayMessage = 'Each DHCP group can have only one Authority relay server.';
            await this.service.render();
            return;
        }
        if (this.relayDeployComputingNodes().length === 0) {
            this.relayMessage = 'Cluster has no computing nodes to deploy.';
            await this.service.render();
            return;
        }
        if (!this.relayPreflightReady() && !this.relayOverrideRequested()) {
            await this.runRelayPreflight(false);
            if (!this.relayPreflightReady() && !this.relayOverrideRequested()) {
                this.relayMessage = this.relayPreflightForceable()
                    ? 'Preflight requires override before deployment.'
                    : 'Preflight failed. Resolve reported errors before deployment.';
                await this.service.render();
                return;
            }
        }

        const confirmMessage = this.relayOverrideRequested()
            ? 'Preflight override is enabled. Start relay orchestration for this cluster?'
            : 'Start relay orchestration for this cluster?';
        if (!confirm(confirmMessage)) return;

        this.relayDeployStarting = true;
        this.relayDeployStarted = true;
        this.relayDeployCompleted = false;
        this.relayMessage = '';
        await this.service.render();

        const groupId = await this.ensureClusterRelayGroupSaved(false, true);
        if (!groupId) {
            this.relayDeployStarting = false;
            this.relayDeployStarted = false;
            await this.service.render();
            return;
        }

        const payload = this.buildClusterRelayRequestPayload(groupId);
        const { code, data } = await this.relayApi("orchestration_start", { data: JSON.stringify(payload) });
        this.relayDeployStarting = false;
        if ((code === 200 || code === 409) && data?.job) {
            if (data?.group_id) this.relayCreatedId = data.group_id;
            this.relayOrchestrationJobId = data.job.id;
            this.syncRelayOrchestrationJob(data.job);
            if (this.relayOrchestrationInProgressStatus(data.job.status)) {
                this.startRelayJobPoll();
            }
            if (code === 409) this.relayMessage = data?.message || 'Relay orchestration is already running.';
        } else {
            this.relayDeployStarted = false;
            if (data?.report) this.setRelayPreflightReport(data.report);
            this.relayMessage = data?.message || 'Relay orchestration failed to start.';
        }
        await this.service.render();
    }

    private async syncRelayPersistedJob(shouldRender: boolean = true): Promise<boolean> {
        let result: any = null;
        if (this.relayCreatedId) {
            result = await this.relayApi("latest_orchestration", { group_id: this.relayCreatedId });
        } else if (this.relayOrchestrationJobId) {
            result = await this.relayApi("orchestration_status", { job_id: this.relayOrchestrationJobId });
        }
        if (result?.code === 200 && result.data?.job) {
            this.relayOrchestrationJobId = result.data.job.id || this.relayOrchestrationJobId;
            this.syncRelayOrchestrationJob(result.data.job);
            if (shouldRender) await this.service.render();
            return true;
        }
        return false;
    }

    private syncRelayOrchestrationJob(job: any) {
        this.relayOrchestrationJob = job;
        if (!job) return;

        this.relayDeployStarted = true;
        for (const relayServer of job.relay_servers || []) {
            const current = this.relayDeploymentStatus[relayServer.node_id] || {};
            this.relayDeploymentStatus[relayServer.node_id] = {
                imageDeployed: relayServer.status !== 'pending',
                ready: !!relayServer.ready,
                osReady: !!relayServer.ready,
                failed: relayServer.status === 'failed' || relayServer.status === 'error',
                status: relayServer.status,
                deployStatus: relayServer.deploy_status || '',
                deployStartedAt: relayServer.deploy_started_at || current.deployStartedAt || this.relayHeadDeployStartedAt,
                deployCompletedAt: relayServer.deploy_completed_at || current.deployCompletedAt || this.relayHeadDeployCompletedAt,
                deployElapsedSeconds: this.relayNumericSeconds(relayServer.deploy_elapsed_seconds || current.deployElapsedSeconds),
                deployDurationSeconds: this.relayNumericSeconds(relayServer.deploy_duration_seconds || current.deployDurationSeconds),
                readyWaitRemainingSeconds: this.relayNumericSeconds(relayServer.ready_wait_remaining_seconds || current.readyWaitRemainingSeconds),
                message: relayServer.message || ''
            };
            if (relayServer.power_state) this.applyRelayServerPowerState(relayServer.node_id, relayServer.power_state);
        }

        for (const computingNode of job.computing_nodes || []) {
            const status = computingNode.status === 'error' ? 'failed' : computingNode.status;
            this.relayNodeDeployStatus[computingNode.node_id] = {
                status,
                message: computingNode.message || ''
            };
            const localNode = this.clusterNodes.find((node: any) => String(node.id) === String(computingNode.node_id));
            if (localNode && computingNode.power_state) localNode.power_status = computingNode.power_state;
        }

        this.relayDeployCompleted = job.status === 'completed';
        this.updateRelayDeployStats();
    }

    private startRelayJobPoll() {
        if (this.relayJobPoller) clearInterval(this.relayJobPoller);
        this.relayJobPoller = setInterval(async () => {
            const synced = await this.syncRelayPersistedJob(false);
            if (synced && ['completed', 'failed'].includes(this.relayOrchestrationJob?.status)) {
                clearInterval(this.relayJobPoller);
                this.relayJobPoller = null;
            }
            await this.service.render();
        }, 10000);
    }

    public relayOrchestrationSteps(): any[] {
        return this.relayOrchestrationJob?.steps || [];
    }

    public relayOrchestrationDisplayStatus(): string {
        const controlState = String(this.relayOrchestrationJob?.control_state || '').toLowerCase();
        if (['paused', 'runner_error', 'stopped'].includes(controlState)) return controlState;
        return this.relayOrchestrationJob?.status || 'pending';
    }

    public relayCanPauseOrchestration(): boolean {
        return this.relayOrchestrationInProgressStatus(this.relayOrchestrationJob?.status)
            && this.relayOrchestrationDisplayStatus() === 'running'
            && !this.relayOrchestrationControlRunning;
    }

    public relayCanResumeOrchestration(): boolean {
        if (!this.relayOrchestrationInProgressStatus(this.relayOrchestrationJob?.status)) return false;
        const displayStatus = this.relayOrchestrationDisplayStatus();
        return ['paused', 'runner_error'].includes(displayStatus)
            || this.relayOrchestrationJob?.server_runner_enabled !== true;
    }

    public relayCanStopOrchestration(): boolean {
        return this.relayOrchestrationInProgressStatus(this.relayOrchestrationJob?.status)
            && this.relayOrchestrationDisplayStatus() !== 'stopped'
            && !this.relayOrchestrationControlRunning;
    }

    public relayOrchestrationRunnerLabel(): string {
        if (this.relayOrchestrationJob?.server_runner_enabled !== true) return 'server runner disabled';
        const runnerStatus = String(this.relayOrchestrationJob?.server_runner?.status || 'starting');
        const heartbeat = String(this.relayOrchestrationJob?.server_runner?.heartbeat_at || '');
        return heartbeat ? `server runner ${runnerStatus} · ${heartbeat}` : `server runner ${runnerStatus}`;
    }

    public async pauseRelayOrchestration() {
        if (!this.relayCanPauseOrchestration()) return;
        if (!confirm('Pause this orchestration after the current safe checkpoint? Already queued work may finish.')) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        this.relayOrchestrationControlRunning = true;
        await this.service.render();
        const { code, data } = await this.relayApi('orchestration_pause', { job_id: jobId, group_id: groupId });
        this.relayOrchestrationControlRunning = false;
        if (code === 200 && data?.job) {
            this.syncRelayOrchestrationJob(data.job);
            this.relayMessage = data?.message || 'Orchestration paused.';
        } else {
            this.relayMessage = data?.message || 'Failed to pause orchestration.';
        }
        await this.service.render();
    }

    public async resumeRelayOrchestration() {
        if (!this.relayCanResumeOrchestration() || this.relayOrchestrationControlRunning) return;
        if (!confirm('Resume this orchestration on the server?')) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        this.relayOrchestrationControlRunning = true;
        await this.service.render();
        const { code, data } = await this.relayApi('orchestration_resume', { job_id: jobId, group_id: groupId });
        this.relayOrchestrationControlRunning = false;
        if (code === 200 && data?.job) {
            this.syncRelayOrchestrationJob(data.job);
            this.relayMessage = data?.message || 'Orchestration resumed.';
            this.startRelayJobPoll();
        } else {
            this.relayMessage = data?.message || 'Failed to resume orchestration.';
        }
        await this.service.render();
    }

    public async stopRelayOrchestration() {
        if (!this.relayCanStopOrchestration()) return;
        if (!confirm('Stop this orchestration? Pending operations will be cancelled and the active step will fail.')) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        this.relayOrchestrationControlRunning = true;
        await this.service.render();
        const { code, data } = await this.relayApi('orchestration_stop', { job_id: jobId, group_id: groupId });
        this.relayOrchestrationControlRunning = false;
        if (data?.job) this.syncRelayOrchestrationJob(data.job);
        this.relayMessage = code === 200
            ? (data?.message || 'Orchestration stopped.')
            : (data?.message || 'Failed to stop orchestration.');
        if (code === 200 && this.relayJobPoller) {
            clearInterval(this.relayJobPoller);
            this.relayJobPoller = null;
        }
        await this.service.render();
    }

    public relayCanOpenOrchestrationLog(step: any): boolean {
        if (!step || step.key !== 'relay-script') return false;
        return !!step.status && step.status !== 'pending';
    }

    private currentRelayOrchestrationLogStep(): any {
        return (this.relayOrchestrationJob?.steps || []).find((step: any) => step.key === 'relay-script') || null;
    }

    private relayOrchestrationLogShouldOpenSummary(step: any): boolean {
        return step?.status === 'failed' || this.relayOrchestrationJob?.status === 'failed';
    }

    public async openRelayOrchestrationLog(step: any) {
        if (!this.relayCanOpenOrchestrationLog(step)) return;
        this.relayOrchestrationLogVisible = true;
        this.relayOrchestrationLogMeta = { ...(step || {}) };
        this.relayOrchestrationLogTab = this.relayOrchestrationLogShouldOpenSummary(step) ? 'summary' : 'script';
        this.relayOrchestrationIntegratedLogs = [];
        this.relayOrchestrationNodeLogs = [];
        this.relayOrchestrationSelectedNodeLog = null;
        this.relayOrchestrationFailureSummary = null;
        this.relayOrchestrationFailureActionMessage = '';
        this.relayOrchestrationLogTitle = step?.log_label || step?.title || 'Relay script log';
        this.relayOrchestrationLogFilename = step?.log_filename || '';
        this.relayOrchestrationLogMessage = this.relayOrchestrationLogTab === 'summary' ? 'Loading failure summary...' : 'Loading log...';
        if (!this.relayOrchestrationLogContent) this.relayOrchestrationLogContent = '';
        await this.loadRelayOrchestrationLogList(false);
        if (this.relayOrchestrationLogTab === 'summary') {
            await this.loadRelayOrchestrationFailureSummary(false);
        } else {
            await this.refreshRelayOrchestrationLog(false);
        }
        if (this.currentRelayOrchestrationLogStep()?.status === 'in_progress') {
            this.startRelayOrchestrationLogPoll();
        }
        await this.service.render();
    }

    private relayOrchestrationLogContext(): any {
        return {
            jobId: this.relayOrchestrationJob?.id || this.relayOrchestrationJobId || '',
            groupId: this.relayOrchestrationJob?.group_id || this.relayCreatedId || ''
        };
    }

    public async loadRelayOrchestrationLogList(shouldRender: boolean = true) {
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        if (!jobId && !groupId) return;
        const { code, data } = await this.relayApi("orchestration_logs", {
            job_id: jobId,
            group_id: groupId
        });
        if (code === 200) {
            this.relayOrchestrationIntegratedLogs = data?.integrated_logs || [];
            this.relayOrchestrationNodeLogs = data?.individual_logs || [];
            const selectedFilename = this.relayOrchestrationSelectedNodeLog?.filename || '';
            this.relayOrchestrationSelectedNodeLog = this.relayOrchestrationNodeLogs.find((log: any) => log.filename === selectedFilename) || this.relayOrchestrationNodeLogs[0] || null;
            if (!this.relayOrchestrationLogFilename && data?.script_log_filename) {
                this.relayOrchestrationLogFilename = data.script_log_filename;
            }
        }
        if (shouldRender) await this.service.render();
    }

    public async loadRelayOrchestrationFailureSummary(shouldRender: boolean = true) {
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        if (!jobId && !groupId) return;

        this.relayOrchestrationLogLoading = true;
        const { code, data } = await this.relayApi("orchestration_failure_summary", {
            job_id: jobId,
            group_id: groupId
        });
        this.relayOrchestrationLogLoading = false;

        if (code === 200) {
            this.relayOrchestrationFailureSummary = data?.summary || null;
            if (data?.job) this.syncRelayOrchestrationJob(data.job);
            this.relayOrchestrationLogMessage = this.relayOrchestrationFailureSummary?.step_message || '';
        } else {
            this.relayOrchestrationFailureSummary = null;
            this.relayOrchestrationLogMessage = data?.message || 'Failed to load failure summary.';
        }
        if (shouldRender) await this.service.render();
    }

    public async selectRelayOrchestrationLogTab(tab: string) {
        this.relayOrchestrationLogTab = tab;
        this.relayOrchestrationLogContent = '';
        this.relayOrchestrationLogMessage = tab === 'summary' ? 'Loading failure summary...' : (tab === 'nodes' ? 'Loading node log...' : 'Loading log...');
        if (tab === 'summary') {
            await this.loadRelayOrchestrationFailureSummary(false);
            await this.service.render();
            return;
        }
        if (tab === 'nodes') {
            await this.loadRelayOrchestrationLogList(false);
        }
        await this.refreshRelayOrchestrationLog(false);
        await this.service.render();
    }

    public async selectRelayOrchestrationNodeLog(log: any) {
        this.relayOrchestrationSelectedNodeLog = log;
        this.relayOrchestrationLogContent = '';
        this.relayOrchestrationLogMessage = 'Loading node log...';
        await this.refreshRelayOrchestrationLog(false);
        await this.service.render();
    }

    public async refreshRelayOrchestrationLog(shouldRender: boolean = true) {
        if (!this.relayOrchestrationLogVisible) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        if (!jobId && !groupId) {
            this.relayOrchestrationLogMessage = 'Relay orchestration job is not available.';
            if (shouldRender) await this.service.render();
            return;
        }

        if (this.relayOrchestrationLogTab === 'summary') {
            await this.loadRelayOrchestrationFailureSummary(shouldRender);
            return;
        }

        this.relayOrchestrationLogLoading = true;
        if (this.relayOrchestrationLogTab === 'nodes') {
            await this.loadRelayOrchestrationLogList(false);
        }
        const filename = this.relayOrchestrationLogTab === 'nodes'
            ? (this.relayOrchestrationSelectedNodeLog?.filename || '')
            : (this.relayOrchestrationLogFilename || this.relayOrchestrationLogMeta?.log_filename || '');
        if (this.relayOrchestrationLogTab === 'nodes' && !filename) {
            this.relayOrchestrationLogLoading = false;
            this.relayOrchestrationLogContent = '';
            this.relayOrchestrationLogMessage = 'No individual node logs found yet.';
            if (shouldRender) await this.service.render();
            return;
        }
        const { code, data } = await this.relayApi("orchestration_log_content", {
            job_id: jobId,
            group_id: groupId,
            step_key: 'relay-script',
            filename
        });
        this.relayOrchestrationLogLoading = false;

        if (code === 200) {
            this.relayOrchestrationLogContent = data?.content || '';
            if (this.relayOrchestrationLogTab === 'script') {
                this.relayOrchestrationLogFilename = data?.filename || this.relayOrchestrationLogFilename;
            }
            this.relayOrchestrationLogMessage = data?.message || '';
            const currentStep = this.currentRelayOrchestrationLogStep();
            if (currentStep && data?.step_status) {
                currentStep.status = data.step_status;
                currentStep.message = data.message || currentStep.message;
            }
            if (data?.running) this.startRelayOrchestrationLogPoll();
            else this.stopRelayOrchestrationLogPoll();
        } else {
            this.relayOrchestrationLogMessage = data?.message || 'Failed to load relay script log.';
            const currentStep = this.currentRelayOrchestrationLogStep();
            if (currentStep?.status !== 'in_progress') this.stopRelayOrchestrationLogPoll();
        }

        if (shouldRender) await this.service.render();
    }

    public async runRelayOrchestrationRecoveryCheck() {
        if (this.relayOrchestrationRecoveryRunning) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        if (!jobId && !groupId) return;

        this.relayOrchestrationRecoveryRunning = true;
        this.relayOrchestrationFailureActionMessage = 'Running recovery check...';
        await this.service.render();

        const { code, data } = await this.relayApi("orchestration_recovery_check", {
            job_id: jobId,
            group_id: groupId
        });
        this.relayOrchestrationRecoveryRunning = false;
        if (code === 200) {
            this.relayOrchestrationFailureSummary = data?.summary || this.relayOrchestrationFailureSummary;
            if (data?.job) this.syncRelayOrchestrationJob(data.job);
            this.relayOrchestrationFailureActionMessage = data?.recovery_result?.message || 'Recovery check completed.';
        } else {
            this.relayOrchestrationFailureActionMessage = data?.message || 'Recovery check failed.';
        }
        await this.service.render();
    }

    public async stopRelayOrchestrationScript() {
        if (this.relayOrchestrationStopRunning) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        if (!jobId && !groupId) return;
        if (!confirm('Stop the running relay script?')) return;

        this.relayOrchestrationStopRunning = true;
        this.relayOrchestrationFailureActionMessage = 'Stopping relay script...';
        await this.service.render();

        const { code, data } = await this.relayApi("orchestration_stop", {
            job_id: jobId,
            group_id: groupId
        });
        this.relayOrchestrationStopRunning = false;
        if (code === 200) {
            this.relayOrchestrationFailureSummary = data?.summary || this.relayOrchestrationFailureSummary;
            if (data?.job) this.syncRelayOrchestrationJob(data.job);
            this.relayOrchestrationFailureActionMessage = data?.message || 'Relay script stopped.';
            this.stopRelayOrchestrationLogPoll();
            await this.loadRelayOrchestrationFailureSummary(false);
        } else {
            this.relayOrchestrationFailureActionMessage = data?.message || 'Relay script stop failed.';
        }
        await this.service.render();
    }

    public async rerunRelayOrchestrationFromLog() {
        if (this.relayOrchestrationRerunRunning) return;
        const { jobId, groupId } = this.relayOrchestrationLogContext();
        if (!jobId && !groupId) return;
        if (!confirm('Rerun this failed relay orchestration job?')) return;

        this.relayOrchestrationRerunRunning = true;
        this.relayOrchestrationFailureActionMessage = 'Starting rerun...';
        await this.service.render();

        const { code, data } = await this.relayApi("orchestration_rerun", {
            job_id: jobId,
            group_id: groupId
        });
        this.relayOrchestrationRerunRunning = false;
        if (code === 200 && data?.job) {
            this.relayOrchestrationJobId = data.job.id;
            this.syncRelayOrchestrationJob(data.job);
            this.relayOrchestrationFailureActionMessage = 'Rerun started.';
            this.relayOrchestrationFailureSummary = null;
            this.relayOrchestrationLogTab = 'script';
            this.relayOrchestrationLogContent = '';
            this.relayOrchestrationLogFilename = data.job?.steps?.find((step: any) => step.key === 'relay-script')?.log_filename || '';
            await this.loadRelayOrchestrationLogList(false);
            await this.refreshRelayOrchestrationLog(false);
            if (this.relayOrchestrationInProgressStatus(data.job.status)) {
                this.startRelayJobPoll();
                this.startRelayOrchestrationLogPoll();
            }
        } else {
            if (data?.report) this.setRelayPreflightReport(data.report);
            this.relayOrchestrationFailureActionMessage = data?.message || 'Rerun failed to start.';
        }
        await this.service.render();
    }

    private startRelayOrchestrationLogPoll() {
        if (this.relayOrchestrationLogPoller) return;
        this.relayOrchestrationLogPoller = setInterval(async () => {
            await this.refreshRelayOrchestrationLog();
        }, 3000);
    }

    private stopRelayOrchestrationLogPoll() {
        if (!this.relayOrchestrationLogPoller) return;
        clearInterval(this.relayOrchestrationLogPoller);
        this.relayOrchestrationLogPoller = null;
    }

    public async closeRelayOrchestrationLog() {
        this.stopRelayOrchestrationLogPoll();
        this.relayOrchestrationLogVisible = false;
        this.relayOrchestrationLogLoading = false;
        this.relayOrchestrationLogTitle = '';
        this.relayOrchestrationLogFilename = '';
        this.relayOrchestrationLogContent = '';
        this.relayOrchestrationLogMessage = '';
        this.relayOrchestrationLogMeta = null;
        this.relayOrchestrationLogTab = 'script';
        this.relayOrchestrationIntegratedLogs = [];
        this.relayOrchestrationNodeLogs = [];
        this.relayOrchestrationSelectedNodeLog = null;
        this.relayOrchestrationFailureSummary = null;
        this.relayOrchestrationFailureActionMessage = '';
        this.relayOrchestrationRecoveryRunning = false;
        this.relayOrchestrationRerunRunning = false;
        this.relayOrchestrationStopRunning = false;
        await this.service.render();
    }

    public updateRelayDeployStats() {
        const stats = { total: 0, deployed: 0, in_progress: 0, failed: 0 };
        const targetNodeIds = this.relayDeployHasTarget()
            ? new Set(this.relayDeployComputingNodes().map((node: any) => String(node.id)))
            : null;
        for (const nodeId of Object.keys(this.relayNodeDeployStatus)) {
            if (targetNodeIds && !targetNodeIds.has(String(nodeId))) continue;
            stats.total++;
            const status = this.relayNodeDeployStatus[nodeId]?.status;
            if (status === 'deployed' || status === 'ready') stats.deployed++;
            else if (status === 'deploying' || status === 'pending') stats.in_progress++;
            else if (status === 'failed' || status === 'error') stats.failed++;
        }
        this.relayDeployStats = stats;
    }

    public async powerOnRelayWorkers() {
        const nodeIds = this.clusterRelayWorkerNodes().map((node: any) => node.id);
        if (nodeIds.length === 0) return;
        this.relayPoweringOn = true;
        await this.service.render();
        await this.relayApi("power_on_all", { data: JSON.stringify({ node_ids: nodeIds }) });
        this.clusterRelayWorkerNodes().forEach((node: any) => { node.power_status = 'on'; });
        this.relayPoweringOn = false;
        await this.service.render();
    }

    public async powerOffRelayWorkers() {
        const nodeIds = this.clusterRelayWorkerNodes().map((node: any) => node.id);
        if (nodeIds.length === 0) return;
        this.relayPoweringOff = true;
        await this.service.render();
        await this.relayApi("power_off_all", { data: JSON.stringify({ node_ids: nodeIds }) });
        this.clusterRelayWorkerNodes().forEach((node: any) => { node.power_status = 'off'; });
        this.relayPoweringOff = false;
        await this.service.render();
    }

    public async powerRelayWorker(nodeId: number, action: string) {
        await this.relayApi("power_node", { node_id: nodeId, action });
        const node = this.clusterNodes.find((item: any) => Number(item.id) === Number(nodeId));
        if (node) node.power_status = action;
        await this.service.render();
    }

    // =========================================================================
    // Storage 관리
    // =========================================================================

    public async loadStorages() {
        const { code, data } = await wiz.call("storages", { id: this.id });
        if (code === 200) {
            this.storageList = data;
        }
    }

    public addStorage() {
        this.editingStorage = {
            name: '', type: 'nfs', server: '', path: '',
            mount_point: '', size: 0, options: '', status: 'active'
        };
    }

    public editStorage(stor: any) {
        this.editingStorage = { ...stor };
    }

    public cancelStorage() {
        this.editingStorage = null;
    }

    public async saveStorage() {
        if (!this.editingStorage) return;
        const { code } = await wiz.call("storage_save", {
            id: this.id, data: JSON.stringify(this.editingStorage)
        });
        if (code === 200) {
            this.editingStorage = null;
            await this.loadStorages();
        }
        await this.service.render();
    }

    public async deleteStorage(stor: any) {
        if (!confirm(this.translate.instant('page.clusters.item.confirm_delete_storage', { name: stor.name }))) return;
        const { code } = await wiz.call("storage_delete", { id: this.id, stor_id: stor.id });
        if (code === 200) {
            await this.loadStorages();
        }
        await this.service.render();
    }

    public formatSize(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let i = 0;
        let size = bytes;
        while (size >= 1024 && i < units.length - 1) {
            size /= 1024;
            i++;
        }
        return `${size.toFixed(1)} ${units[i]}`;
    }
    public canManageResourceUsers() { return ['admin', 'superadmin'].includes(String(this.service.auth.session?.role || '').toLowerCase()); }
}

export default PageKieraClustersItemComponent;
